 


 const staticData = {
    "data": {
        "overall_data": {
            "university": "Edith Cowan University",
            "teacher_name": "Shuchi Dhir",
            "student_name": "Isaac PANG",
            "total_classrooms": 3,
            "units": {
                "total_units": 1,
                "unit_name": "Scripting Languages",
                "display_code": "CYB6004",
                "created_at": "2023-01-09 04:38:05.952340"
            },
            "total_calls": 31,
            "total_sms": 47,
            "total_mails": 48
        },
        "conversation_data": {
            "audio": [
    {
      "file_name": "a5dce338-742c-4089-90cc-d3d30e3a1639.wav",
      "file_url": "https://admin.lincfellow.com/v1/api/recordings/135015/a5dce338-742c-4089-90cc-d3d30e3a1639.wav",
      "duration": 576,
      "transcription": [
        {
          "speaker": "(0.01s - 0.02s) Isaac PANG",
          "line": "Hello?"
        },
        {
          "speaker": "(0.03s - 0.05s) Suchi Dhir",
          "line": "Hi, can you hear me?"
        },
        {
          "speaker": "(0.05s - 0.08s) Isaac PANG",
          "line": "Hi. Yeah, can you hear me?"
        },
        {
          "speaker": "(0.08s - 0.59s) Suchi Dhir",
          "line": "Yes, I can. So I was saying that, you know, there are two, three things that you can do from here if you want to go with the simplest approach. That would be like, you know, you can have a query like display the total number of vulnerabilities in the year 2000 920 ten. And you can have if then else statements and simple grep or set statements. And you can simply, you know, fetch the information about the number of, total number of vulnerabilities and display that."
        },
        {
          "speaker": "(0.62s - 0.63s) Isaac PANG",
          "line": "Yeah."
        },
        {
          "speaker": "(0.63s - 2.19s) Suchi Dhir",
          "line": "Okay. That is a simple way. Like, you know, you can have multiple queries on number of vulnerabilities or type of vulnerabilities which were there. Okay, that is one way. Another way is to use, you know, now you have a file ready. You know how to read a file, read a file using while loop, while read line, read each individual line. And then you write your code where you are checking for, you know, you can see that now in your text you have the sections like number of vulnerabilities, D OS code execution. You have all those sections so you can, you know, have those as read variables. Some, you know, define for example, number of vulnerabilities, DOS code execution. All these can be the predefined variables in your script. You read the line and whatever value comes because they are one after another in your, in your text. Whatever you have cleaned, the information is there one after another in each next line, next line, next line. So you can read from, you know, read line function each line and I store the value below those variables, right. And you can, and you know, you can generate a maybe CSV table first common comma separated values. And once your temporary table is ready, then you can write an Aux script and you can read that from, from that table, right?"
        },
        {
          "speaker": "(2.19s - 2.2s) Isaac PANG",
          "line": "Okay."
        },
        {
          "speaker": "(2.2s - 2.96s) Suchi Dhir",
          "line": "Rather than just, rather than just directly writing octable, if you're not finding it comfortable, this is the easier way you can do that. Now, for your CSV table, you have the, you know, what are the headings? You know, you have year, number of vulnerabilities, dos code. So all those can be your variables. Yeah, all those can be the variables. And the values are something that you are picking from the text that you have created. So you write a statement like while read line function, read each line, pick up the values that you get and just store it below the particular variable. And that's how you can create a CSV file. And when that is done, then things will be very easy. You can easily read awk table from there, right?"
        },
        {
          "speaker": "(2.97s - 3.11s) Isaac PANG",
          "line": "Okay. Sure. Okay, I'll do that. That sounds good. And then once I've got. Yes, sir."
        },
        {
          "speaker": "(3.11s - 3.17s) Suchi Dhir",
          "line": "Because I'm quite satisfied with the table, the text table that you have got now."
        },
        {
          "speaker": "(3.19s - 3.22s) Isaac PANG",
          "line": "Yeah, the text is good. Is it now?"
        },
        {
          "speaker": "(3.23s - 3.74s) Suchi Dhir",
          "line": "Yes, that is good enough. Now you can have, you can read the line. Now you have to write the logic of your code and read line. And you know, you can have conditionals depending upon the values which are there in the text. So initially, anything, you have to just write the conditions accordingly. Check the text table correctly and write the if then else conditions while loop. What you have to discard and what you have. What information do you need accordingly, you will have to write frame your conditions."
        },
        {
          "speaker": "(3.76s - 3.95s) Isaac PANG",
          "line": "Right. So you, um, is this, is this all to just put it into one big table or is this for like the user if they were to select one of the vulnerabilities?"
        },
        {
          "speaker": "(3.95s - 4.34s) Suchi Dhir",
          "line": "This is, this is, so there are two things that you can do effect. Now you have two things. First part, there are two parts. Either you choose path one or choose path two. First part that you just write the queries and like, let's say total number of memory corruption vulnerabilities in year 2009. Okay?"
        },
        {
          "speaker": "(4.34s - 4.35s) Isaac PANG",
          "line": "Yeah."
        },
        {
          "speaker": "(4.35s - 4.92s) Suchi Dhir",
          "line": "And then you just pick up those values using some crepe commands or set commands and show it to the user from the table. That's one option. You have multiple if then else you know statements. So if user has selected year 2009, if user has selected number of vulnerabilities or d us accordingly, you just grab said and you display the values. That's it. Okay, so that's, that is one part where you don't have a table. You're not displaying output in the form of table. You are, you have just queries and you are displaying the answer of the queries to the user."
        },
        {
          "speaker": "(4.93s - 4.95s) Isaac PANG",
          "line": "Yeah."
        },
        {
          "speaker": "(4.95s - 5.19s) Suchi Dhir",
          "line": "And if you want, in this, if you want to, because this is a very simple script, a very, very simple and easy path. So if you want, you can also have, you know, plot the information in the form of chart."
        },
        {
          "speaker": "(5.2s - 5.23s) Isaac PANG",
          "line": "Yeah, I was planning on doing that."
        },
        {
          "speaker": "(5.26s - 6.07s) Suchi Dhir",
          "line": "Yeah. By the year, for example, by year 2009, you pick up all information and just put it in the form of chart because you have all the variables defined. Number of vulnerabilities, DOS code execution, overflow, memory corruption, all these are variables that you can define in your code and values you can pick up from the text. Now, what you have, this is part one, part two. Part two is that you read the file which you have line by line. Write a code in a form that you know. It discards anything which is useless. And useful information like starting from number of vulnerabilities, you pick what value is given the first value, put it below number of vulnerabilities. Second value, put it below Dus because that's how it is given in your text."
        },
        {
          "speaker": "(6.08s - 6.68s) Isaac PANG",
          "line": "In my text file though, it's kind of like if I just pull up, it's got all of the vulnerabilities first, like, like going down, and then it has year and then it has the numbers after the, it doesn't have like for instance, it doesn't have after Di, like denial of service, it doesn't have like how many. It's kind of like they're not next to each other, if you know what I mean."
        },
        {
          "speaker": "(6.69s - 6.94s) Suchi Dhir",
          "line": "No, they are. I was looking into your text file. It was like it's not next to each other but it's in the next line. Five, three. Next line, three. Then there are some blank spaces and then afterwards there is one so present like that."
        },
        {
          "speaker": "(6.95s - 6.98s) Isaac PANG",
          "line": "Okay. Okay."
        },
        {
          "speaker": "(6.99s - 7.2s) Suchi Dhir",
          "line": "Or if you do not, yeah. You know, if you do not want to pick up detailed information, if you just want to pick up number of vulnerabilities, you can only pick up the first column and leave the rest of the values."
        },
        {
          "speaker": "(7.23s - 7.27s) Isaac PANG",
          "line": "Yeah. The last column I think total is."
        },
        {
          "speaker": "(7.27s - 7.35s) Suchi Dhir",
          "line": "In the first one. The total number of vulnerabilities."
        },
        {
          "speaker": "(7.35s - 7.38s) Isaac PANG",
          "line": "Oh, total number."
        },
        {
          "speaker": "(7.39s - 7.77s) Suchi Dhir",
          "line": "It's 2009. And the next line, it gives the total number of vulnerabilities. If you want, you can also, I mean, you have to set, you have to read, you have to look into your file and you have to decode it completely. See what I can help you because I will not be able to assist you in writing your code. I can obviously guide you what you have to do. Otherwise, if you want, I can share an example script with you."
        },
        {
          "speaker": "(7.77s - 7.83s) Isaac PANG",
          "line": "Yeah, an example, yeah."
        },
        {
          "speaker": "(7.86s - 8.15s) Suchi Dhir",
          "line": "I will share some examples with you. You can just go through them and accordingly you can, you know, you can work and you can decide. Two, three examples I'll share with you so that you have an idea. Okay. This is how I can take it up. Or, you know, in different ways. I'll do that. Exactly."
        },
        {
          "speaker": "(8.16s - 8.33s) Isaac PANG",
          "line": "Okay. That would be good. Yeah. Because I'm trying to aim to finish it by the end of this week. So I have time to kind of finalize, you know, make finishing touches and make it good."
        },
        {
          "speaker": "(8.36s - 8.57s) Suchi Dhir",
          "line": "Okay, understood. Okay. So I will, yeah, I will definitely share this with you. I'll just try to, is it possible to download this table completely? Did you try that?"
        },
        {
          "speaker": "(8.58s - 8.61s) Isaac PANG",
          "line": "You mean just the table?"
        },
        {
          "speaker": "(8.61s - 8.63s) Suchi Dhir",
          "line": "Yes."
        },
        {
          "speaker": "(8.64s - 8.74s) Isaac PANG",
          "line": "I don't think you can. You mean from the HTML code?"
        },
        {
          "speaker": "(8.76s - 9.05s) Suchi Dhir",
          "line": "Yes. From the code or first you try to do it from the webpage itself. Is it possible to download the table? Because there are some websites from where it is possible to download the tables also directly."
        },
        {
          "speaker": "(9.05s - 9.18s) Isaac PANG",
          "line": "Yeah, I don't. I had a look, actually, but I don't recall seeing anything about downloading the table. I can have a quick. Not a look."
        },
        {
          "speaker": "(9.19s - 9.4s) Suchi Dhir",
          "line": "Okay. So in case, if you're able to. Because see, you are reading from a table. Reading from a table is different, difficult. If you have information on a webpage and you put that information in a."
        },
        {
          "speaker": "(9.47s - 9.47s) Isaac PANG",
          "line": "Hello."
        }
      ],
      "date": "2023-02-16 09:35:58.353234Z"
    },
    {
      "file_name": "9ebcc121-f74e-435f-9dd7-ff311b3dba14.wav",
      "file_url": "https://admin.lincfellow.com/v1/api/recordings/135016/9ebcc121-f74e-435f-9dd7-ff311b3dba14.wav",
      "duration": 154,
      "transcription": [
        {
          "speaker": "(0.02s - 0.07s) Isaac PANG",
          "line": "Hello? Hello?"
        },
        {
          "speaker": "(0.07s - 0.29s) Suchi Dhir",
          "line": "Yeah. Yeah. Sorry for that, Isaac. So, yeah, so just try, you know, if there is a possibility of downloading it as a table completely. Otherwise, I'm just looking."
        },
        {
          "speaker": "(0.29s - 0.31s) Isaac PANG",
          "line": "I don't think you can."
        },
        {
          "speaker": "(0.33s - 0.8s) Suchi Dhir",
          "line": "Okay. We need to read the HTML file first, you know, because generally a table has to be inside special tags. So if those tags can be interpreted. I need to look into an HTML file. Not getting sufficient time, but okay. Today also, I have calls. I just wanted you to look into the HTML file that you download and just see."
        },
        {
          "speaker": "(0.8s - 0.82s) Isaac PANG",
          "line": "I've got the HTML file here."
        },
        {
          "speaker": "(0.82s - 1.29s) Suchi Dhir",
          "line": "Yes. Go through it completely and see whether this table is defined by any specific tags. So, before you remove HTML tags, if you can identify the table, you know, so just retain the information inside those tags. The table and rest of the information should be deleted from your. From your site, from the HTML page. Because table will be defined in specific HTML tags only."
        },
        {
          "speaker": "(1.31s - 1.37s) Isaac PANG",
          "line": "Right. I can see some. Some table tags."
        },
        {
          "speaker": "(1.38s - 1.8s) Suchi Dhir",
          "line": "Yes, table tags. So those tags you should not delete and you should delete all the other tags. And once your table tags is retained, then you have to process it accordingly. Once your table is there. So leaving table tags, rest all the HTML tags. If you can clean, that should be a good way to. Then you will be able to retain the spaces, the blanks properly."
        },
        {
          "speaker": "(1.8s - 2.43s) Isaac PANG",
          "line": "And then I've kept the spaces in the blanks. Just the table tags aren't there anymore. Hello? Hello."
        }
      ],
      "date": "2023-02-16T09:46:19.871976Z"
    },
    {
      "file_name": "63a7d37d-5198-481c-9a37-5437ebf86162.wav",
      "file_url": "https://admin.lincfellow.com/v1/api/recordings/135018/63a7d37d-5198-481c-9a37-5437ebf86162.wav",
      "duration": 271,
      "transcription": [
        {
          "speaker": "(0.03s - 0.96s) Suchi Dhir",
          "line": "Hello, I'm very sorry for this. My app is actually hanging from, you know, the app which I'm calling, I need to clean it, I'm not getting time. I need to clean all the cookies and all. Yeah, that's why this, because it's a voice call coming through this app. It is, you know, it gets, it's happening with most of the students. I'm not able to speak continuously. I'll do that today. So, yeah, I, I was saying that, you know, then the best way is to create a CSV file, and then from the CSV file create your, you know, use octave to display the table. That's the best way. I think you should start immediately writing the code for reading the lines from the text and try to convert it into a CSV file, a comma separated table, you know, simple table. And then it would be easier for you to write the or command, like how you have done in week five, you have etc password."
        },
        {
          "speaker": "(0.96s - 1.04s) Isaac PANG",
          "line": "I know you said it was a bit difficult to write it straight from the data that I've got right now."
        },
        {
          "speaker": "(1.05s - 1.24s) Suchi Dhir",
          "line": "Yeah, you need to have good knowledge of awk and it's not possible to, you know, spend that much time to work on it. Yeah, it's completely unstructured data, it's not a structured."
        },
        {
          "speaker": "(1.24s - 1.4s) Isaac PANG",
          "line": "Exactly. So if I convert it to a comma separated file, CSV file first, then it will be easier to work, sir."
        },
        {
          "speaker": "(1.4s - 2.01s) Suchi Dhir",
          "line": "Then it would be easier. You have all the variables defined. You have to just ensure that each line when you are reading for each year 2009, because I saw that in your table, all the values are there, 2009 and rest all the values are there line next. So keep on reading the line and it should pick up the values from the text and then put it inside the comma separated values below that. So below the number of vulnerabilities, number of year 2009, number of vulnerabilities. And like that, it keeps on populating the table. And once that is done, then the next one will be awk, simply displaying the table."
        },
        {
          "speaker": "(2.02s - 2.11s) Isaac PANG",
          "line": "Yes. Okay, sure. All right, I'll aim to do that."
        },
        {
          "speaker": "(2.11s - 2.65s) Suchi Dhir",
          "line": "Yeah. So please move in that, you know, direction and let me know how it goes. You can connect to me, I will be sharing anyhow some examples. I have a lot of troubleshooting, you know, calls, so I'll do, that's what I was thinking that, you know, let me share some examples with all of you, because it's not only you. Many students are getting stuck in understanding how to clean and how to use awk. Now we cannot individual projects not possible so I'll share three examples. Three or four examples with you."
        },
        {
          "speaker": "(2.66s - 2.78s) Isaac PANG",
          "line": "Yeah, just send those to me and I should be able to. I reckon I'll be able to figure out myself if I have an example to go off."
        },
        {
          "speaker": "(2.79s - 2.84s) Suchi Dhir",
          "line": "Sure. I'll be. Yeah, give me some time. I'll do that."
        },
        {
          "speaker": "(2.84s - 2.87s) Isaac PANG",
          "line": "That's fine. Not a problem."
        },
        {
          "speaker": "(2.88s - 2.97s) Suchi Dhir",
          "line": "I have to do it by today, so that it should be. You should be able to use them also. I'll do that."
        },
        {
          "speaker": "(2.97s - 3.32s) Isaac PANG",
          "line": "Yeah. Cool. That's cool. Okay. That's great. I'll try and. Yeah, my goal is to finish well, at least like the first kind of draft of it by the end of the week. Have everything kind of working then. And then next week I'll probably work on some python to add a line graph or something similar."
        },
        {
          "speaker": "(3.33s - 3.38s) Suchi Dhir",
          "line": "Yeah, you can use python to add a graph."
        },
        {
          "speaker": "(3.39s - 3.42s) Isaac PANG",
          "line": "Yeah, something like that."
        },
        {
          "speaker": "(3.42s - 3.63s) Suchi Dhir",
          "line": "Okay, so let me share something with you and you work accordingly. As of now, please start working towards reading the lines of the table and try to convert it into comma separated values. One."
        },
        {
          "speaker": "(4.08s - 4.48s) Isaac PANG",
          "line": "Probably Sydney. You and Bradley and Jack and soft. Yeah, I need to count on that. Are your parents actually counting calories?"
        }
      ],
      "date": "2023-02-16T09:49:31.851923Z"
    },
    {
      "file_name": "e3af72fd-8560-47a2-a184-37a7b788c07d.wav",
      "file_url": "https://s3-ap-southeast-2.amazonaws.com/linc-recordings/e3af72fd-8560-47a2-a184-37a7b788c07d.wav",
      "duration": 360,
      "transcription": [
        {
          "speaker": "(0.04s - 0.05s) Isaac PANG",
          "line": "Hello."
        },
        {
          "speaker": "(0.05s - 0.09s) Suchi Dhir",
          "line": "Hi. Hi, Isaac. How are you doing?"
        },
        {
          "speaker": "(0.09s - 0.13s) Isaac PANG",
          "line": "Hi, I'm good, thank you. How are you?"
        },
        {
          "speaker": "(0.14s - 0.17s) Suchi Dhir",
          "line": "I'm doing great, Isaac."
        },
        {
          "speaker": "(0.18s - 0.2s) Isaac PANG",
          "line": "How was your progress?"
        },
        {
          "speaker": "(0.2s - 0.22s) Suchi Dhir",
          "line": "How was your progress?"
        },
        {
          "speaker": "(0.23s - 0.3s) Isaac PANG",
          "line": "Yeah, I just finished writing my report. Ten minutes here."
        },
        {
          "speaker": "(0.3s - 0.53s) Suchi Dhir",
          "line": "Okay. Okay. Okay. That's great. Please do share it with me. I'll go through it. And what is the username of your repository?"
        },
        {
          "speaker": "(0.56s - 0.73s) Isaac PANG",
          "line": "It's the Pangster 99. So let me, give me one sec. I'll text it to your number."
        },
        {
          "speaker": "(0.76s - 0.88s) Suchi Dhir",
          "line": "Yeah, I have that. I have opened it in front of me. I'm trying. Yes, I've got it."
        },
        {
          "speaker": "(0.9s - 1.26s) Isaac PANG",
          "line": "Oh yeah. The one problem I was having was submitting my week six repository through the Windows command terminal. It wouldn't let me do the git add and then all of that stuff because I finished all the week six work. I just can't seem to commit it to the."
        },
        {
          "speaker": "(1.31s - 1.36s) Suchi Dhir",
          "line": "Do you have any desk? Do you want me to connect with you?"
        },
        {
          "speaker": "(1.37s - 1.39s) Isaac PANG",
          "line": "Beg your pardon?"
        },
        {
          "speaker": "(1.41s - 1.55s) Suchi Dhir",
          "line": "Do you have any desk? If you want I can connect with your screen and assist you in pushing your work on the."
        },
        {
          "speaker": "(1.55s - 1.67s) Isaac PANG",
          "line": "Yeah, sure. I have, well, I have Microsoft Teams. I can get that or something."
        },
        {
          "speaker": "(1.69s - 1.9s) Suchi Dhir",
          "line": "Okay. If you want, you can call me on Microsoft Teams and share your screen from there. Just. We will be on mute on Microsoft Teams and we will continue our call here because this is recorded. So."
        },
        {
          "speaker": "(1.9s - 2.09s) Isaac PANG",
          "line": "Okay. Let me get up my team's thing and let me see if I can get it all working. Oh crap."
        },
        {
          "speaker": "(2.12s - 2.27s) Suchi Dhir",
          "line": "So I'm going through your work, which you have uploaded is Zach. And it's like there is. You didn't add comments to your work."
        },
        {
          "speaker": "(2.29s - 2.31s) Isaac PANG",
          "line": "What do you mean comment?"
        },
        {
          "speaker": "(2.34s - 2.69s) Suchi Dhir",
          "line": "I have shared an example text file. Examples script file. And I did mention that you have to add comments on the top of your code. And if you are using any function, the importance of it, please. In one line and at the end there should be, at the bottom there should be references. Did you go through that?"
        },
        {
          "speaker": "(2.7s - 2.79s) Isaac PANG",
          "line": "I haven't gone through that, no. But I can go through and make all those changes."
        },
        {
          "speaker": "(2.8s - 2.93s) Suchi Dhir",
          "line": "Yeah, please do make. I have shared an example script file and I also shared some tips to improve your code."
        },
        {
          "speaker": "(2.94s - 2.95s) Isaac PANG",
          "line": "Yeah."
        },
        {
          "speaker": "(2.95s - 5.17s) Suchi Dhir",
          "line": "So that also I think that you need to do little. You know, there is some work which you have to like. For example, if I see your week two script, you have not added any checks to your script. For example, checking whether secret txt file exists or not. And before you actually use it through cat command. And then also I don't know what is the correct password. So if I want to execute this and see whether your code is working or not, I access to correct password. So at least in comments you can add the correct password so that when we execute and enter the correct password, we are able to see the message access granted, some of the things. And wherever possible, wherever possible, please try to add a menu to your script. Okay, let's say for week five, let's say for week five useraccounts sh in that script you can add a menu where the first option will be to display contents of etc password file and the second option will be to display only the users with bin bash shell and the third option will be exit. So you know the script. If the flow of the script can be controlled by user, that kind of scripts are more robust as compared to the scripts which are controlled by the function, the logic which is there inside the script. So wherever possible, please add user menu and try to add as many checks as possible and print an error function. You can have error function in all the six scripts which we are going to grade you in. Portfolio activity, the assessment tree so all the six scripts from week one, one script, week two, week three, week four, all those scripts at least try to have an error function."
        },
        {
          "speaker": "(5.19s - 5.28s) Isaac PANG",
          "line": "The one that was, the ones that are like highlighted in green in the modules that have been graded."
        },
        {
          "speaker": "(5.28s - 5.69s) Suchi Dhir",
          "line": "Yes, yes. Yeah, those are the six scripts from week one to week six. At least those six scripts, you will have to, you know, ensure that they, you add error funk, error handling, you add user menus, you add comments, you add references. Follow the example script which I have shared because right now, whatever work you, you know, you have."
        }
      ],
      "date": "2023-02-23T09:33:17.016573Z"
    },
    {
      "file_name": "8eef2bd8-ddbc-4cb4-b50e-9c32bd1a122d.wav",
      "file_url": "https://admin.lincfellow.com/v1/api/recordings/129776/8eef2bd8-ddbc-4cb4-b50e-9c32bd1a122d.wav",
      "duration": 926,
      "transcription": [
        {
          "speaker": "(0.02s - 0.03s) Isaac PANG",
          "line": "Hello."
        },
        {
          "speaker": "(0.04s - 0.1s) Suchi Dhir",
          "line": "Hi Isaac, this is Doctor Shuchi here. How are you doing?"
        },
        {
          "speaker": "(0.1s - 0.12s) Isaac PANG",
          "line": "Good, thank you. And yourself?"
        },
        {
          "speaker": "(0.13s - 0.27s) Suchi Dhir",
          "line": "I'm doing great, thank you for asking. That's good. Great. So I just called to have a quick discussion with you on the unit."
        },
        {
          "speaker": "(0.27s - 0.28s) Isaac PANG",
          "line": "Yeah, sure."
        },
        {
          "speaker": "(0.28s - 0.59s) Suchi Dhir",
          "line": "And before I start I just wanted to understand your academic or your, you know, professional experience in Linux or in shell scripting. So have you learned these concepts before or have you worked on Linux?"
        },
        {
          "speaker": "(0.59s - 0.94s) Isaac PANG",
          "line": "Yeah, I just had a look at week one and I pretty much learned all of those commands previously, at least those basic ones covered in the week one, moving through directories and all of that. So I can do all that type of thing, but outside of that I don't have like that much experience."
        },
        {
          "speaker": "(0.98s - 1.1s) Suchi Dhir",
          "line": "Okay, that's great. And what about your bash shell scripting?"
        },
        {
          "speaker": "(1.13s - 1.18s) Isaac PANG",
          "line": "Is that like the Powershell commands and all that?"
        },
        {
          "speaker": "(1.2s - 1.24s) Suchi Dhir",
          "line": "Yes, it's same to that."
        },
        {
          "speaker": "(1.25s - 1.46s) Isaac PANG",
          "line": "Yeah, it's alright. It's like I can do all the basic stuff like, you know, like, like, yeah, I can pretty much. I had a look at week one and I was familiar with all the stuff that they were talking about."
        },
        {
          "speaker": "(1.47s - 1.61s) Suchi Dhir",
          "line": "Oh, that's, that's great. So, and that's good to know. And is this your first unit or have you done any of the units before this?"
        },
        {
          "speaker": "(1.62s - 1.78s) Isaac PANG",
          "line": "This is my third unit, so I've done the cybersecurity unit for, I did that first and then I did networking second and this is my third year."
        },
        {
          "speaker": "(1.79s - 1.99s) Suchi Dhir",
          "line": "Okay, that's great. Then you must be aware of my role, my responsibilities and the kind of support that you may, you know, you may get from me."
        },
        {
          "speaker": "(1.99s - 2.02s) Isaac PANG",
          "line": "Yes, I'm aware."
        },
        {
          "speaker": "(2.02s - 3.89s) Suchi Dhir",
          "line": "Okay, that's great. So, yes, so I would like to quickly give you an overview of this unit because it's a basic unit, not like your cyber security, which does talk about cybersecurity concepts. And there are so many activities, lab activities that you could have done in cybersecurity unit as well as in networking. You would have done some good wireshark activities in your lab. This unit is very basic unit, which the main, main purpose of the unit is to ensure that students are able to write scripts, able to create scripts which are generally used by most of the security, you know, cyber security professionals to create, to automate their tasks, to execute Linux commands and to get lots of work done through, you know, Linux. So that's the basic reason behind this. So week one, week two, week three, very, very simple. And a student or professionals, you know, who have already worked in the next or who have programming experience may find week one, week two, week three, very simple. And easy. In that case, it's, in that case, you know, I would suggest that, you know, if you find week one, two, three simple, complete them as quickly as possible, move on to week four, five, six, complete that and focus your time on the final assessment because you are going to learn a lot through that. You have, you have to create your own scripts there and that will really help you in learning lot of the concepts. So you can just focus directly on that. So have you gone through the content of the."
        },
        {
          "speaker": "(3.9s - 4.12s) Isaac PANG",
          "line": "I haven't like gone through week by week, but I have gone through week one and I just did that today and I was planning on like working through it more tomorrow and a bit more. Yeah."
        },
        {
          "speaker": "(4.15s - 5.3s) Suchi Dhir",
          "line": "Okay, so here if you have gone through week one, week two and week three, it's, you know, very, very basic concepts of Linux that you would have done in cyber security. Also how to access the files and basic commands and then you would be introduced to a very, very basic program of shell scripting in week one and week four, week five, six are quite, you know, deals with some difficult concepts. So you need to spend more time on that. Now do they do three things? It is different than your networking and cybersecurity because here there are two assigned major assignments. You have to submit it at the end of week six. You don't need to submit anything after week four. And one of the major assessments is very, very easy and simple because that's based on what you are doing daily. You have to create a GitHub repository, upload your work, your lab activities on GitHub and that's part of your assessment. You have to just maintain a portfolio on GitHub."
        },
        {
          "speaker": "(5.31s - 5.32s) Isaac PANG",
          "line": "Yeah."
        },
        {
          "speaker": "(5.33s - 5.54s) Suchi Dhir",
          "line": "And we will be accessing, you know, we will be accessing your GitHub repository, we will check your work and then we will grade you on, on the way you have worked, you know, on your portfolio."
        },
        {
          "speaker": "(5.55s - 5.56s) Isaac PANG",
          "line": "Okay."
        },
        {
          "speaker": "(5.57s - 5.6s) Suchi Dhir",
          "line": "Have you worked on GitHub before?"
        },
        {
          "speaker": "(5.61s - 5.69s) Isaac PANG",
          "line": "No, I haven't worked on GitHub, but I know what it is, I just haven't used it before."
        },
        {
          "speaker": "(5.7s - 6.27s) Suchi Dhir",
          "line": "Okay, so I will be sharing by end of the week because this is week zero. We have not shared, we have not started as such. So I'll be sharing the notes on how to, you know, create a private repository on GitHub and I'll also share what needs to be done, how to upload your work on GitHub. Now whatever you're working every day, you can upload it on GitHub and we will be accessing it and we will be creating your work through that. Okay, now what is it exactly that."
        },
        {
          "speaker": "(6.27s - 6.35s) Isaac PANG",
          "line": "Um, we are uploading then? Is it just like the tasks, we."
        },
        {
          "speaker": "(6.35s - 6.79s) Suchi Dhir",
          "line": "Go through them every day, every week there are, yeah, every week there are scripts that you would be working on. You will be uploading them on GitHub. At the end of the week there is a checklist which is provided to you. You have to upload all the programs which are mentioned in the checklist on GitHub. You have to ensure that you have uploaded all the code, all the scripts which are mentioned in that checklist."
        },
        {
          "speaker": "(6.79s - 6.81s) Isaac PANG",
          "line": "Yes, that's fine."
        },
        {
          "speaker": "(6.82s - 8.77s) Suchi Dhir",
          "line": "That's important. Now, with respect to your, you know, the content which is being provided, you may need some extra, you know, you may ref, you may need to refer to some extra materials. So I would be sharing them time to time because it's important that you are able to understand all the aspects of bash scripting language. After this call, I'll be sharing a link with you that's a very good link on bash scripting course. And I would suggest that you go through that course quickly. You don't need to make any notes or don't need to remember, but when you go through this course, you understand the capabilities of the bash scripting language. You will be able to understand different ways through which a particular problem can be approached. When you understand that, you always, you always deliver, you know, competent scripts, you always deliver shorter scripts. Because I've observed in past that some of the students are able to write very small scripts. Yeah. They are able to achieve their tasks in a smaller way because they know commands, maybe because of their professional experience or they would have learned bash shell scripting before. Some of the students who have not learnt bash shell scripting before, they, they produce larger scripts. The way they approach to the problem is different than the students who know bash scripting. And students can feel that difference because when students, when on group discussions, when students, they share the scripts, they feel that, you know, some of the students are approaching the scripts in a very, very different way as they are doing so."
        },
        {
          "speaker": "(8.78s - 8.79s) Isaac PANG",
          "line": "Yeah."
        },
        {
          "speaker": "(8.8s - 9.49s) Suchi Dhir",
          "line": "So that's why it's very important to go through this course, which I'm going to share after our call. You can spend some time on that, you know, five to 6 hours or seven to 8 hours and understand, you know, the ways through which Bashen script can be created. When you have that in your mind, when you are approaching, when you're writing your own script, you will have better ideas to write the script. Otherwise it will be very difficult. Even though you will know how to write the script, you will find that, you know, there are something that is missing. There are some commands which you don't know through which, you know, you can make your work easier."
        },
        {
          "speaker": "(9.51s - 9.53s) Isaac PANG",
          "line": "Yes. Okay."
        },
        {
          "speaker": "(9.53s - 10.05s) Suchi Dhir",
          "line": "Right. So I will share that now after email. Yes, I'll do that after the call. And also I'll be sharing, you know, from every day or maybe, you know, as you progress through, I'll be sharing some important notes which are really required. So please go through them because you need to have a complete understanding of this. Bash shell scripting."
        },
        {
          "speaker": "(10.07s - 10.09s) Isaac PANG",
          "line": "Yeah, sure."
        },
        {
          "speaker": "(10.1s - 10.32s) Suchi Dhir",
          "line": "It's one of the most default shell, which is used in almost all the Linux distributions. And you know, when you would be working as a cybersecurity engineer, you may be interacting with this shell."
        },
        {
          "speaker": "(10.33s - 10.37s) Isaac PANG",
          "line": "Yeah. Okay, cool."
        },
        {
          "speaker": "(10.37s - 10.54s) Suchi Dhir",
          "line": "Yeah, so it's important. So Isaac, do you have any particular requirements or do you have any queries that you would like to ask me?"
        },
        {
          "speaker": "(10.56s - 10.78s) Isaac PANG",
          "line": "No, I think you've explained everything pretty well. I'll go over the link you send me tonight or tomorrow, and then if I have any queries I'll get back to you about that."
        },
        {
          "speaker": "(10.79s - 11.11s) Suchi Dhir",
          "line": "Okay. And with respect to your assignments, you can create the draft versions of your assignments and you can share it with me. I'll go through them and I'll guide you on the best way to approach those assignments. Sure."
        },
        {
          "speaker": "(11.11s - 11.12s) Isaac PANG",
          "line": "Yeah."
        },
        {
          "speaker": "(11.12s - 12.55s) Suchi Dhir",
          "line": "And that is possible only when you really, when you're able to share your draft assessments well in time, because you should have some time to improve. Yeah. And to implement the suggestions which are made by me. So that's, that's important. And yes, the most important thing to remember in mind to ensure that you are able to complete the course with good grades is the time you have to very, very quickly. I would say rather, you know, in a week's time, you should be able to complete until week four. That's my, yeah. If you have some time, if you're able to complete that and with your experience, which you already have in Linux, you should be able to complete them quickly. And once that is done, focus on, you know, start working on your assignment because you are going to learn a lot through your assignments. So don't just, yeah, don't just park it for the end and try to complete your week four. Start looking at the major assessment which is there, and start working towards it. I'm there to guide you and explain you step by step what needs to be done and how to complete it. That can be discussed afterwards, but you need to spend some time to complete your weekly task as soon as possible."
        },
        {
          "speaker": "(12.56s - 12.65s) Isaac PANG",
          "line": "So there's, so I saw there were like the quizzes. Those are the weekly tasks, right?"
        },
        {
          "speaker": "(12.66s - 12.72s) Suchi Dhir",
          "line": "Yeah, those are weekly tasks and just leave that one. But."
        },
        {
          "speaker": "(12.75s - 12.81s) Isaac PANG",
          "line": "Yeah, so the. And then there's just one major assignment after that."
        },
        {
          "speaker": "(12.83s - 13.82s) Suchi Dhir",
          "line": "Yeah, there are two major assignments. One of the assignment is something which you are doing every week. You are uploading your scripts on GitHub. GitHub, yes. That's portfolio submission. And at the end of the week six, you submit your portfolio and we will just check your work, what you have done every week, and on the basis of that, you will be graded. So that's portfolio. Yeah. But there is one major assessment where you have to write scripts and there are multiple scripts that you would be writing to complete the work done. Complete the work which is given. So that is something which will really help you in learning a lot because you. Yeah. So try to complete your work as quickly as possible and start working towards it because that is also. Yeah, that is not something where you are going to apply your knowledge, but that is something that you are going to use as a learning tool."
        },
        {
          "speaker": "(13.83s - 13.96s) Isaac PANG",
          "line": "Yep. Okay, great. Now I'll finish up to week four, then I'll try and get it done by the end of this week."
        },
        {
          "speaker": "(13.97s - 14.35s) Suchi Dhir",
          "line": "Yes, you should be able to use that because it's very simple and easy. It's only time consuming. You may have to spend time to read everything which is provided online, but apart from that, simplicity, it's quite simple. Specifically for the students who have background, you know, in Linux who have done some of the work, it would be easy."
        },
        {
          "speaker": "(14.36s - 14.46s) Isaac PANG",
          "line": "Okay, great. Well that's great. Thanks so much for the call then. That's brilliant."
        },
        {
          "speaker": "(14.48s - 14.59s) Suchi Dhir",
          "line": "You're welcome, zak. And can we speak every week, same time? Can we schedule a call next week, same time?"
        },
        {
          "speaker": "(14.6s - 14.65s) Isaac PANG",
          "line": "Is that Thursday 530 western time?"
        },
        {
          "speaker": "(14.65s - 14.69s) Suchi Dhir",
          "line": "Yes, Thursday 530 your time?"
        },
        {
          "speaker": "(14.7s - 14.74s) Isaac PANG",
          "line": "Yes, that's fine. That works with me."
        },
        {
          "speaker": "(14.75s - 15.02s) Suchi Dhir",
          "line": "Great. And I'll speak to you next week. And meanwhile I'll be sharing some emails with you. I keep on sharing some of the resources as well, so please do follow them. And in case if you need any particular resource on any particular topic, do let me know."
        },
        {
          "speaker": "(15.03s - 15.08s) Isaac PANG",
          "line": "Can I expect the email with the."
        },
        {
          "speaker": "(15.09s - 15.16s) Suchi Dhir",
          "line": "I'll do it now, I will do it now. I'll do straight away."
        },
        {
          "speaker": "(15.17s - 15.25s) Isaac PANG",
          "line": "Yeah, great. Okay, thank you so much. Is it sushi?"
        },
        {
          "speaker": "(15.25s - 15.3s) Suchi Dhir",
          "line": "Yes, my name is Druchi."
        },
        {
          "speaker": "(15.3s - 15.33s) Isaac PANG",
          "line": "Okay, great. Thank you very much for that."
        },
        {
          "speaker": "(15.33s - 15.36s) Suchi Dhir",
          "line": "You're welcome. Bye bye, take care."
        },
        {
          "speaker": "(15.37s - 15.39s) Isaac PANG",
          "line": "Okay then I'll see you later. Okay then, bye."
        }
      ],
      "date": "2023-01-12T09:30:13.659558Z"
    },
    {
      "file_name": "366c3c62-420b-472a-92c9-5003a67648e9.wav",
      "file_url": "https://admin.lincfellow.com/v1/api/recordings/130811/366c3c62-420b-472a-92c9-5003a67648e9.wav",
      "duration": 1330,
      "transcription": [
        {
          "speaker": "(0.02s - 0.03s) Isaac PANG",
          "line": "Hello."
        },
        {
          "speaker": "(0.03s - 0.06s) Suchi Dhir",
          "line": "Hi, Isaac. How are you doing?"
        },
        {
          "speaker": "(0.07s - 0.1s) Isaac PANG",
          "line": "I'm great, thank you. And yourself?"
        },
        {
          "speaker": "(0.1s - 0.14s) Suchi Dhir",
          "line": "I'm doing good, thanks for asking."
        },
        {
          "speaker": "(0.15s - 0.16s) Isaac PANG",
          "line": "That's okay."
        },
        {
          "speaker": "(0.17s - 0.25s) Suchi Dhir",
          "line": "How is your progress, Isaac? Have you completed week one, week two?"
        },
        {
          "speaker": "(0.26s - 0.3s) Isaac PANG",
          "line": "I've completed week one, week two, and week three."
        },
        {
          "speaker": "(0.3s - 0.38s) Suchi Dhir",
          "line": "Oh, that's great. Good to know. You have completed all, all the scripts of week three?"
        },
        {
          "speaker": "(0.39s - 0.48s) Isaac PANG",
          "line": "Yeah, I've completed all the scripts of week three. I submitted them about an hour and a half ago."
        },
        {
          "speaker": "(0.49s - 0.57s) Suchi Dhir",
          "line": "That's really good. And I did share an example script yesterday."
        },
        {
          "speaker": "(0.57s - 0.87s) Isaac PANG",
          "line": "Yeah, yeah. I will go back and redo them to make them better. I just wanted to submit week three and then I can go back and touch up on all of the stuff that you mentioned before. Yeah, yeah."
        },
        {
          "speaker": "(0.87s - 1.06s) Suchi Dhir",
          "line": "And that's what required also. So if you, you know, that's how you can maintain different versions of your code, you can, you have to actually go back and improvise whatever you have worked in the previous weeks."
        },
        {
          "speaker": "(1.07s - 1.11s) Isaac PANG",
          "line": "Right. Okay, great."
        },
        {
          "speaker": "(1.12s - 1.21s) Suchi Dhir",
          "line": "So any, any particular, you know, query that you have?"
        },
        {
          "speaker": "(1.23s - 1.58s) Isaac PANG",
          "line": "Not quite yet. I'll be starting week four tomorrow, I guess. So when I have any questions, I will get probably give you a text like I have through the week and stuff as usual. But right now, as of now, I'm, I've got no questions. I think I'm doing okay."
        },
        {
          "speaker": "(1.59s - 2.08s) Suchi Dhir",
          "line": "Okay. So two, three things which I would definitely like to discuss. The scripts that you're working on, like, you know, set password and check password, and then you're working on your mega menu. These are the scripts that they are, you know, that are going to compromise the, comprise the components of your final assessment, so ensure that they all are, you know, kind of similar."
        },
        {
          "speaker": "(2.1s - 2.19s) Isaac PANG",
          "line": "Oh, right, sorry. Can you explain, explain that? I didn't quite get it."
        },
        {
          "speaker": "(2.19s - 2.34s) Suchi Dhir",
          "line": "Sorry for that. See, for your final, for your final assessment, you have to create a menu driven script."
        },
        {
          "speaker": "(2.35s - 2.36s) Isaac PANG",
          "line": "Yes."
        },
        {
          "speaker": "(2.37s - 3.11s) Suchi Dhir",
          "line": "Yeah. Menu driven script in which you will be scraping a web page, collecting some data from that and then producing analysis of the data as an output. So that script has to be completely menu driven. And then to ensure that it also has that, you know, security path, you can, you know, allow only the secure users to access some part of the script, for example, downloading the data or reading this data that you have downloaded. So whatever you're working from week one to week five, all these scripts will be, you know, the part of your final scripts."
        },
        {
          "speaker": "(3.11s - 3.17s) Isaac PANG",
          "line": "Right, I understand, yeah. So, yeah, that's fine."
        },
        {
          "speaker": "(3.18s - 3.52s) Suchi Dhir",
          "line": "So yeah, you should be able to source these scripts in your assessment for script. So do your work accordingly, understand how to, and if you want to export any variable, you know, from one script to another, you can also write."
        },
        {
          "speaker": "(3.53s - 3.75s) Isaac PANG",
          "line": "Okay, so we'll be, we'll be using the scripts that we have been going in week one to five or are they just going to be like, we're going to be writing similar scripts to."
        },
        {
          "speaker": "(3.76s - 3.86s) Suchi Dhir",
          "line": "Those best is to use the same scripts that you have done rather than redoing the work."
        },
        {
          "speaker": "(3.86s - 3.88s) Isaac PANG",
          "line": "Right, right, I see."
        },
        {
          "speaker": "(3.88s - 4.19s) Suchi Dhir",
          "line": "Yeah, that's focus it that way. You know, when you're writing these scripts, ensure that you're able to also call them in your final assessment rather than redoing everything that will show, you know, the flexibility part that your entire, this."
        },
        {
          "speaker": "(4.19s - 4.26s) Isaac PANG",
          "line": "Is for the final, not the portfolio, like the final assessment."
        },
        {
          "speaker": "(4.26s - 4.31s) Suchi Dhir",
          "line": "Right, I'm talking about your final assessment. Right?"
        },
        {
          "speaker": "(4.31s - 4.35s) Isaac PANG",
          "line": "Yeah, yeah, yeah, cool. Yeah, that's cool."
        },
        {
          "speaker": "(4.36s - 4.51s) Suchi Dhir",
          "line": "Okay, so yeah, do it. Yeah, do it that way that, you know, you are able to use them later on also, rather than making them very, very static."
        },
        {
          "speaker": "(4.52s - 4.59s) Isaac PANG",
          "line": "Sure. Okay. Yeah, I'll try and do that then."
        },
        {
          "speaker": "(4.6s - 5.06s) Suchi Dhir",
          "line": "Great. Another important suggestion is, again, for your portfolio, you have to ensure that your scripts, whatever scripts you have uploaded, you maintain different versions of those scripts and improvise on the basis of what you are learning in future weeks. For example, in week two and week three, if you have learned about debugging, you incorporate that debugging component in wepand script."
        },
        {
          "speaker": "(5.08s - 5.09s) Isaac PANG",
          "line": "Okay."
        },
        {
          "speaker": "(5.11s - 5.49s) Suchi Dhir",
          "line": "Yeah, yeah. So that's something important. Also ensure that, you know, there are proper checks in your script because in your final assessment you will be using the same script. And if you are incorporating that habit now in your scripts, it will be easy for you to continue."
        },
        {
          "speaker": "(5.49s - 5.55s) Isaac PANG",
          "line": "For example, what do you mean by a check, sir?"
        },
        {
          "speaker": "(5.55s - 5.78s) Suchi Dhir",
          "line": "Yeah. For example, if you are opening a file, let's say secret TXT file for checking the stored hash before opening it, check whether the file exists or not. Otherwise the terminal."
        },
        {
          "speaker": "(5.8s - 5.81s) Isaac PANG",
          "line": "Yeah."
        },
        {
          "speaker": "(5.82s - 6.6s) Suchi Dhir",
          "line": "It will end your program abruptly. So check whether the file exists or not. You know, you have done that code in one of the. Yes. Free. And then same way, if you're using a looping statement to, let's say, read the lines which are there in the file, ensure that, you know, there are the loop lower bound and the upper bounds of the loops are checked correctly. Okay. There should be conditional statements, proper conditional statements in place. And. Yeah, whenever you are using pipes in batch. Yeah. Pipes to join towards any commands, it is possible to even, you know, exploit that."
        },
        {
          "speaker": "(6.62s - 6.64s) Isaac PANG",
          "line": "Right."
        },
        {
          "speaker": "(6.64s - 6.78s) Suchi Dhir",
          "line": "Okay. So that is something you will have to ensure that, you know."
        },
        {
          "speaker": "(6.78s - 6.8s) Isaac PANG",
          "line": "Yeah, yeah."
        },
        {
          "speaker": "(6.8s - 6.83s) Suchi Dhir",
          "line": "Is properly used."
        },
        {
          "speaker": "(6.87s - 7.03s) Isaac PANG",
          "line": "Yeah, sure. No, that's okay. I'll go back through the script and try and change, like fix up those things."
        },
        {
          "speaker": "(7.03s - 7.4s) Suchi Dhir",
          "line": "I do try to link whatever you are learning with cybersecurity because at the end of the day you're learning it for cyber security. So just try to link everything with that. Try to, you know, also focus on learning good programming skills because."
        },
        {
          "speaker": "(7.4s - 7.76s) Isaac PANG",
          "line": "Yeah, sure. Time I've really used like bastion and scripting sense like this. So all those things are new to me. Like, I guess I'll just have to go back and do those things that you say it doesn't. Yeah, I haven't, like, I don't think I've done a lot of those things straight up on in the first round of writing it, you know."
        },
        {
          "speaker": "(7.76s - 8.62s) Suchi Dhir",
          "line": "Yeah, that's the, that's the pretty reason I was, you know, suggesting all the students to complete, you know, their week four very quickly because it's not only about learning programming, it's about learning other things that are related with it. And that was the reason. Now when you have completed, now you have good amount of time to do little research to understand about how to create secure codes, how to create secure scripts, because being a cyber security expert, we are always talking about, let's say, vulnerabilities, which are, you know, valuable in the code, let's say buffer overflow, very, very common vulnerability that the programmers believe. So try to link it to your scripts and understand whether any loophole or any, you know, vulnerability left in your script that can cause any."
        },
        {
          "speaker": "(8.62s - 8.75s) Isaac PANG",
          "line": "So even if, even if the script works as intended, maybe that's not enough to get the full marks."
        },
        {
          "speaker": "(8.78s - 9.49s) Suchi Dhir",
          "line": "It is, it is. I'm not talking about grades, is that. It's about learning. See, your grades will be related to. Yeah. Your grades will be related to your rubrics. And for assessment four, not for the portfolio of the task, you know, for assessment four, your script will be evaluated against security, reliability, reusability, flexibility. So these are the four parameters on which you will have to actually, you know, discuss how your, you know, how your code is secure or how you have implemented flexibility. You have to write a report and you will have to defend your code."
        },
        {
          "speaker": "(9.5s - 9.63s) Isaac PANG",
          "line": "Okay. Okay, I see. So I just practice those, practice those things in the code that we're writing right now in the portfolio."
        },
        {
          "speaker": "(9.63s - 9.74s) Suchi Dhir",
          "line": "Yeah. So it would be easy for you to quickly, you know, use it in the same way in your final assessment."
        },
        {
          "speaker": "(9.76s - 10.2s) Isaac PANG",
          "line": "Yeah, I see. Yep. That's fine. So now that. Yeah, so I submitted all my stuff and it all executes like it does the task as required. Like in the question, it all works properly, but going back to review it, like, what would be like the first or maybe the most important things to kind of look out for to improve the code a bit more then."
        },
        {
          "speaker": "(10.21s - 10.73s) Suchi Dhir",
          "line": "Yes, yes. And see, there are some grades for adding comments, for adding references in your code, and obviously some bonus marks are there for highly efficient and competent code. So if your code is highly competent, efficient, and there are no other ways through which you could have improvised your work. So definitely it always. You'll get full grades on that particular course."
        },
        {
          "speaker": "(10.74s - 10.96s) Isaac PANG",
          "line": "Yeah, I'll try my best to go back and see what I can tighten up on it because it's all working fine. It's all doing the task as needed, but I'll go back and have a look at what I can improve on then."
        },
        {
          "speaker": "(10.97s - 11.81s) Suchi Dhir",
          "line": "Yes. For example, just giving you a small example that if you're opening a file and if you have used absolute paths in your code, then that's not an example of a highly efficient code. So using relative paths or trying to use more of sourcing a file or know exporting variables are some of the features of good code. Right. So don't use absolute path. If, even though your code is working, but you have used absolute paths and you have not tested, you don't have enough conditional statements in your code and the code is kind of static rather than, rather than self driven, then in that case, it's not completed."
        },
        {
          "speaker": "(11.84s - 11.98s) Isaac PANG",
          "line": "Sorry, what do you mean by static? I know you've said that just before. I'm not entirely sure what you mean by that."
        },
        {
          "speaker": "(11.99s - 12.93s) Suchi Dhir",
          "line": "Okay, for example, your set password and check password. You have hard coded the password and you have stored it. Now your check password is only checking that hard coded password. Now, if you submit that file and I am supposed to execute it only through the password that you have set, that's something kind of static code. It's not very user friendly code because I have to check your code. Running your code only through the password that you have set. That's a small example. Don't hard code anything. You are learning about menu in week three. So everything should be menu driven, it should be more interactive, and the user should be able to drive the execution of the code rather than code driving the execution, you know, of the user."
        },
        {
          "speaker": "(12.93s - 12.94s) Isaac PANG",
          "line": "Yeah."
        },
        {
          "speaker": "(12.94s - 13.18s) Suchi Dhir",
          "line": "Yes. So that's, that's the difference. I'm just talking about sac. I'm talking about highly efficient code right now. So that's just if you are competing for high distinction grades."
        },
        {
          "speaker": "(13.19s - 13.2s) Isaac PANG",
          "line": "Yeah."
        },
        {
          "speaker": "(13.2s - 13.3s) Suchi Dhir",
          "line": "Then you should look for. And you should work towards generating highly efficient code."
        },
        {
          "speaker": "(13.31s - 13.41s) Isaac PANG",
          "line": "Yeah, that's. Yeah. Essentially my aim to try and get there. But yeah."
        },
        {
          "speaker": "(13.45s - 13.77s) Suchi Dhir",
          "line": "You'Re already you know, completed week four. And if you spend some more time, and these are the things which you know will really help you in improvising as a coder itself, because even you write efficient code, that will be a skill that will be used most useful for you."
        },
        {
          "speaker": "(13.78s - 14.03s) Isaac PANG",
          "line": "Yeah, sure. Okay, well, thank you for the advice. That's good. I'll take that into account when I start off again tomorrow and week four and review all my stuff that I've already submitted in the portfolio."
        },
        {
          "speaker": "(14.04s - 14.14s) Suchi Dhir",
          "line": "Great. Let's say for menu. Menu. Did you write that mega menu script?"
        },
        {
          "speaker": "(14.15s - 14.18s) Isaac PANG",
          "line": "Yeah, yeah, I wrote that."
        },
        {
          "speaker": "(14.18s - 14.55s) Suchi Dhir",
          "line": "Yeah. Try to write in a way that you are reusing the folders, the files which are already created. I have seen the scripts in past where, you know, students, they just copy paste all the files again in week three folder rather than using the files which were there in the week to folder. That's one mistake."
        },
        {
          "speaker": "(14.55s - 14.8s) Isaac PANG",
          "line": "Yes, I copied all of, yeah, I copied all of the files like the dot sh files that we were calling into week three because I wasn't sure, I wasn't sure how to call the week two ones. Do you know what I mean?"
        },
        {
          "speaker": "(14.8s - 15.27s) Suchi Dhir",
          "line": "Yeah. So that is what you will have to do little research on and to ensure that, you know, you make your files, you make your work more, I would say streamlined. Yes, yes. So if, if you are using the exit already, you know, reusability of your code. So code already exists rather than copy pasting it inside the folders. Using the absolute maths does not make an efficient code at all."
        },
        {
          "speaker": "(15.27s - 15.45s) Isaac PANG",
          "line": "No. Yep, yep, yep. That's fine. That's something that I was wondering about actually, but I couldn't, I couldn't really figure it, figure it out. But I'll tackle that tomorrow and see if I can fix that up."
        },
        {
          "speaker": "(15.47s - 17.09s) Suchi Dhir",
          "line": "Great. That would be very good. Ishak and yeah, sourcing files is very good capability that bash provides because, you know, the current shell which we are working in is totally different than other shells because it opens multiple shells for the users to interact. So if you want to use one file which is currently open in one shell into another, then you will have to export the, those files or the variables, and then you also have something called as sourcing files. So if you want to source any particular file in the current running shell, you can do that as well. Okay, so do that. Try to make use of bash configuration file for. I mean, I'm just giving you some pointers to research on. So you can also use a bash configuration file for storing the information of the login users. You know, the password, the password you can export it in another files. Just try doing that, you know, something which is different if you have time. I'm just suggesting you. I'm not suggesting this to every student because most of the students are just on stuck on week one they have not completed, so it's not mandatory. Again, is that. That you have to do this. These are only the pointers because you have completed. I just wanted to share some extra points which you can, you know, research and work on."
        },
        {
          "speaker": "(17.1s - 17.55s) Isaac PANG",
          "line": "Yeah, yeah, yeah. No, I wouldn't say I'm like proficient in any means. Like, I only just started learning this in the same as the other students. I think I just finished it a bit faster. So. Yeah, sometimes it. Sometimes it's a bit overwhelming, like all the different things you can do and then like putting them into practice. But I'll just take like, now that I'm a little bit ahead and kind of just focused on those things. Yeah, yeah."
        },
        {
          "speaker": "(17.55s - 17.76s) Suchi Dhir",
          "line": "Please do not worry. I can understand it becomes little overwhelming and do not worry about that. If you just research about it and even if you fail, at least you will gain some knowledge on that."
        },
        {
          "speaker": "(17.76s - 17.77s) Isaac PANG",
          "line": "Yeah."
        },
        {
          "speaker": "(17.77s - 18.15s) Suchi Dhir",
          "line": "Because handling bash configuration files are also very important. You can actually export some of the values and import some of the values from that. So just try, you know, it's not necessary that you have to do that again. In fact, I'm saying it's only. I'm sharing it with you because you have completed something. So I just thought, yeah, you know."
        },
        {
          "speaker": "(18.15s - 18.27s) Isaac PANG",
          "line": "Yeah, no, that's fine. Thank you. No, it's really good that you are bringing that up so I can try and tighten up everything a bit better. No, it's good."
        },
        {
          "speaker": "(18.27s - 18.51s) Suchi Dhir",
          "line": "Yes, it happens that, you know, always there would be some students who would be ahead in the cohort and when we suggest them something, provide them a good direction, they generally come up with a great assessment and that's what, you know, I'm trying to do."
        },
        {
          "speaker": "(18.52s - 18.54s) Isaac PANG",
          "line": "Yeah, no, no, thank you. No, it's really good."
        },
        {
          "speaker": "(18.55s - 18.55s) Suchi Dhir",
          "line": "Yeah."
        },
        {
          "speaker": "(18.55s - 18.64s) Isaac PANG",
          "line": "I'm obviously going to take into consideration what you're talking about. Yeah, yeah, that definitely."
        },
        {
          "speaker": "(18.64s - 18.82s) Suchi Dhir",
          "line": "Great. Do try all the things. I'm always there to assist you in case if you get stuck somewhere, you can let me know and I'll guide you on how to complete that."
        },
        {
          "speaker": "(18.83s - 18.88s) Isaac PANG",
          "line": "Yeah, cool. Thank you. Yeah, perfect. That's great."
        },
        {
          "speaker": "(18.88s - 19.09s) Suchi Dhir",
          "line": "Great. And yes, your quizzes have not started yet, but the link to the quiz is not active. But it's quite simple and easy because it's an open link."
        },
        {
          "speaker": "(19.11s - 19.24s) Isaac PANG",
          "line": "Yeah, sure. So they will just have to use the terminal to, I guess, do some commands from the quizzes. Yeah."
        },
        {
          "speaker": "(19.24s - 19.34s) Suchi Dhir",
          "line": "Yes. You'll have to. You'll have to use terminal to execute the commands. Produce that. Yeah."
        },
        {
          "speaker": "(19.34s - 19.39s) Isaac PANG",
          "line": "And ten questions or 20 questions?"
        },
        {
          "speaker": "(19.4s - 19.44s) Suchi Dhir",
          "line": "Ten questions for the first quiz, I guess."
        },
        {
          "speaker": "(19.44s - 19.45s) Isaac PANG",
          "line": "Okay."
        },
        {
          "speaker": "(19.45s - 19.54s) Suchi Dhir",
          "line": "Yeah, I have to. I'll have to. I'll have to check this. I'm sorry, Zach. I will just check this and get back to you."
        },
        {
          "speaker": "(19.55s - 19.6s) Isaac PANG",
          "line": "Three. When does that quiz open?"
        },
        {
          "speaker": "(19.61s - 19.64s) Suchi Dhir",
          "line": "I guess next week. Monday."
        },
        {
          "speaker": "(19.65s - 19.83s) Isaac PANG",
          "line": "Next Monday. Okay. Sure. I'll try and finish a bit more another week at least before that quiz starts then. And does that please cover content from week week?"
        },
        {
          "speaker": "(19.86s - 19.92s) Suchi Dhir",
          "line": "It's from week one to week three complete."
        },
        {
          "speaker": "(19.92s - 19.99s) Isaac PANG",
          "line": "Yeah. Okay, cool. That's all good."
        },
        {
          "speaker": "(20.0s - 20.15s) Suchi Dhir",
          "line": "Great. And I will definitely would like to discuss more about assessment four next week. I would suggest that you go through that."
        },
        {
          "speaker": "(20.16s - 20.3s) Isaac PANG",
          "line": "You have to finish up to week five. So then we can talk about the assessment by next week. So we can talk about."
        },
        {
          "speaker": "(20.3s - 20.31s) Suchi Dhir",
          "line": "Great."
        },
        {
          "speaker": "(20.33s - 20.35s) Isaac PANG",
          "line": "Yes, definitely."
        },
        {
          "speaker": "(20.35s - 20.62s) Suchi Dhir",
          "line": "And then you would be on. You would be on. On track. I would say Sac, because week five, whatever you're doing related to Awk, is something that you will be utilizing in your assessment for also. It would be wise to have that discussion next week."
        },
        {
          "speaker": "(20.63s - 20.75s) Isaac PANG",
          "line": "Yep. That's fine. I'll aim to finish week five before our next call then, so then we can discuss better."
        },
        {
          "speaker": "(20.75s - 20.89s) Suchi Dhir",
          "line": "Yeah, that's great. All the best. I'm so happy, Isaac. After talking to you, I'm only going. Yes. Who has completed."
        },
        {
          "speaker": "(20.92s - 21.27s) Isaac PANG",
          "line": "I've been working quite hard because I feel like it's the first time I've done it and it's not that easy the first time. I spent a lot of hours on it. Yeah, it's not. It's not something that is. I haven't, like, breathed through it by any means. I've actually put in quite a few hours. It's not come that easy."
        },
        {
          "speaker": "(21.27s - 21.42s) Suchi Dhir",
          "line": "Yeah, I understand. I completely agree with you. And it's good, you know, your hard work will definitely pay you off. Is that."
        },
        {
          "speaker": "(21.42s - 21.43s) Isaac PANG",
          "line": "Yeah."
        },
        {
          "speaker": "(21.44s - 21.48s) Suchi Dhir",
          "line": "In terms of learning as well as grades?"
        },
        {
          "speaker": "(21.49s - 21.62s) Isaac PANG",
          "line": "Yeah. Yeah. Well, we'll see. We'll see. I'll probably be texting you through this week asking for help, but no worries."
        },
        {
          "speaker": "(21.62s - 21.9s) Suchi Dhir",
          "line": "You can. I'm here always to help students and. Yeah. Be more inquisitive. You can ask questions and that would be really helpful for you as well as for other students because it, you know, gives me a perspective of what students are understanding, what they are thinking."
        },
        {
          "speaker": "(21.91s - 21.99s) Isaac PANG",
          "line": "Yeah. Yeah. Perfect. Okay, that's good. Okay."
        },
        {
          "speaker": "(22.0s - 22.08s) Suchi Dhir",
          "line": "All the best. I'll speak to you next week. Thank you."
        },
        {
          "speaker": "(22.08s - 22.11s) Isaac PANG",
          "line": "Bye bye. Thank you."
        },
        {
          "speaker": "(22.11s - 22.12s) Suchi Dhir",
          "line": "Bye."
        }
      ],
      "date": "2023-01-19T09:34:00.448967Z"
    },
    {
      "file_name": "92bb6da0-a9ff-4885-af5a-4ab9dd8db176.wav",
      "file_url": "https://admin.lincfellow.com/v1/api/recordings/131985/92bb6da0-a9ff-4885-af5a-4ab9dd8db176.wav",
      "duration": 824,
      "transcription": [
        {
          "speaker": "(0.02s - 0.03s) Isaac PANG",
          "line": "Hello."
        },
        {
          "speaker": "(0.03s - 0.07s) Suchi Dhir",
          "line": "Hi, Zak. Happy. Hi, shishi."
        },
        {
          "speaker": "(0.07s - 0.12s) Isaac PANG",
          "line": "How are you? Oh, thank you. Yeah."
        },
        {
          "speaker": "(0.15s - 0.26s) Suchi Dhir",
          "line": "So how is your progress? And good that, you know, you have completed so many scripts. Good to know."
        },
        {
          "speaker": "(0.27s - 0.53s) Isaac PANG",
          "line": "Yeah, my progress is good. It's. Well, I finished week four yesterday and then I won away today, but I have a Wi Fi, so I was planning on trying to finish week five this week. Maybe a quiz as well."
        },
        {
          "speaker": "(0.54s - 0.68s) Suchi Dhir",
          "line": "Okay, that's really good. So do you have any issues like learning, working on week four scripts regular?"
        },
        {
          "speaker": "(0.68s - 0.99s) Isaac PANG",
          "line": "Actually, week four I found the easiest for me. Not maybe because I'm. Maybe because I'm more used to the controls and everything now, you know, but I found week four a little bit easier than the other week."
        },
        {
          "speaker": "(1.01s - 1.21s) Suchi Dhir",
          "line": "That's. That's really good. So week five, if you complete, which is on awk, then probably you can actually, you know, start working towards your final assessment."
        },
        {
          "speaker": "(1.22s - 1.25s) Isaac PANG",
          "line": "Yes. Yeah, that was my plan."
        },
        {
          "speaker": "(1.25s - 1.31s) Suchi Dhir",
          "line": "Okay. So you need to spend more time on your final assessment."
        },
        {
          "speaker": "(1.32s - 1.33s) Isaac PANG",
          "line": "Yeah."
        },
        {
          "speaker": "(1.33s - 1.41s) Suchi Dhir",
          "line": "Do you want me to share some notes on that so that you can at least start working towards."
        },
        {
          "speaker": "(1.42s - 1.45s) Isaac PANG",
          "line": "Yes, that would be great. Thanks. Yeah."
        },
        {
          "speaker": "(1.46s - 1.68s) Suchi Dhir",
          "line": "Okay, so I'll do one thing. I'll share some notes with you. You shortlist some of the websites that you want to work on and also find out the kind of analysis that you would like to do."
        },
        {
          "speaker": "(1.69s - 1.71s) Isaac PANG",
          "line": "Okay."
        },
        {
          "speaker": "(1.71s - 2.09s) Suchi Dhir",
          "line": "And you can actually share the list of websites that you have shortlisted with me. And when we speak next week, we can actually discuss about those shortlisted websites and discuss about the pros and cons of selecting them and which can make the best assessment for you."
        },
        {
          "speaker": "(2.1s - 2.43s) Isaac PANG",
          "line": "Okay. Because I vaguely remember I read the task assignment task when in the start of week one, was it we had to pick a website and then did we have to write a script to do some tasks for it? Was that correct?"
        },
        {
          "speaker": "(2.44s - 3.31s) Suchi Dhir",
          "line": "Yes. You have to select a website which has some cybersecurity data related to it. And then you have to scrape the website. You have to collect the data which is there in the website. And after that you have to analyze it. Like, you can create some graphs. You can display the data in the form of a table. And you have to write a script for that. The script should have components. Like, it should have a menu which you have worked on, mega menu. And then for security, the script should be strong enough. It should be secure. You can have set password, check password that you have created. Then you have. You would have created one. You would have worked on one script called regular rejects. Sh. For checking the password? Yes."
        },
        {
          "speaker": "(3.31s - 3.32s) Isaac PANG",
          "line": "Yeah."
        },
        {
          "speaker": "(3.32s - 3.82s) Suchi Dhir",
          "line": "So you can use that script also. It would be like. And then the Internet downloader. So you can, yeah, you can actually, you know, take help from that script. So whatever you have worked on till now, only those scripts you would be using and doing little more research, little more learning to understand how to write that script. So when you write that script, whatever you have learned different components, they would be much more clearer to you."
        },
        {
          "speaker": "(3.82s - 3.97s) Isaac PANG",
          "line": "Okay? Okay, sure. And so is it inclusive of week five and six topics for the assignment?"
        },
        {
          "speaker": "(3.98s - 5.18s) Suchi Dhir",
          "line": "Say week five? Yes. And week six you will be learning about three different programming languages, that is Python per and Ruby. And in the assignment we want students to use Bash as well as other programming, other scripting languages also. So I would suggest that, you know, start working towards your script, write your basic script in bash, whatever you have learned so far. Python has some good components for creating charts. So you can use some of the libraries of Python and, you know, at the end, once your script is ready, you can also have one Python script which can create charts from the data that you have analyzed. So that's how you can, yeah, that's how you can merge. So week six you can do afterwards, that's completely different. But please start working towards the script because that's very good assignment. You can learn a lot provided you started very early. And I'm so happy, sad that standing in week two you have completed your, you know, all the scripts are weak for it's a very, very, oh yeah."
        },
        {
          "speaker": "(5.23s - 5.3s) Isaac PANG",
          "line": "Well, yeah, you said to do that, so I just figured that was probably for the best."
        },
        {
          "speaker": "(5.32s - 6.22s) Suchi Dhir",
          "line": "Now, now you can start working. So I'll do one thing, I'll share some notes with you on the assessment. Yep. And let's start working towards it. There is lot to learn through that assessment. So I want you to start working towards it. There would be a lot of troubleshooting, you will get a lot of errors, definitely, because you know, it's going to be a bigger script that you're, that you would be writing. But believe me, after you complete that, all your concepts of, you know, the scripting language will be clear and it will be easier for you to, you know, use write the scripts when you are interacting with the Linux, for example, going forward, if you work in cybersecurity field, you work with Linux, let's say configuring the firewalls in Linux. Then rather than writing statement one by one, you can write a script, all the statements together and execute as a, you know, a bash script."
        },
        {
          "speaker": "(6.22s - 6.24s) Isaac PANG",
          "line": "Yes. Okay."
        },
        {
          "speaker": "(6.24s - 6.27s) Suchi Dhir",
          "line": "Things will be more clearer to you."
        },
        {
          "speaker": "(6.28s - 6.55s) Isaac PANG",
          "line": "Yeah, brilliant. That's great. Cool. Well, yeah, so this week I'll just, well this by the end of this week I hope to have finished week five and then obviously maybe early next week I can get a start on, on the project, I guess."
        },
        {
          "speaker": "(6.56s - 7.0s) Suchi Dhir",
          "line": "Okay, great. I'll share the notes with you when you speak next week. Sak, I want you to, before that, I want you to make short list of websites. Share those websites with me through email so that when I speak we can discuss over them. And I can also understand your thoughts of how you're going to analyze or process the information and accordingly we can discuss more about it."
        },
        {
          "speaker": "(7.01s - 7.12s) Isaac PANG",
          "line": "So you want me to. So you'll send a package of websites for me to kind of pick from?"
        },
        {
          "speaker": "(7.13s - 7.52s) Suchi Dhir",
          "line": "No, I would be sharing one example website. I don't want to restrict your choices because sometimes students, they come up with better options. So I will share some example website that you can look for. You can select that website if you want. Happy. But if you want, if you have any other option which you think will be better, you can use that."
        },
        {
          "speaker": "(7.53s - 7.64s) Isaac PANG",
          "line": "Ok. Ok. And so you want me to make a short list of the, sorry, what do you mean by a shortlist of the website?"
        },
        {
          "speaker": "(7.66s - 8.44s) Suchi Dhir",
          "line": "Yeah, look for some websites and find out which website you would be scraping for your assignment. So at least two or three websites, you just shortlist first. At first go, you know, then we can discuss about like, you know, pros and cons in the sense the data that you get, will it be meaningful? You know, data that can be passed so we can have a discussion over it and then accordingly I can, you know, share some feedback with you that. What are the advantages of using this website, scraping data? What best can you get from this? So we can discuss, have a discussion over it and then probably you can select any one of them and go further."
        },
        {
          "speaker": "(8.45s - 8.57s) Isaac PANG",
          "line": "Sure. So by next Thursday evening I'll pick all those things. So then next Thursday we can have that talk. That sounds good."
        },
        {
          "speaker": "(8.58s - 9.3s) Suchi Dhir",
          "line": "Yes. And I would be sharing a link with you which you can follow to understand how to do web scraping because that has not been taught in Unita. Internet downloader is something equivalent to, I would say web scraping. You will be using the same command to do that, but I will be sharing a video. You can follow that. I would suggest that whatever websites you have shortlisted, just follow the steps. Do web scraping, scrape data from those websites and then you see whether you are getting the data that you want. Yeah, most of the websites they don't allow scraping."
        },
        {
          "speaker": "(9.3s - 9.45s) Isaac PANG",
          "line": "So do you mind just explaining what scraping actually is? I'm not really familiar."
        },
        {
          "speaker": "(9.46s - 10.01s) Suchi Dhir",
          "line": "Yeah, no worries. See, web scraping is a process where, you know, using a script you actually scrape all the like, you know, the entire HTML webpage. So you, you just, yeah, you just obtain that data which is there in the web page that is called as web scraping, or you can also call it as web data extraction. So you go to a particular URL and you scrape all the data which is there. So all the data will be downloaded in the form of HTML text."
        },
        {
          "speaker": "(10.01s - 10.05s) Isaac PANG",
          "line": "Okay, I see. Yes. Okay, cool."
        },
        {
          "speaker": "(10.05s - 10.69s) Suchi Dhir",
          "line": "That makes sense. See we are writing a script, but generally web scraping is a term which is used of electronic extraction of data from the websites. So there are generally bots that keep on, you know, doing, extracting the data from the website and they do it for various kinds of, you know, integration and various other purposes. Scraping is done. So now that's why most of the web pages do not allow scraping. So if it's like, because it can also affect the performance of the webpage."
        },
        {
          "speaker": "(10.7s - 10.7s) Isaac PANG",
          "line": "Okay."
        },
        {
          "speaker": "(10.7s - 11.05s) Suchi Dhir",
          "line": "So that's why, yeah, they don't allow scraping of the website. But we are going to just write a small script and we are going to scrape data from a website. So it might be possible that even though some of the websites don't allow, but when you run that script, you, you will be able to scrape some data from that."
        },
        {
          "speaker": "(11.05s - 11.18s) Isaac PANG",
          "line": "Cool, that sounds great. And so you'll send a video explaining how to do that."
        },
        {
          "speaker": "(11.19s - 11.35s) Suchi Dhir",
          "line": "Yes, I will be, I'll be sharing a very good resource with you. Just follow that and at least do this web scraping, you know, basic part."
        },
        {
          "speaker": "(11.35s - 11.39s) Isaac PANG",
          "line": "Yeah, sure. That sounds good."
        },
        {
          "speaker": "(11.39s - 11.87s) Suchi Dhir",
          "line": "Yes. And then as part of the learning you have HTML text, whatever you have scraped will be in the form of XML, HTML or some other form in which it is stored. So you will have to clean all the tags, HTML tags, XML tags, so that you can obtain the data from it and using all the techniques that you have learned in week four and then week five. So that is, that is your assignment. Yes."
        },
        {
          "speaker": "(11.88s - 12.05s) Isaac PANG",
          "line": "Okay, sure. Well that sounds good. I'll try and get what you asked done by next Thursday. So then we can talk about it in depth a bit better next week."
        },
        {
          "speaker": "(12.06s - 12.09s) Suchi Dhir",
          "line": "Great. So that is good."
        },
        {
          "speaker": "(12.09s - 12.1s) Isaac PANG",
          "line": "Yeah."
        },
        {
          "speaker": "(12.1s - 12.39s) Suchi Dhir",
          "line": "And I also wanted to check regarding, because I just saw that, you know, our call was not, it was not scheduled. I didn't share the invite with you. I guess I missed the time. So when should I, when should I call you? Next Thursday?"
        },
        {
          "speaker": "(12.39s - 12.54s) Isaac PANG",
          "line": "I think, I think it's our usual time was 530 western time, australian western times. Does that work for you?"
        },
        {
          "speaker": "(12.55s - 12.92s) Suchi Dhir",
          "line": "Okay, I'll do that. 530 Thursday. In case if there is any, you know, any issue, I'll let you know. Because recently I've been transferred a network security unit, the entire cohort. So I have a lot of students to handle. Oh, wow. In case if there is any issue, you know, in the time."
        },
        {
          "speaker": "(12.92s - 13.13s) Isaac PANG",
          "line": "Yeah, that's fine, that's fine. Just let me know. I'm pretty available, so maybe if there's an easier time for you, for yourself, I'm happy to change to that time. Whatever works best."
        },
        {
          "speaker": "(13.13s - 13.22s) Suchi Dhir",
          "line": "Thursday, can you give me a range of time? Like from 530 till 730, at least you have available?"
        },
        {
          "speaker": "(13.23s - 13.3s) Isaac PANG",
          "line": "Yeah, yeah, 530 to 730 is fine for me too. Yeah."
        },
        {
          "speaker": "(13.3s - 13.41s) Suchi Dhir",
          "line": "Okay, great. Then I look into my calendar and book a call, because I guess there was no schedule call for today."
        },
        {
          "speaker": "(13.41s - 13.57s) Isaac PANG",
          "line": "Yeah, sorry for that. No, that's fine. No, don't worry. It's fine. It's no problem. Okay, very busy."
        },
        {
          "speaker": "(13.6s - 13.67s) Suchi Dhir",
          "line": "Yes, all the best, Isak. We'll speak next week. Bye bye."
        },
        {
          "speaker": "(13.67s - 13.69s) Isaac PANG",
          "line": "Thank you. Okay then."
        },
        {
          "speaker": "(13.69s - 13.71s) Suchi Dhir",
          "line": "Thank you."
        },
        {
          "speaker": "(13.71s - 13.72s) Isaac PANG",
          "line": "Bye."
        }
      ],
      "date": "2023-01-26T11:25:03.518424Z"
    },
    {
      "file_name": "21f7fab3-7780-4b4c-a17f-09a18a7acf32.wav",
      "file_url": "https://admin.lincfellow.com/v1/api/recordings/133147/21f7fab3-7780-4b4c-a17f-09a18a7acf32.wav",
      "duration": 1527,
      "transcription": [
        {
          "speaker": "(0.02s - 0.03s) Isaac PANG",
          "line": "Hello."
        },
        {
          "speaker": "(0.04s - 0.09s) Suchi Dhir",
          "line": "Hi Isaac. Doctor Shuchi here. How are you doing?"
        },
        {
          "speaker": "(0.09s - 0.11s) Isaac PANG",
          "line": "Hi, how are you?"
        },
        {
          "speaker": "(0.12s - 0.3s) Suchi Dhir",
          "line": "I'm doing great, thank you. So how is your progress? Like, you know, have you started working on the final assessment?"
        },
        {
          "speaker": "(0.31s - 0.97s) Isaac PANG",
          "line": "Yeah, well, so I finished week five in the, I've submitted all my stuff for that. So I finished that yesterday. So today I started looking at the final assignment and looking at the emails that you sent about it. And now I just, I was a bit confused. I just wanted to ask you a few questions. Well, the first one, I guess, was like, the task is to find a cyber security website. And then what? Like write a script to get the data from it. Is that correct?"
        },
        {
          "speaker": "(0.99s - 2.3s) Suchi Dhir",
          "line": "Yeah. So basically you have to write a script and you have to, whatever data you have collected from the website, you have to clean it up because it will be in the form of HTML, XML or maybe it will be adjacent data. So you will have to clean up all the, you know, tags and all the information which is not required, and then you will have to store it in the form of table. Like, you know, using awk cleaning has been obviously using said, using said regular expressions. So apart from that you can analyze the information, whatever data you have collected in different ways. For example, in week five, you listed the table completely and you also filtered the users who were using bin bash shell and then only listed this users with bin bash shell. So it is exactly the same, similar kind of stuff where you have some queries and on the basis of the queries you display the data collectively in the table. And in case, if you want to, I'm like, if you have time and if you want to try plotting graphs, you can do that as well."
        },
        {
          "speaker": "(2.31s - 2.66s) Isaac PANG",
          "line": "Yeah. Okay. That leads into my second question, which is the websites that we're looking to get data from. I'm not sure the type of websites you're meaning to find. I don't know, like OAP website with daughter and stuff. Is that."
        },
        {
          "speaker": "(2.7s - 4.88s) Suchi Dhir",
          "line": "Okay? I guess in my mail I did share one website like CVE details. So I gave you that example because it had some good amounts of data. See, you have to find out the website which has some data which you can scrap. If the website does not have, you know, good data to scrap, you will not be able to analyze it. For example, if it only contains about some news articles on cyber security and, you know, something like that, it would be difficult for you to write your script, write some queries, you know, display that. So that kind of website is not required, but a website where it has numbers, for example, number of security incidents which happened in the year 2020, number of. Yeah, it will be useful for you because you will be able to project it. Well, I mean, like, it's not, it's not, I'm not saying that you should not, you cannot do, you can scrape any website which has some cyber security data. You can scrape any website, you're free to do so. But in case, if you scrape a website, for example, the one which generally only has some news or some information, so if you just do that, you will not be able to display a good output. You will not be able to, you don't have much work to do in the script. You'll not be able to learn something from it. So that's why if you find out a website like the links which I shared, you can see, you know, it just listed all the vulnerabilities based on the product. You can also list all the vulnerabilities based on year specific vulnerabilities. So something like that where you can design multiple queries, that user can select, for example, print list the number of vulnerabilities for the Apple product in the year 2022. So you can have those kind of design queries in your menu and user can select any option and you know, your script should display the output."
        },
        {
          "speaker": "(4.88s - 5.23s) Isaac PANG",
          "line": "Yeah. So you want a menu kind of format. So like the user picks or in that case like the vulnerabilities for the was the Apple product and then they click the num like 1234 whatever, and then it takes them to the, to the table or the data set the."
        },
        {
          "speaker": "(5.24s - 5.81s) Suchi Dhir",
          "line": "Points exactly like you have in b five that talk where in fact in week five script what you have created, you can actually, you know, have a menu in the script where first option, yeah, displaying all the data and etc. Password table and second option will be only displaying the users with bin bash shell. So yeah, you know, your query, your, your script will be driven by the user. User can select option one or user can select options."
        },
        {
          "speaker": "(5.82s - 5.93s) Isaac PANG",
          "line": "Yes. So I guess the most important thing is picking a good website then that has enough data."
        },
        {
          "speaker": "(5.94s - 6.58s) Suchi Dhir",
          "line": "Yes, you can select the one which I have shared with you that CvE details if you want. Go ahead and do that. It's a very good website with lot of information and you know, best part is that you have a lot of time stacked. You have completed your work quite ahead. So you can actually, you know, combine data from multiple websites, from all three websites and fetch data and you can do aggregation of data and you can present, you know, very good queries to the user so that user can collectively see what user wants to see?"
        },
        {
          "speaker": "(6.58s - 6.63s) Isaac PANG",
          "line": "So you could do multiple websites if you wanted to."
        },
        {
          "speaker": "(6.64s - 6.76s) Suchi Dhir",
          "line": "Yes. You can increase the breadth of your data set by creating multiple websites."
        },
        {
          "speaker": "(6.79s - 6.99s) Isaac PANG",
          "line": "Okay. Yeah. Okay. Interesting assignment. It's a good assignment. It's more like a. Yeah, it's good. Need to have more of a think about how I'm going to approach it."
        },
        {
          "speaker": "(6.99s - 7.2s) Suchi Dhir",
          "line": "Interesting assignment. And there are some components that you have already done. You have done mega menu week three. So you know you have to use that script to create your menu. That will be fun."
        },
        {
          "speaker": "(7.2s - 7.21s) Isaac PANG",
          "line": "Yeah."
        },
        {
          "speaker": "(7.24s - 7.51s) Suchi Dhir",
          "line": "You have week five, awkward users accounts. So you know how to, you know how to read the table and how to create. How to. Yeah. How to display the values in ECC password table in the form of a table."
        },
        {
          "speaker": "(7.51s - 7.52s) Isaac PANG",
          "line": "Yes."
        },
        {
          "speaker": "(7.52s - 7.73s) Suchi Dhir",
          "line": "You have done that. You have so many other scripts like password check set password regex, sh, where you are checking the strength of the password. All these components will be part of your assessment."
        },
        {
          "speaker": "(7.74s - 7.93s) Isaac PANG",
          "line": "So would it be so in that instance, like the password check and I guess the password strength check. Is that something that you can incorporate to or is that."
        },
        {
          "speaker": "(7.94s - 8.06s) Suchi Dhir",
          "line": "Yes, you have to, if you want to have excellent grades in your assignments, you should incorporate all those elements."
        },
        {
          "speaker": "(8.07s - 8.21s) Isaac PANG",
          "line": "Oh, okay. So I assume like all the things we've covered, you want to try as best you can to implement into the script."
        },
        {
          "speaker": "(8.22s - 8.3s) Suchi Dhir",
          "line": "Yes. And if you can implement whatever you have learned, that will be really great."
        },
        {
          "speaker": "(8.31s - 8.46s) Isaac PANG",
          "line": "Yeah, yeah, yeah. Okay. That's interesting. I'll have to plan a bit more, I think, and then come up with exactly what I'm going to do."
        },
        {
          "speaker": "(8.47s - 8.79s) Suchi Dhir",
          "line": "Yes. And you know, it's going to take a lot of time for you to clean the data that you have scraped by writing statements, regular expressions. But I'm sure if you can spend some time, because you have good amount of time now only on that part. Rest of the part is very, very simple and easy."
        },
        {
          "speaker": "(8.8s - 8.83s) Isaac PANG",
          "line": "Yes. The rest is simple. Yeah."
        },
        {
          "speaker": "(8.84s - 8.96s) Suchi Dhir",
          "line": "Yes. And you'll get confident on regular expressions, said Grep. All these concepts will become very, very clear, you know?"
        },
        {
          "speaker": "(8.97s - 9.22s) Isaac PANG",
          "line": "Yeah. I'd say that I'm still not very, like, very good at them. Like, I guess I understand them, but in practice I'm not like far. You know what I mean? Like, because I haven't done it enough. Only those tasks."
        },
        {
          "speaker": "(9.22s - 9.3s) Suchi Dhir",
          "line": "I wouldn't say I'm not very, very good in that. Even I'm not very good in that effect."
        },
        {
          "speaker": "(9.3s - 9.31s) Isaac PANG",
          "line": "Yeah. Yeah."
        },
        {
          "speaker": "(9.31s - 9.43s) Suchi Dhir",
          "line": "Because there are various tools available. So whenever I have to write a regular expression, I, I check, you know, a tool."
        },
        {
          "speaker": "(9.43s - 9.44s) Isaac PANG",
          "line": "Yeah."
        },
        {
          "speaker": "(9.44s - 9.49s) Suchi Dhir",
          "line": "Again, you know, every time remembering the wild card characters."
        },
        {
          "speaker": "(9.5s - 9.73s) Isaac PANG",
          "line": "What? Yeah, very. It was actually quite overwhelming. The um, amount of like things that I was like oh my God, like it is."
        },
        {
          "speaker": "(9.73s - 10.18s) Suchi Dhir",
          "line": "But we have to refer a cheat sheet. There are cheat sheets available so, or at, the best thing is that there are tools to build your regular expression, to test your regular expression. You have to build your regular expression on those tools. The cheat sheets are also available. Open them and keep on looking. Even I don't remember if you ask me. I don't remember anything. I have to work on it. I can make it work but I have to spend some time on that."
        },
        {
          "speaker": "(10.18s - 10.24s) Isaac PANG",
          "line": "Yeah. Okay. Yeah. Pretty good to hear, I guess."
        },
        {
          "speaker": "(10.26s - 10.36s) Suchi Dhir",
          "line": "So that's something that you have to work on and you need to spend some time."
        },
        {
          "speaker": "(10.38s - 10.63s) Isaac PANG",
          "line": "Okay. What else? I don't think I have anything else. I mean the video you sent me, what was it describing the data like, you remember that YouTube video, the tutorial that one you sent?"
        },
        {
          "speaker": "(10.65s - 10.7s) Suchi Dhir",
          "line": "Yeah. I have sent you one video for web scraping."
        },
        {
          "speaker": "(10.73s - 10.87s) Isaac PANG",
          "line": "So I guess we have to kind of write a script similar to that to scrape the data for a chosen website. Is that correct?"
        },
        {
          "speaker": "(10.89s - 11.0s) Suchi Dhir",
          "line": "Exactly. So in fact what you have done, yeah, it should be the same way for scraping your webpage."
        },
        {
          "speaker": "(11.01s - 11.26s) Isaac PANG",
          "line": "So yeah, that tutorial, I know it was specific to that website that he was scraping on, but that, that kind of method, method, method will work for the current."
        },
        {
          "speaker": "(11.26s - 11.27s) Suchi Dhir",
          "line": "Yes."
        },
        {
          "speaker": "(11.27s - 11.32s) Isaac PANG",
          "line": "Yep. So just follow the same logic I guess."
        },
        {
          "speaker": "(11.33s - 11.34s) Suchi Dhir",
          "line": "Yes."
        },
        {
          "speaker": "(11.35s - 11.4s) Isaac PANG",
          "line": "Okay. So that's the one thing."
        },
        {
          "speaker": "(11.41s - 11.5s) Suchi Dhir",
          "line": "Yeah, that is the one which is saying. And you can use that one."
        },
        {
          "speaker": "(11.51s - 11.65s) Isaac PANG",
          "line": "Yeah. Okay. I'm gonna probably get on to writing that tomorrow I think. Seems like the most complicated part of the whole thing."
        },
        {
          "speaker": "(11.67s - 11.92s) Suchi Dhir",
          "line": "So that's quite simple. See it's a curl statement. Like you have done an Internet downloader, we basically a curl statement and then you should have a file where you are going to dump everything, what the curl brings."
        },
        {
          "speaker": "(11.94s - 12.04s) Isaac PANG",
          "line": "So just create a folder in the script directory."
        },
        {
          "speaker": "(12.07s - 12.32s) Suchi Dhir",
          "line": "Yeah, it can. Yes, you have to, not in the scripts directory, but it's just a curl statement. I'm saying curl and give the URL, the entire webpage will be scraped and you can store it into a file."
        },
        {
          "speaker": "(12.33s - 12.39s) Isaac PANG",
          "line": "Okay. Yep. So create a file for all this stuff."
        },
        {
          "speaker": "(12.39s - 12.6s) Suchi Dhir",
          "line": "Yeah, see it's a simple, very simple command for scraping webpage. I guess similar to that you have done an Internet downloader also. So you have learned the usage of curl command, right?"
        },
        {
          "speaker": "(12.6s - 12.61s) Isaac PANG",
          "line": "Yeah."
        },
        {
          "speaker": "(12.61s - 13.01s) Suchi Dhir",
          "line": "So that is what you have to write for your webpage. For web scraping you have to write curl. Then you have to specify the output file where you want to store the value which comes after downloading which comes from the URL and then you have to specify the URL which you want. Very simple. I mean, when you start working on it you will understand. It's a very simple thing."
        },
        {
          "speaker": "(13.01s - 13.1s) Isaac PANG",
          "line": "I think that's the one thing, yes, creping is easier."
        },
        {
          "speaker": "(13.1s - 13.38s) Suchi Dhir",
          "line": "That's just one or two lines. The difficult part is cleaning whatever you get from the web page, cleaning that and you know, just removing everything which is extra is very very tough because you have to understand said statements, regular expressions."
        },
        {
          "speaker": "(13.38s - 13.57s) Isaac PANG",
          "line": "Oh yeah, yeah, yeah, yeah. I'm starting to understand now why. Yeah, yeah, I understand. That would be a pain. Oh, that would take me ages."
        },
        {
          "speaker": "(13.59s - 13.75s) Suchi Dhir",
          "line": "Web scraping is this two or three lines of code? That's very simple. The problem comes when you start cleaning that data which you have got now."
        },
        {
          "speaker": "(13.76s - 14.04s) Isaac PANG",
          "line": "Yeah, sounds like a pain, but that's fine, I'll figure that out. It's okay. What was one other thing? Week six content. Would you recommend doing that before or after I finished the assignment?"
        },
        {
          "speaker": "(14.05s - 14.46s) Suchi Dhir",
          "line": "After you finish. Finish the assignment now. Spend good amount of time on the assignment, just don't do anything else. Stop doing. Yes, it's, you know, if you have completed week five, focus on your assignment once your first version of assignment is ready, when you have cleaned all the text and everything, then you start looking at week six, I guess only on your assignment."
        },
        {
          "speaker": "(14.47s - 14.59s) Isaac PANG",
          "line": "Yeah, yeah, cool. Because I did the quiz the other day, I said I think I still have one more to do, but I'll do that later."
        },
        {
          "speaker": "(14.61s - 15.19s) Suchi Dhir",
          "line": "Okay, so week six is completely, you know, different. It talks about different languages like Python, Perl, Ruby, and then you have some code. Yeah, dictionary attack. So you will learn about that, how to write a script in dictionary attack that you can do at the end, you know, once your assessment is ready. But you have to have at least one element in your assignment or one script either from Python or Perl or Ruby if you want to get excellent grades in your assignment."
        },
        {
          "speaker": "(15.19s - 15.21s) Isaac PANG",
          "line": "Oh really?"
        },
        {
          "speaker": "(15.22s - 15.76s) Suchi Dhir",
          "line": "Yeah, you have to write complete script in bash. But at least we will see whether you have included a python script or a ruby script or a Perl script, because that is what you are learning in week six. So I have seen in the past that some of the students, they, the chart component they use, you know, to implement, they use python to implement that. So you can do that, but not required. Now at least you write the basic script, complete it, it should be running, that's more important."
        },
        {
          "speaker": "(15.76s - 15.94s) Isaac PANG",
          "line": "So complete the like kind of the groundwork of it and then do week six and then come back and like add whatever the python or whatever type of language you want later at least."
        },
        {
          "speaker": "(15.94s - 15.98s) Suchi Dhir",
          "line": "Yeah. Yes. You can do that at the end."
        },
        {
          "speaker": "(15.98s - 16.71s) Isaac PANG",
          "line": "Okay, fine. That's fine. Yeah, yeah, that's fine. The other thing is like, I find that I do the tasks, like they take me about like a good amount of time and then I finish the task, but I still don't feel, I still don't feel like I'm proficient, do you know what I mean? Like, I feel like it takes like a lot more practice to, to get good at the, at this, you know, like even though I finished all the tasks and like, whatever, I still feel like I'm not like good, you know? You know, like I was wondering like what type of things that I can like, do to get, to get good at this, like scripting stuff."
        },
        {
          "speaker": "(16.72s - 17.84s) Suchi Dhir",
          "line": "Yeah, it's actually, if you want to work only on servers and if you want to like, you know, focus your career, you want to focus your career only on configuring the servers, then probably you may require to master bash scripting language. However, if you want to focus your career as a cybersecurity consultant, as an engineer analyst, or you want to enter into SoC, then in that case you just need to be understanding the basket because some of your firewall configuration files will be written in the form of a script. So if you are able to understand how to write the script, you are able to, you know, if a script is provided to you, if you're able to decode it, that's fine. That's completely fine. If you want to become a cyber security engineer, however, if you just want to enter into configuring servers, you know, configuring web server can figure it. Configuring Nginx server, writing the configuration files, then probably you will have to master this bash."
        },
        {
          "speaker": "(17.88s - 18.03s) Isaac PANG",
          "line": "Do you know much about, one area that interests me is penetration testing. Do you know much about like, about that area?"
        },
        {
          "speaker": "(18.05s - 18.58s) Suchi Dhir",
          "line": "Yes. So if you want to do penetration testing, there are tools you should focus on, you know, you should focus only on practicing those tools. Then in that case, whatever you have learned now, sufficient. It's completely sufficient. You don't need to spend more time, you know, on learning it. That's, that's my advice. And if you want, if you want to enter into the area of penetration testing, are you doing masters here or graduate?"
        },
        {
          "speaker": "(18.58s - 18.62s) Isaac PANG",
          "line": "I'm doing my master's, yeah."
        },
        {
          "speaker": "(18.63s - 19.57s) Suchi Dhir",
          "line": "So if you are doing your masters and along with that is that if you can join as a cybersecurity intern, you know, there are various opportunities which are available online as cybersecurity intern, you can look for them. They don't pay you a great salary. But you know, they give you very good book. Yeah. They give you the real life data of their clients. You will have to do penetration testing. You will have to test, you will have to go through the logs which they provide. You have to identify the anomalies in the log. So if you want to enter into that area, if that excites you, you can, you know, you can look for these kind of opportunities which are available. There are many, many opportunities available for cybersecurity intern. So if you can complete your internship, complete this master's course, that's very good. Excellent."
        },
        {
          "speaker": "(19.57s - 19.69s) Isaac PANG",
          "line": "Okay, I'll look to do that. And one question. Do you know much about the OFCP certification?"
        },
        {
          "speaker": "(19.71s - 20.27s) Suchi Dhir",
          "line": "Yeah, that is also good. I have never done that because I'm preparing for CEH, but that is also required. So for the companies. Yeah, for the organizations which want to implement some certifications. Sorry. Which wants to, you know, get the certificate, certification that they have done the testing properly, security testing. So for that, you know, that's good. You need to understand all the basic principles that owas follow to. For the security testing."
        },
        {
          "speaker": "(20.29s - 20.3s) Isaac PANG",
          "line": "Yeah."
        },
        {
          "speaker": "(20.34s - 20.54s) Suchi Dhir",
          "line": "This more into, I would say security testing of web servers, security testing of the applications which are available on the website. So more of that."
        },
        {
          "speaker": "(20.57s - 20.78s) Isaac PANG",
          "line": "Yeah, I've seen lots of our job descriptions. They have that kind of a prerequisite, that certification, the OSCP one for those penetration testing jobs. So I just thought I'd ask about."
        },
        {
          "speaker": "(20.78s - 21.37s) Suchi Dhir",
          "line": "That because now most of the organizations, you know, for them, after, after some of the security acts like Critical Infrastructure act, the Saukie act which has been proposed in Australia, after that, for most of the organizations now they're obliged to follow some of the security guidelines. For example, they have to get vulnerability assessment done. They, yeah, they should be certified from, you know, some good organizations like ovas, you are saying they should be certified from them. So the requirement is there in the industry. I see that, yeah."
        },
        {
          "speaker": "(21.37s - 21.5s) Isaac PANG",
          "line": "Okay, cool. Uh, I guess that's it. Um, pretty good. I guess we got a bit off topic with the assignment, but."
        },
        {
          "speaker": "(21.5s - 21.85s) Suchi Dhir",
          "line": "Yeah, we got off topic, but yeah, but is that, um. Just wanted to understand what you want in your career. So in case, if you are bending towards the side, penetration testing, vulnerability assessment, then in that case whatever you have learned till now is sufficient. So don't think that you need to spend more time and you have to become a master."
        },
        {
          "speaker": "(21.85s - 21.86s) Isaac PANG",
          "line": "Yes."
        },
        {
          "speaker": "(21.87s - 21.9s) Suchi Dhir",
          "line": "You would not be using it in real life."
        },
        {
          "speaker": "(21.91s - 21.95s) Isaac PANG",
          "line": "No. Yeah."
        },
        {
          "speaker": "(21.96s - 22.15s) Suchi Dhir",
          "line": "You are not going to configure, you are not going into configuration part. You will be reading the configuration files. Although to find out the errors, anomalies. So if you are able to understand that much, it's sufficient."
        },
        {
          "speaker": "(22.16s - 22.23s) Isaac PANG",
          "line": "Yeah. Okay, cool. No, that's. That's. That's really good insight. Thank you for that."
        },
        {
          "speaker": "(22.26s - 22.33s) Suchi Dhir",
          "line": "Great. Dan is. When can I book a call? Next week, Thursday?"
        },
        {
          "speaker": "(22.34s - 22.44s) Isaac PANG",
          "line": "Uh, yeah, next week, Thursday. 530. Sorry, I was, uh, having a nap. I missed your call."
        },
        {
          "speaker": "(22.45s - 22.54s) Suchi Dhir",
          "line": "Yeah. And then I had. Yeah, I'm having a lot of troubleshooting calls. Uh, so."
        },
        {
          "speaker": "(22.54s - 22.65s) Isaac PANG",
          "line": "No, that's fine. I remember you said you're doing the networking as well, so I assumed you had a lot to do."
        },
        {
          "speaker": "(22.67s - 22.77s) Suchi Dhir",
          "line": "Yeah. So I immediately asked another student. He said, yes, I'm available. So I thought. Let me finish that part."
        },
        {
          "speaker": "(22.77s - 22.92s) Isaac PANG",
          "line": "Yeah, that's completely fine. Don't worry about it. That's fine. Yeah, no problems at all. How are the other students. How are the other students going in the unit?"
        },
        {
          "speaker": "(22.93s - 23.22s) Suchi Dhir",
          "line": "Okay, I have, I would say, 20% of the students there who have completed week five. No, no, no, I'm sorry. Not 20 person. There are three students. Three students, including you? Three."
        },
        {
          "speaker": "(23.22s - 23.29s) Isaac PANG",
          "line": "Oh, right. Three who have completed. And how many students are there?"
        },
        {
          "speaker": "(23.32s - 23.37s) Suchi Dhir",
          "line": "There are around 23 students."
        },
        {
          "speaker": "(23.38s - 23.41s) Isaac PANG",
          "line": "21St. Okay."
        },
        {
          "speaker": "(23.42s - 23.5s) Suchi Dhir",
          "line": "And I have a group of students who are still struggling to complete week two."
        },
        {
          "speaker": "(23.5s - 23.52s) Isaac PANG",
          "line": "Yeah."
        },
        {
          "speaker": "(23.53s - 24.09s) Suchi Dhir",
          "line": "Yes. So I guess only after doing lot of motivation, only three of you could complete week five students who are on week three now, because I know students, they really suffer if they don't complete it early. Writing the script for the assessment is very, very difficult. It's not easy. So then. Yeah, it becomes very difficult. And they become stressed in the last minute, and I have lot of. And many troubleshooting calls in the last minute, which really becomes difficult."
        },
        {
          "speaker": "(24.1s - 24.2s) Isaac PANG",
          "line": "Yes. That does become difficult. Yeah, of course. No, that's fine. Yes."
        },
        {
          "speaker": "(24.21s - 24.3s) Suchi Dhir",
          "line": "And they don't end up learning anything. That's the problem. Unless and until a student files on their own."
        },
        {
          "speaker": "(24.3s - 24.31s) Isaac PANG",
          "line": "Yeah."
        },
        {
          "speaker": "(24.31s - 24.37s) Suchi Dhir",
          "line": "They find out the errors on their own. They cannot learn."
        },
        {
          "speaker": "(24.37s - 24.79s) Isaac PANG",
          "line": "I can imagine, yeah. Oh, well, doesn't matter. By next week's call, I guess I'll aim to, I don't know, ridden up the scraping stuff and have a website picked and starting to write my stuff. So we can talk about that in a bit more detail, I guess."
        },
        {
          "speaker": "(24.79s - 25.06s) Suchi Dhir",
          "line": "Yes. And if you have something to share with me, like your draft, you can do that. I look into your work and share my feedback. You can also upload it on GitHub. That's the best way. And I can look your work from there? Yes, sure."
        },
        {
          "speaker": "(25.07s - 25.12s) Isaac PANG",
          "line": "Okay, cool. Well, I guess that's all, isn't it?"
        },
        {
          "speaker": "(25.13s - 25.22s) Suchi Dhir",
          "line": "Yes. Okay, Zach. All the best. It's very good that you have computed week five."
        },
        {
          "speaker": "(25.22s - 25.23s) Isaac PANG",
          "line": "Thank you."
        },
        {
          "speaker": "(25.23s - 25.31s) Suchi Dhir",
          "line": "I'll speak to you next week. Focus on assessment completely. One week for assessment."
        },
        {
          "speaker": "(25.32s - 25.36s) Isaac PANG",
          "line": "Will. I will. Thank you very much. Sushi."
        },
        {
          "speaker": "(25.36s - 25.38s) Suchi Dhir",
          "line": "Bye bye. Take care. Have a great."
        },
        {
          "speaker": "(25.38s - 25.44s) Isaac PANG",
          "line": "Okay. Bye bye. Take care. Yeah. Goodbye. Good luck. See you. Bye."
        }
      ],
      "date": "2023-02-03T11:00:52.23264Z"
    },
    {
      "file_name": "f153b00c-93fa-45da-8829-a49ce5145633.wav",
      "file_url": "https://admin.lincfellow.com/v1/api/recordings/133747/f153b00c-93fa-45da-8829-a49ce5145633.wav",
      "duration": 735,
      "transcription": [
        {
          "speaker": "(0.02s - 0.03s) Isaac PANG",
          "line": "Hello?"
        },
        {
          "speaker": "(0.03s - 0.07s) Suchi Dhir",
          "line": "Hi, is that doctor Shuchi here? How are you doing?"
        },
        {
          "speaker": "(0.08s - 0.11s) Isaac PANG",
          "line": "Good, thank you. And how are you going?"
        },
        {
          "speaker": "(0.11s - 0.16s) Suchi Dhir",
          "line": "I'm doing great, yes."
        },
        {
          "speaker": "(0.16s - 0.71s) Isaac PANG",
          "line": "Okay cool. Yeah, I just had a few questions about my. Well I started writing my script and for some. Well obviously there's a reason, I just can't figure out what's wrong. It's not working properly to download the data and then from the website then clean it. I think there's a problem with my cleaning portion of the script. I've actually emailed it to you just about two minutes ago."
        },
        {
          "speaker": "(0.71s - 0.75s) Suchi Dhir",
          "line": "Yes, I'm sorry, I did now."
        },
        {
          "speaker": "(0.76s - 1.45s) Isaac PANG",
          "line": "Yep. So the main problem I'm having is I run this script, everything runs fine, it downloads the URL I'm using by the way, the website that you said that you sent to me, but I'm just using a different like vulnerability statistics, I'm using Android instead of the apple. So yeah, so it downloads the, what's it called, the curl function to get all the HTML data and then from there, I don't know, you can see my script if you're following."
        },
        {
          "speaker": "(1.47s - 1.65s) Suchi Dhir",
          "line": "Can you share the screenshots of the output like what you're getting? Do you want me to have a screen share session? Or if you want you can just share the screenshot with me through email."
        },
        {
          "speaker": "(1.65s - 3.25s) Isaac PANG",
          "line": "Yeah I can. It's pretty straightforward. What is happening is I would explain it first and then while I'm explaining take some photos and send them to you. What's happening is it's creating all of the files that I want it to create. So in this case if you have a look at the script, it's creating source code txt and temp txt source code txt is obviously the source code and then the temp txt is the meant to be, the filtered stuff. But what happens is when I use the cat command to look at both of those files, it works fine on the first one, the downloaded HTML data, but when I cat for the second one, it doesn't give me anything at all, it just, I go at that file and then I click enter and then it just like nothing. And then, you know, I can type another command. Let me just show you what I mean. I've been having a problem with that. Not sure why, but I think they've probably said something wrong that I'm doing. Have you been busy today?"
        },
        {
          "speaker": "(3.27s - 3.46s) Suchi Dhir",
          "line": "Yes, it has been like, you know, I have my schedule calls and then some troubleshooting calls, specifically, more specifically with GitHub and that's why I just shared one email with all of you."
        },
        {
          "speaker": "(3.46s - 3.48s) Isaac PANG",
          "line": "I saw that? Yeah."
        },
        {
          "speaker": "(3.49s - 3.54s) Suchi Dhir",
          "line": "So that use the commands correctly?"
        },
        {
          "speaker": "(3.54s - 3.75s) Isaac PANG",
          "line": "Yeah. Okay. Okay, so I just sent through the picture of what, I mean, like when I tap temp tXT, this is like no output."
        },
        {
          "speaker": "(3.91s - 3.97s) Suchi Dhir",
          "line": "Okay, so your temp txt file is blanken. So."
        },
        {
          "speaker": "(3.97s - 4.37s) Isaac PANG",
          "line": "Yeah, it's not actually. I'm not sure why though. Uh, I'm like, I can't seem to figure it out. That's just what I assumed, that it was probably blank. I was wondering if maybe you could just have a look at the script like that and see what's wrong with it."
        },
        {
          "speaker": "(4.41s - 4.84s) Suchi Dhir",
          "line": "Okay, so you are using, actually, and you are looking for some, you know, specific tags to filter the information. And then it goes to set and you're only selecting the year and table from that. Did you, did you individually run the commands? Like for example, just run grep e command first on the table that you have downloaded? Just running?"
        },
        {
          "speaker": "(4.88s - 4.98s) Isaac PANG",
          "line": "Yeah, I think I did that earlier and I was still getting, I was still getting blank."
        },
        {
          "speaker": "(5.01s - 5.28s) Suchi Dhir",
          "line": "That means the command is not working correctly. You'll have to, you'll have to create it properly again to see that, you know, which part is not working in that expression for stripping HTML will you need to build it?"
        },
        {
          "speaker": "(5.32s - 5.35s) Isaac PANG",
          "line": "Okay, because it's not working."
        },
        {
          "speaker": "(5.36s - 5.91s) Suchi Dhir",
          "line": "Yeah, you need to give me some time on this. If you want me to troubleshoot this, then you'll have to give me some time. Yeah. So by end of the day I'll be able to, you know, let me first troubleshoot this. Let me run these individually and see what's happening and provide you, I think instead of grep, if you use said structure, that would be much more better than grep. I think so. Yes. You said instead of grip."
        },
        {
          "speaker": "(5.92s - 5.99s) Isaac PANG",
          "line": "Okay, so maybe you said command. Yeah."
        },
        {
          "speaker": "(6.0s - 6.29s) Suchi Dhir",
          "line": "Yes, instead of grep. That's more efficient. When you work on, you know, parsing the files and cleaning the HTML tax. Yeah, that would be much more better. Rather than using your grip, I guess."
        },
        {
          "speaker": "(6.31s - 6.34s) Isaac PANG",
          "line": "Okay, I'll try."
        },
        {
          "speaker": "(6.34s - 6.57s) Suchi Dhir",
          "line": "I need to actually look into your HTML file, what you are getting, and then I need to just check the statement, what you are trying to match and what you are trying to delete. What should be the kind of output, you know, from, from this page."
        },
        {
          "speaker": "(6.58s - 6.63s) Isaac PANG",
          "line": "I essentially just want all the, what."
        },
        {
          "speaker": "(6.63s - 6.66s) Suchi Dhir",
          "line": "You, what you want, what you're stripping."
        },
        {
          "speaker": "(6.66s - 7.19s) Isaac PANG",
          "line": "Actually, I'm shipping the like table data. So it's like year in the y column and then like types of vulnerabilities across the top. And then it's like you can click on, you can click with the mouse, like the number of vulnerabilities within the table so essentially what I want is like, like if you click on that webpage, you'll be able to see what I mean. It's essentially like the big table with all the data on it. So I just want that startup on the page."
        },
        {
          "speaker": "(7.21s - 7.36s) Suchi Dhir",
          "line": "Can you quickly share your downloaded HTML file with me through email? I just wanted to understand what you're trying to filter."
        },
        {
          "speaker": "(7.37s - 7.41s) Isaac PANG",
          "line": "You want me to send the HTML."
        },
        {
          "speaker": "(7.41s - 7.45s) Suchi Dhir",
          "line": "Yes, HTML five."
        },
        {
          "speaker": "(7.46s - 7.55s) Isaac PANG",
          "line": "Yeah, it's whatever you really. Okay, email me."
        },
        {
          "speaker": "(7.55s - 7.67s) Suchi Dhir",
          "line": "I wanted to check the patterns, you know, I want to see the patterns and what kind of command you have used to clean your webpage."
        },
        {
          "speaker": "(7.68s - 7.74s) Isaac PANG",
          "line": "Yep, sure. I'm just coughing, coughing it now."
        },
        {
          "speaker": "(8.12s - 9.0s) Suchi Dhir",
          "line": "Today I have shared, you know, some said one liners, there is a link, you just go through that and I guess the first thing that can be done is cleaning up all the HTML tags using said one liner. That's a very good command to clean. It removes all the HTML tags and then create a temporary file from that. Now on that temporary file, you can select whatever you want, some of the tags and use awk to, you know, create columns. You cannot achieve, you cannot achieve this in one line. So with one line of code, you cannot achieve, you know, cleaning of the entire file. You have to create multiple, you can create multiple temporary files to ensure that, you know, cleaning process is very, very clean and clear for more clarity."
        },
        {
          "speaker": "(9.0s - 9.01s) Isaac PANG",
          "line": "Yeah."
        },
        {
          "speaker": "(9.01s - 9.14s) Suchi Dhir",
          "line": "So first step, clean all HTML tags. There is one you can use set command for that and clean knowledge."
        },
        {
          "speaker": "(9.14s - 9.22s) Isaac PANG",
          "line": "Yeah, I've got a set command for cleaning all the tabs tags. I just, yes."
        },
        {
          "speaker": "(9.22s - 9.67s) Suchi Dhir",
          "line": "Yeah. So do that. Put it in a temporary file, let's say tempfun TXT. Now again on that tempfun TXT, understand, you know, how you're going to, what kind of data you want to pick, the next kind of, you know, set command, whatever you want to grab, you just select that only and put it in other file. So something like that should be done, you know, series of commands will be there."
        },
        {
          "speaker": "(9.69s - 9.91s) Isaac PANG",
          "line": "Okay, sure. It's just not letting me send the HTML, it's quite long."
        },
        {
          "speaker": "(9.92s - 10.08s) Suchi Dhir",
          "line": "Let me do one thing, I will work on this and I'll share something on this. Give me some time, I need to."
        },
        {
          "speaker": "(10.08s - 10.11s) Isaac PANG",
          "line": "That'S okay, I don't mind. Yeah."
        },
        {
          "speaker": "(10.15s - 10.28s) Suchi Dhir",
          "line": "Now you have got good amount of time. So I look into your work and yash, suggest what changes you need to do into this."
        },
        {
          "speaker": "(10.28s - 10.42s) Isaac PANG",
          "line": "That's fine. Yeah, sure. So you recommend like first, for instance, like at each said command."
        },
        {
          "speaker": "(10.46s - 10.83s) Suchi Dhir",
          "line": "Yes. Like remove all the HTML tags using one command. And once that is done, then you grab whatever you want. For example, if you want, you know, information into different headings or different ways you can do that. Let me first look into the data and the file and probably I'll share my suggestions with you."
        },
        {
          "speaker": "(10.84s - 10.85s) Isaac PANG",
          "line": "Sure. Okay."
        },
        {
          "speaker": "(10.85s - 11.28s) Suchi Dhir",
          "line": "Yeah, I need to look into the file which you have got and use a Regex calculator, you know, to work on the subset of your file. Don't work on the complete set, just work on the subset of your file and just see whether your commands are working correctly. You're getting the correct answer. I think if you work on Regex checker online that would be better."
        },
        {
          "speaker": "(11.3s - 11.35s) Isaac PANG",
          "line": "Yeah, sure, I'll do that then. Cool."
        },
        {
          "speaker": "(11.35s - 11.47s) Suchi Dhir",
          "line": "Okay, so share your codes. Share, so you have shared the code with me. That's it. Give me some time, I'll reply."
        },
        {
          "speaker": "(11.47s - 11.57s) Isaac PANG",
          "line": "That's okay, no problem. Just. Yeah, let me know when you, when you're, when you're, when you're finished."
        },
        {
          "speaker": "(11.58s - 11.75s) Suchi Dhir",
          "line": "Yeah, sure, I will by end of the day. Let me just troubleshoot this and then let me first complete my calls. I do have some kind of calls."
        },
        {
          "speaker": "(11.77s - 11.85s) Isaac PANG",
          "line": "There's a lot to troubleshoot, I'm sure in that code. It probably, probably sucks."
        },
        {
          "speaker": "(11.87s - 11.91s) Suchi Dhir",
          "line": "It's going to take some good amount of time, this."
        },
        {
          "speaker": "(11.92s - 11.98s) Isaac PANG",
          "line": "Yeah, there's a lot of things clearly very wrong."
        },
        {
          "speaker": "(12.03s - 12.06s) Suchi Dhir",
          "line": "Then. Do you have any other queries?"
        },
        {
          "speaker": "(12.07s - 12.11s) Isaac PANG",
          "line": "No, that's the main one. Thanks."
        },
        {
          "speaker": "(12.11s - 12.15s) Suchi Dhir",
          "line": "Okay, sure. Thank you. Bye bye, take care."
        },
        {
          "speaker": "(12.15s - 12.2s) Isaac PANG",
          "line": "No worries. Thank you. Okay then. Bye bye."
        },
        {
          "speaker": "(12.2s - 12.21s) Suchi Dhir",
          "line": "Take care."
        },
        {
          "speaker": "(12.21s - 12.22s) Isaac PANG",
          "line": "Okay, bye."
        }
      ],
      "date": "2023-02-08T09:36:42.086853Z"
    },
    {
      "file_name": "bb2933bc-a817-4289-9baf-1f4247e4df99.wav",
      "file_url": "https://admin.lincfellow.com/v1/api/recordings/133969/bb2933bc-a817-4289-9baf-1f4247e4df99.wav",
      "duration": 1413,
      "transcription": [
        {
          "speaker": "(0.02s - 0.03s) Isaac PANG",
          "line": "Hello?"
        },
        {
          "speaker": "(0.03s - 0.06s) Suchi Dhir",
          "line": "Hi, is that, can you hear me now?"
        },
        {
          "speaker": "(0.07s - 0.12s) Isaac PANG",
          "line": "Yeah, yeah, I think there might be a problem with the connection."
        },
        {
          "speaker": "(0.12s - 1.72s) Suchi Dhir",
          "line": "Yeah, there is some issue with the Internet today, so I just shared the file with you. Please run it and you will get a text file. Now you have to investigate the text file properly. Look at the webpage, the link of the webpage that you have. Analyze both of them and try to find out some patterns, you know, in your text file. Accordingly. You will have to write a script. You will have to write some functions. For example, the webpage, the link that you have selected, it has a table, you know, which presents year wise number of vulnerabilities. The similar kind of information is present in your, in your text temp two text, which is which your script is generating. So what you have to do, you'll have to write a function and which creates a similar kind of table which is given on the webpage. And you have here you have number of vulnerabilities and different type of vulnerabilities. You have the variable, you know, like you have worked on oxcript and you have the variables for the title of your table and the rest of the information that will be filled. That has to be, you know, written as a function. You will have to use some commands to, you know, to read for the line by line from the text that you have generated. And then you have to identify wherever 2001 is written. Just pick up all information related to that year or something like that. It depends upon your output now, the kind of output that you are expecting."
        },
        {
          "speaker": "(1.72s - 1.77s) Isaac PANG",
          "line": "From your script, right?"
        },
        {
          "speaker": "(1.8s - 2.54s) Suchi Dhir",
          "line": "Yeah, I know one thing is that I'm planning to, because I'm having multiple queries, these kind of queries, and I'm stuck in troubleshooting, which is not possible with individual files. What I'm going to do is that I'll be sharing a sample web scraping project which is available on GitHub, and I'll also share some more small chunks of code there. It tells like how to do, how to, you know, select particular tabs from the HTML, like let's say if you're looking for a particular information in the text file which has been generated now. So I will share some chunks of code with all of you so that you can start working towards it."
        },
        {
          "speaker": "(2.55s - 2.73s) Isaac PANG",
          "line": "Okay, so just to be clear, you provided the, the, the code that you provided creates the temp two text, right?"
        },
        {
          "speaker": "(2.74s - 2.74s) Suchi Dhir",
          "line": "Yes."
        },
        {
          "speaker": "(2.74s - 3.01s) Isaac PANG",
          "line": "And in that it's been like partially cleaned, in that partially cleaned like text file, I don't see the, well, is that, has it been stripped of all the HTML tags?"
        },
        {
          "speaker": "(3.02s - 3.71s) Suchi Dhir",
          "line": "It has stripped all the HTML tags. It has also stripped all the spaces. You won't find any spaces or any other additional tags, but on the web page you have JavaScript. Also there are some functions, I didn't strip them off, you don't need to, okay, you have now it's a clean file, I would say not very clean. If you still want, you can have some more set statements to clean, few more things you'll have to look into, like for example anything that starts from function, you can look for it and you can delete it. You can write small, you know, set statements, statements for that. But if you want you can, you have some functions, JavaScript functions, if you want you can just delete them off, not a problem."
        },
        {
          "speaker": "(3.72s - 3.87s) Isaac PANG",
          "line": "Yeah, so I just find like the JavaScript and the anything starting with functions."
        },
        {
          "speaker": "(3.88s - 5.42s) Suchi Dhir",
          "line": "Functions, right. That needs to be stripped. You can, you know, do little research and strip further, you can clean it, make a temp three txt so, but I was, I was feeling that you can still work on this file as well, but if you want you can obviously delete those functions also. Now the next step that you have to take is you have to read this file line by line, like how you have done in your file name, and then probably you have to look for, let's say year wise, like it depends upon your query. So if you're looking for the number of vulnerabilities in 2001, so you can do that, you know, look for that information in the file by writing, writing a function for that, or the best way is, you know, write a function to again align, you know, convert this text into a CSV file. So if you can generate a CSV file which is comma separated values file, then you can, you'll have an Excel sheet similar to what has been shown here on the webpage. Okay. And then you can easily, you know, write your queries, you can easily fetch your information from that Excel because I found that in the text file there are still extra spaces which are there between the data. So that maybe, that maybe, you know, you have to clean or it's better that you again store it into a CSV file. Whatever text file is being given, you know, store it into a CSV file. So that is the next step of research that you will have to do."
        },
        {
          "speaker": "(5.44s - 5.85s) Isaac PANG",
          "line": "So once it's been like once I shift the JavaScript code and I've shipped anything, you know, starting with a function and it's all saved to, for example temp three txt from there, sorry, I didn't quite understand from there I create a function that, because it's already in the text file, isn't it?"
        },
        {
          "speaker": "(5.85s - 8.15s) Suchi Dhir",
          "line": "Yes. Then it is already. Yes. So you have all the information, what you see now, first you have to decide that what information do you want to use from here? Do you want to present the same table which is there on the page? The similar. So if you want a similar kind of table to be printed, then you can use op command. Then you do not need to store it into CSV directly. You can use off command. You have the headers of the table ready. You know, your number of vulnerabilities, all that is there. You will have to use some set commands to, you know, find out the particular number of year and just the number of vulnerabilities. Actually, if you look at the text file, you will be able to, you know, understand that how the information is presented. It's present, the information is presented linearly. You have to just pick it up using some set commands and, you know, put it inside the octave, which is not going to be a great challenge. I guess the only challenge will be that you will have to sit, you will have to analyze the pattern which is there in the text file, and accordingly you will have to write the, you know, right here, the code. I will do one thing, I will take small, small chunks with you where the information is present in the text file and how to pick it up and how to generate an AWK file. How to use AWk using that, I'll take, I'll share some small chunks with you, some, okay, you know, small chunk of code. So then you will have to say, because this is a little more cumbersome, you will have to analyze the pattern, how data is there inside your text file, how you can further, you know, make it more neat so that you're able to pick up the values correctly, so you can see that, you know, all the information. What you see here on the table, on the web page is present linearly. Linearly, in the sense in the first line, 2001 is there, then the next line, five, then one. Yes, like that, it is present. So now you will have to write a code so that you are able to read it and then present it in the, you know, wherever you want to store it. Obviously, if you're using AWK, then that information should be read from the table and should be, you know, press place below the columns."
        },
        {
          "speaker": "(8.17s - 8.19s) Isaac PANG",
          "line": "Yeah. Okay."
        },
        {
          "speaker": "(8.2s - 8.27s) Suchi Dhir",
          "line": "Yes. You will have to learn more of awk now after that."
        },
        {
          "speaker": "(8.27s - 8.37s) Isaac PANG",
          "line": "Yeah, so create the table with Awk and then pull the information from the table into the orc table."
        },
        {
          "speaker": "(8.38s - 8.57s) Suchi Dhir",
          "line": "Yes, that would be the best. If you can do that, then probably the next step will be generating like, you know, number of vulnerabilities in the year 2001. Something like that."
        },
        {
          "speaker": "(8.61s - 8.63s) Isaac PANG",
          "line": "Yes. Okay."
        },
        {
          "speaker": "(8.63s - 9.42s) Suchi Dhir",
          "line": "So the next steps, try to do some research and find out how to strip functions. And it's very simple. You will find out some commands functions and how to remove all the other stuff. Look, you know, analyze the information that is there in temp two txt very clearly and look at the web simultaneously. Open the webpage, analyze both of them so that you can make a relation between, you know, what has to be presented and what is there in the text file. Then start writing your code. You know, how to read line by line, how to pick up that from the text file, temp two text and how to insert it into Awk table, how to build that table using awk. That is your next job that you have to do."
        },
        {
          "speaker": "(9.45s - 9.51s) Isaac PANG",
          "line": "Okay. Okay sure, I'll give it a shot."
        },
        {
          "speaker": "(9.52s - 9.67s) Suchi Dhir",
          "line": "Yeah, I understand it's a little challenging task, but you know, you have to do this so that you can understand that, you know, this is how it's been created."
        },
        {
          "speaker": "(9.68s - 9.78s) Isaac PANG",
          "line": "Yes. Yeah, yeah, that's okay. I'll give it a shout, give it a shot. This week I'll try and figure it all out."
        },
        {
          "speaker": "(9.78s - 10.77s) Suchi Dhir",
          "line": "And that's the reason why I was requesting all of you to start it early because I know it requires time. And when you have time in hand you enjoy coding. And if you don't have time in hand, the stress makes you, you know, makes you make more errors actually. So you have time in hand. Is that give me some time. After my calls I'm having lot of troubleshooting, similar kind of issues. So after my call I'm planning to share web scraping project which is available on GitHub. That's first point. Second, I wanted to share some chunks of code so that you can understand how to scrape some important tags from the HTML file. Or if you have to print, read the text file and print an awk, create an awk, use an awk to create a table, how to do that. So some small chunks of code I'll share with all of you. Looking at that as a guidance, you can write your code."
        },
        {
          "speaker": "(10.78s - 10.89s) Isaac PANG",
          "line": "Okay. Yep, sure. Just, yeah, once you send it through I'll have a look and try and probably have a better idea."
        },
        {
          "speaker": "(10.9s - 11.47s) Suchi Dhir",
          "line": "Then you work on the stem two text. Try to remove more spaces. Okay. You can look for some spaces and just try to delete spaces. You can do that. If you remember in week four or week three when we did file name, sort, et cetera. We did remove some extra spaces which were there using grep command. Yeah, it was there. So try to remove extra spaces which are there. And I try to arrange it much more better so that you can immediately, you know, write some code and generate an octable."
        },
        {
          "speaker": "(11.49s - 11.54s) Isaac PANG",
          "line": "Yes, okay, sure. Okay. Okay."
        },
        {
          "speaker": "(11.55s - 11.93s) Suchi Dhir",
          "line": "This is an interesting thing that you will enjoy working on. The text file which I have generated now through this code is very, I mean, it's partially clean, it has some JavaScript functions. I didn't feel that, you know, we need to remove them. We can still write our code and we can use, but if you want to have a practice and make it more cleaner, you can do that."
        },
        {
          "speaker": "(11.93s - 11.99s) Isaac PANG",
          "line": "But you think, you think they're definitely to strip the function."
        },
        {
          "speaker": "(12.01s - 12.4s) Suchi Dhir",
          "line": "Yeah, it's not required, but you can have it, because what happens that all those extra information will add some more clutter. And when you are thinking, when you're trying to relate it to the webpage, it may add some confusion. So if you want, you can write some code to remove the JavaScript function. It's very simple. Wherever you have function, you'll have to look for the patterns in which the functions are present and then, you know, delete them."
        },
        {
          "speaker": "(12.41s - 12.59s) Isaac PANG",
          "line": "And then once I'm happy with how it's been cleaned from there, I do I, do I write a separate script or do I can, do I write it in the same script?"
        },
        {
          "speaker": "(12.6s - 12.74s) Suchi Dhir",
          "line": "See, write functions. Write the functions, you know, make a function, yeah, write a function like green HTML. Yes."
        },
        {
          "speaker": "(12.74s - 13.0s) Isaac PANG",
          "line": "So that's, I'll write a function to create an orc table of the, like, like a basic table with no data in it yet. And then separately I write something that's going to extract the data and put."
        },
        {
          "speaker": "(13.0s - 13.36s) Suchi Dhir",
          "line": "It in, see, you can have a function for cleaning HTML, another one for generating table. So when you are generating table, you should, you can read a, the data from the temp two or temp three exe file and populate the table with the data. So that function which is generating will, you know, populate the table as well."
        },
        {
          "speaker": "(13.37s - 13.39s) Isaac PANG",
          "line": "Okay."
        },
        {
          "speaker": "(13.39s - 13.57s) Suchi Dhir",
          "line": "Or if you want, you can have a static table, you know, which has only the headers. No, actually depends, you know, on the queries that you are creating."
        },
        {
          "speaker": "(13.58s - 13.6s) Isaac PANG",
          "line": "Yeah. Okay."
        },
        {
          "speaker": "(13.61s - 13.69s) Suchi Dhir",
          "line": "You do one thing first. You create this table. At least try to print this table which is available."
        },
        {
          "speaker": "(13.7s - 13.76s) Isaac PANG",
          "line": "So just write a table that's got the same rows and columns."
        },
        {
          "speaker": "(13.76s - 14.1s) Suchi Dhir",
          "line": "Yes, the same rows and columns and headers. Yes, same headers. So once you have the headers, obviously the octable headers, you're going to define it as variables. So using those variables, it will be much more easier for you to, you know, fetch the value from the off table. It will be easier. Then you can write multiple queries in your code."
        },
        {
          "speaker": "(14.12s - 14.14s) Isaac PANG",
          "line": "Okay. Okay."
        },
        {
          "speaker": "(14.16s - 14.56s) Suchi Dhir",
          "line": "Create the table first. And once you have, once your table is generated, you have all variables. It will be easier for you to write small statements too, like let's say if you want to find out number of total vulnerabilities in year 2022. So you have that, you know, you know the column, you know the variable, so it will be easier for you to look for the values."
        },
        {
          "speaker": "(14.56s - 14.95s) Isaac PANG",
          "line": "Yeah, fine, yeah, that's okay. I'll, I'll try and do that by the end of this week. Then try and get that, all the table written up at least. Um, but once I've done that and I've um, and I've, I've written the functions that, you know, the table has been created. Uh. Is that, that, is that it? Or do I, should I do something else as well?"
        },
        {
          "speaker": "(14.96s - 15.59s) Suchi Dhir",
          "line": "That's it. So that's, I mean this is the basic part. I would say. If you want to get this can fetch you very good grades. Now above, above this, you will have to obviously ensure that your script is secure. That will set you more marks. And then you, if you really want to get excellent and high distinction grade, then you can generate the charts which are provided at, you know, at the end of the page. So like vulnerabilities by ear, vulnerabilities by type. So if you can generate that chart by GNU plot or any other mechanism, maybe using Python language."
        },
        {
          "speaker": "(15.59s - 15.66s) Isaac PANG",
          "line": "Oh, you mean, you mean generate it as a graph, like a line graph or something?"
        },
        {
          "speaker": "(15.66s - 15.8s) Suchi Dhir",
          "line": "Yes, yes, yes. That also has extra, so it's not mandatory, but if you have that, definitely you'll get hyper function breaks."
        },
        {
          "speaker": "(15.8s - 16.32s) Isaac PANG",
          "line": "Okay. And just in terms of the general structure of the, of this thing, do you still, like, how do I put it? Like when the user executes script in the terminal, do you want them to then like enter a password and then a menu appears kind of similar to what. And then, yeah."
        },
        {
          "speaker": "(16.32s - 17.51s) Suchi Dhir",
          "line": "Yes. And you have to write the complete, I would say a bash application, I would name it as bash application. Like how you used to do earlier, you know, in other programming languages where you create a complete application. So there is a menu, user enters a password, enter, user sees the menu and user drives the complete flow of the, so let's say the first option of the menu will be download the data or scrape the data from the website. So when the user presses that you have the function ready for it, you have the function ready for it, right? So that function will execute. Second function will be display all the vulnerabilities until now in the form of table. So the table which we are talking about, that will be displayed number three. If you want to further, you know, refine the analysis path, you can have the number of vulnerabilities in particular number of year. So user types the year and it displays the vulnerabilities in that particular year. So you can have those three queries and number four display the chart."
        },
        {
          "speaker": "(17.54s - 17.69s) Isaac PANG",
          "line": "But in that menu, would you not need, would they not need to download it first before they are able to generate the table?"
        },
        {
          "speaker": "(17.7s - 17.98s) Suchi Dhir",
          "line": "Yes, they have to. So if they press option number four, that's the basic testing. You have to do that. No, you have to press first option and then all you can select this. So that's the base testing that you will have to do in your code. You'll have to make your script robust, interesting."
        },
        {
          "speaker": "(17.98s - 18.09s) Isaac PANG",
          "line": "Okay, sure. And this is all going to be in one big script then I assume."
        },
        {
          "speaker": "(18.11s - 18.24s) Suchi Dhir",
          "line": "You can see, you can create multiple scripts or you can just have one script and multiple functions."
        },
        {
          "speaker": "(18.25s - 18.51s) Isaac PANG",
          "line": "Because I'm wondering how if we were to do it in one script, how you would generate menu, would you not need to write that in a second script?"
        },
        {
          "speaker": "(18.52s - 18.58s) Suchi Dhir",
          "line": "Now you can have functions for generating menu also."
        },
        {
          "speaker": "(18.59s - 18.61s) Isaac PANG",
          "line": "Yeah, yeah."
        },
        {
          "speaker": "(18.61s - 18.89s) Suchi Dhir",
          "line": "You have done in your script. Now the main section is there and you're calling two functions. You can have that, but there are something like set password, get password, sorry, check password. All those scripts which you have created earlier, you can use them in this assessment."
        },
        {
          "speaker": "(18.91s - 18.92s) Isaac PANG",
          "line": "Yes."
        },
        {
          "speaker": "(18.92s - 19.19s) Suchi Dhir",
          "line": "And then you can also use, and then you can also use that regular expressions script that you have created to ensure that when the user is setting the password, the complexity of the password is maintained. So that also can be, yeah, I remember that one."
        },
        {
          "speaker": "(19.19s - 19.22s) Isaac PANG",
          "line": "I've got that code written."
        },
        {
          "speaker": "(19.23s - 19.36s) Suchi Dhir",
          "line": "Yes. So you have to use all of them. But first put all your energy in, you know, generating this table now."
        },
        {
          "speaker": "(19.36s - 19.43s) Isaac PANG",
          "line": "Yeah, I'm just going to focus on enough. I'll think about the other."
        },
        {
          "speaker": "(19.46s - 19.73s) Suchi Dhir",
          "line": "Yes. So just focus and just complete this part. And I will be sharing, obviously by end of the day I will be sharing some chunk of codes with all of you. You can look into that and probably on the similar lines you generate this table."
        },
        {
          "speaker": "(19.74s - 19.83s) Isaac PANG",
          "line": "Okay, sure. Yeah, that's good. Thank you for that. That was actually very, very helpful."
        },
        {
          "speaker": "(19.85s - 20.69s) Suchi Dhir",
          "line": "That's great, Isaac. And happy coding because this is an interesting part of the bash shell scripting unit. So I wish that you complete, that you, Amri, don't take stress, everything is available on Internet. You need to do little bit of searching and obviously when you write the course yourself, you will enjoy it. You will really find it useful. I did share your, you know, some notebooks, notes on awk, grep and set. Go through them first. And there is one link on set one liners you can use that you will find most of the one liners of set, you know, how to use set. So to successfully complete this, you basically need to have a very good knowledge on Sethe, if you know."
        },
        {
          "speaker": "(20.72s - 20.82s) Isaac PANG",
          "line": "Yeah, yeah. I find them fairly confusing. That's the problem. But it's okay."
        },
        {
          "speaker": "(20.84s - 21.08s) Suchi Dhir",
          "line": "That's why I'm telling more you use them and more you sit and, you know, it took some time for me to provide you with the answer, you know, because I was sitting for morning and I, I did that. So it takes time."
        },
        {
          "speaker": "(21.11s - 21.18s) Isaac PANG",
          "line": "Yeah. Okay, cool. How is everyone else going in the course?"
        },
        {
          "speaker": "(21.2s - 21.63s) Suchi Dhir",
          "line": "There are two students, including you. Nadavan has completed, has generated the table now. And he was also working on CVE details, the similar kind of website, but you are working on vendors and he's working on products. So he has generated this table today. I just spoke to him. So it's only two students, you and he, one more."
        },
        {
          "speaker": "(21.64s - 21.66s) Isaac PANG",
          "line": "Okay. Yeah."
        },
        {
          "speaker": "(21.7s - 21.73s) Suchi Dhir",
          "line": "Others have not started yet."
        },
        {
          "speaker": "(21.74s - 21.83s) Isaac PANG",
          "line": "Okay. Okay. Okay. So I'm competing with this one guy, then I've got to try and beat this guy."
        },
        {
          "speaker": "(21.84s - 22.16s) Suchi Dhir",
          "line": "Yes. And there is one interesting, you know, again, very interesting website. One of the students is working on that. The entire Excel sheet is available there to download. So he's downloading directly from the excel sheet the entire data and working on it. That's quite simple and easy."
        },
        {
          "speaker": "(22.18s - 22.22s) Isaac PANG",
          "line": "Yeah. Okay, cool."
        },
        {
          "speaker": "(22.22s - 22.34s) Suchi Dhir",
          "line": "So that is also. Yes, but you work on this because you have chosen this, so you can work on this website."
        },
        {
          "speaker": "(22.36s - 22.39s) Isaac PANG",
          "line": "Okay. All good."
        },
        {
          "speaker": "(22.41s - 22.5s) Suchi Dhir",
          "line": "Great. Then in a sec I'll book a call next week and you can reach out to me through email."
        },
        {
          "speaker": "(22.52s - 22.59s) Isaac PANG",
          "line": "Yeah, next week, same time, once I. That's okay."
        },
        {
          "speaker": "(22.59s - 22.6s) Suchi Dhir",
          "line": "Yeah."
        },
        {
          "speaker": "(22.6s - 22.79s) Isaac PANG",
          "line": "I'll try and generate this table. Once I've done that, then I'll probably be in contact with you about next steps. But I've written them down so I'll probably need some clarification."
        },
        {
          "speaker": "(22.79s - 23.29s) Suchi Dhir",
          "line": "Sure you can. And spend some time in analyzing the temp two text that has been generated and the webpage together so that you can understand the data which is present in Template TXT. Once you understand the data which is present, you'll be able to write the, you know, convert it into the script easily. You will understand. Okay. I need this kind of set statement to pick up the data from this line. So first, spend some time in analyzing temp two text."
        },
        {
          "speaker": "(23.31s - 23.34s) Isaac PANG",
          "line": "Sure, that's fine. I'll do that first."
        },
        {
          "speaker": "(23.36s - 23.41s) Suchi Dhir",
          "line": "Okay. Bye bye. Take care. Have a great evening."
        },
        {
          "speaker": "(23.41s - 23.44s) Isaac PANG",
          "line": "Thank you very much. Shuchi, have a good."
        },
        {
          "speaker": "(23.44s - 23.47s) Suchi Dhir",
          "line": "You're welcome. You too, have a great."
        },
        {
          "speaker": "(23.49s - 23.51s) Isaac PANG",
          "line": "Thank you. Okay, bye."
        }
      ],
      "date": "2023-02-09T09:44:47.227431Z"
    },
    {
      "file_name": "6df80361-9f06-4e1c-b483-45db0414a52b.wav",
      "file_url": "https://s3-ap-southeast-2.amazonaws.com/linc-recordings/6df80361-9f06-4e1c-b483-45db0414a52b.wav",
      "duration": 1020,
      "transcription": [
        {
          "speaker": "(0.03s - 0.04s) Isaac PANG",
          "line": "Hello."
        },
        {
          "speaker": "(0.05s - 0.1s) Suchi Dhir",
          "line": "Hi, Isaac. Doctor Shuchi here from ECU. How are you doing?"
        },
        {
          "speaker": "(0.11s - 0.13s) Isaac PANG",
          "line": "Good, thank you. And yourself?"
        },
        {
          "speaker": "(0.13s - 0.25s) Suchi Dhir",
          "line": "I'm doing great, thanks for asking. How is your progress? Is that on your studies?"
        },
        {
          "speaker": "(0.27s - 1.91s) Isaac PANG",
          "line": "Good, yeah, yeah. So I'm about 75% of the way through the second. Well, the assignment. And so, yeah, what I was going to ask was, I'll send it to you when I'm done. So I was just going to ask this, like, if you could give me some advice on the way I'm doing it right now. I figured what I'm doing right now is I just wrote an introduction and then I went on and I picked like three Siem kind of solutions for the first scenario. And what I did was, if you see in like this step two, the outline, it says, compare the capabilities, so the hardware requirements, the licensing options and platforms. What I did was I went like, for example, like the first one was splunk. And I went through each of those dot points and explained like hardware requirements or licensing options. And then I did that for each like Siem solution that I picked. And then I was going to after that, like, based on what I talked about, the capabilities and the requirements and whatever, which one of those would be the most appropriate for the. So that's, that's where I'm up to now. I'm up to step three. So I'm pretty much finished. I've just got to finish up that one. But what do you think about that kind of structure? Is that okay?"
        },
        {
          "speaker": "(1.92s - 2.15s) Suchi Dhir",
          "line": "Yeah, that's fine. But when you start after introduction, just give a detailed, you know, discuss advantages and disadvantages of SoC and same solutions. Both of what?"
        },
        {
          "speaker": "(2.15s - 2.16s) Isaac PANG",
          "line": "Sorry."
        },
        {
          "speaker": "(2.17s - 2.35s) Suchi Dhir",
          "line": "Of SoC and same in general. So what is sock and what is same and advantages and disadvantages with respect to the chosen scenario. Yes, hi."
        },
        {
          "speaker": "(2.35s - 2.36s) Isaac PANG",
          "line": "Sure."
        },
        {
          "speaker": "(2.36s - 2.64s) Suchi Dhir",
          "line": "Right. So when you do that, you are in turn, you know, just doing a feasibility analysis of the best solution for the organization, for the scenario. So that is something which you can include and rest. Looks good."
        },
        {
          "speaker": "(2.65s - 2.95s) Isaac PANG",
          "line": "Yep. So the advantages and disadvantages. The other thing is I've got three like CM solutions and no, none of the other, because I felt like that CM was more appropriate for the scenario. Is that okay? Or do I need to have."
        },
        {
          "speaker": "(2.96s - 3.71s) Suchi Dhir",
          "line": "That's fine. You can have three to five. Three is fine. Is that. But you know, whatever you are proposing, let's say, if you are comparing logarithm with, let's say, splunk, so they both are different type of, you know, logarithm is open source and splunk is commercial theme solution. So don't do that mistake of comparing heterogeneous solutions. I would rather suggest that compare, if you're picking up open source, then compare three open source solutions. If you are picking up commercial, select three commercial solutions and compare between them."
        },
        {
          "speaker": "(3.73s - 3.94s) Isaac PANG",
          "line": "Right. Yeah, because right now I've got splunk, I've got IBM Qradar, and then I've also got logarithm. So you don't recommend having logarithm in there."
        },
        {
          "speaker": "(3.96s - 4.31s) Suchi Dhir",
          "line": "Yeah, because logarithm is open source and splunk is commercial. You know, same solution. So they both are different. So whether you want you, you are suggesting open source solution to the organization or commercial, you have to be very clear, they have different features."
        },
        {
          "speaker": "(4.33s - 4.34s) Isaac PANG",
          "line": "Yeah."
        },
        {
          "speaker": "(4.36s - 4.52s) Suchi Dhir",
          "line": "So that is something that you need to. Yeah. Because you cannot compare two heterogeneous solutions. You know, they are totally different."
        },
        {
          "speaker": "(4.54s - 4.61s) Isaac PANG",
          "line": "Yeah. Okay. I'm just writing that down. That's fine."
        },
        {
          "speaker": "(4.62s - 4.78s) Suchi Dhir",
          "line": "Doesn't make more sense when you start comparing different types of solutions together. So, yeah, that is something you need to be clear on."
        },
        {
          "speaker": "(4.79s - 4.98s) Isaac PANG",
          "line": "Okay, I will, yeah, I'll change that up then. That's fine. Yeah. So once I do that, I'll probably send through my draft to you, my first draft, if that's okay."
        },
        {
          "speaker": "(4.98s - 5.51s) Suchi Dhir",
          "line": "Yes, you can. And ensure that whatever you are suggesting, for example, if you are suggesting same tool, recommending same tool to the organization, you should have proper justification. You should also think about how to operate this and any other changes that are required. So you know, in a paragraph you have to explain that part. Also you have to justify that if you are selecting same solution for the chosen scenario, how well does it relate to it?"
        },
        {
          "speaker": "(5.52s - 5.77s) Isaac PANG",
          "line": "Yeah, the other thing is we're not really given much info on their infrastructure like this scenario, I guess. So you can kind of assume with the hardware that they're going to have to buy all of the stuff. Is that correct?"
        },
        {
          "speaker": "(5.78s - 7.03s) Suchi Dhir",
          "line": "Yes. You don't need to assume that it's not required. If you look, some important points are mentioned in the, for example, they do have local servers, data center servers, cloud services and windows endpoints. These are something important. You can imagine like, you know, data center servers, local servers, which means that the amount of logs that would be generated from this going to be huge. Even though. Would be huge. Would be huge. So your scene tool, whatever scene tool you are employing, you have to check whether open source theme solutions have capability to handle such load of data. Or you have to also understand whether, you know, whether 24 byte security monitoring would be possible with huge amount of data that data center servers, local servers are going to generate so that critical analysis has to be part of your report."
        },
        {
          "speaker": "(7.05s - 7.07s) Isaac PANG",
          "line": "Yeah. Okay."
        },
        {
          "speaker": "(7.09s - 8.67s) Suchi Dhir",
          "line": "It's not the only employees, 3000 employees. More than that, you have to focus on different devices from which the data is going to be generated. They are saying data center servers, which means that there is a data center, which means that it's going to be a good organization where lots of, they have a website, they have lot of data generation happening. So because unless until that kind of situation is there, data center server won't be there. So they must be having databases, they must be having web servers. So nginx servers. So there would be so many logs. There would be database logs coming from web server logs. So which same solution is going to cater this huge amount of data, whether open source is good solution or a commercial one? If you are choosing a commercial, commercial one, you need experts to do 24 by seven monitoring, you know, so how to do that, would you require a soc in this case? Because they have data center and it means, it itself means that, you know, there would be a lot of data being generated, backup is required. So do you think that SoC would be required along with C tool and like that, you have to do critical analysis. That critical analysis should be visible in your reports."
        },
        {
          "speaker": "(8.69s - 8.78s) Isaac PANG",
          "line": "Should you just, should we just have a full section for like a critical analysis or just throw out."
        },
        {
          "speaker": "(8.79s - 10.16s) Suchi Dhir",
          "line": "No. In introduction, there would be little critical analysis where you would be actually, you know, analyzing whether SOC is good or seam is good. And you know, there is something called as co managed SoC or same solutions. In co managed SoC solution, the vendors, there are various vendors across Australia which provide the co managed SoC services where they can actually, they can collaborate with the organization and on the basis of terms and conditions they can, example, the same tool would be installed in the premises. There would be no in house SoC. But these vendors, they will be providing experts who can come in, who can do the security monitoring, can check the logs. So those kind of services are also there. So you need to critically analyze, just don't think in one direction that, you know, you explain what you're saying and then provide a comparison between Siem and SoC and just do comparison between any tools or solutions which are available. They are categorized. You know, you have a cloud based theme also available."
        },
        {
          "speaker": "(10.18s - 10.19s) Isaac PANG",
          "line": "Yeah."
        },
        {
          "speaker": "(10.19s - 10.44s) Suchi Dhir",
          "line": "You don't need in house theme. So you cannot compare a cloud based theme solution with commercial scene solution. All those things you will have to, you know, keep in mind."
        },
        {
          "speaker": "(10.46s - 10.93s) Isaac PANG",
          "line": "So maybe it's best if I don't have like, well, right now what I've got is I split up the three solutions that I've got with each solution, like talking about what they do and the dot points covered in step two. And then I was going to go on to explain which one would be best. Do you think that's an okay way to go about it or not?"
        },
        {
          "speaker": "(10.96s - 12.86s) Suchi Dhir",
          "line": "That's fine, but not a very mature report. That's fine. But if you really want high distinction rates and want to learn, obviously. So the best approach would be to do critical analysis on understanding whether SoC is suitable or SIEM is suitable. Second, if you have decided, let's say SiEM, then doing a critical analysis on what type of scene would be better. So either cloud based or hybrid would be better, or commercial open sales, do critical analysis. Let's say after critical analysis, you coined down to cloud based same solutions, then describe in detail components of, in general, cloud based solutions that what are cloud based same solutions, what kind of functionalities do they provide and how those functionalities are implemented. Then just in a table, compare three mainstream solutions which provide cloud based services on some common parameters. You don't need to explain individually what each of them provide because you have already done a very mature analysis and you have refined your analysis to a point where you know that you are going to provide only cloud basing and you are not doing any comparison into different. For example, when you are buying a car, you know that you have to go for hatchback and you compare hatchbacks different, you know, rather than comparing a hatchback with a sedan or any other cars. So that becomes heterogeneous comparison because you cannot then make up your mind and they themselves belong to different categories. So, so it's like that, you know."
        },
        {
          "speaker": "(12.88s - 12.99s) Isaac PANG",
          "line": "Okay, yeah, sure. That's okay. I'll do that. I'll just change it up a little bit."
        },
        {
          "speaker": "(12.99s - 13.15s) Suchi Dhir",
          "line": "I think what you have done is also good. Is that, but that, that is not very mature and definitely."
        },
        {
          "speaker": "(13.16s - 13.21s) Isaac PANG",
          "line": "Yeah, yeah, right."
        },
        {
          "speaker": "(13.21s - 13.89s) Suchi Dhir",
          "line": "And the most important thing, again, as I always advise, is that assignments are also a way to learn, you know, so that's a pretty reason I keep on discussing about the assignments in detail, you know, the requirements, because this is also an important learning point where you're understanding the different solutions which are available and how to do the critical analysis and reach out to and suggest the best solution. Add more references. Whatever you are suggesting, there is no right or wrong answer to this report. Whatever you are suggesting should be supported very well with references."
        },
        {
          "speaker": "(13.91s - 14.05s) Isaac PANG",
          "line": "Yeah, I noticed in the marking guide there's no marks for references. So are we still expected to put in our references?"
        },
        {
          "speaker": "(14.06s - 14.24s) Suchi Dhir",
          "line": "As APa seven, you have to. You have to. Because that would be part of your. You know, the part of your analysis, how well you are supporting it."
        },
        {
          "speaker": "(14.26s - 14.29s) Isaac PANG",
          "line": "Yeah, sure. That's okay."
        },
        {
          "speaker": "(14.3s - 14.58s) Suchi Dhir",
          "line": "Directly. Directly. Because what happens, it takes up the major chunk of the grades, you know, if we go points for references. So we have seen off late that, you know, it doesn't make more sense. So that is part of the assignment. It has to be there."
        },
        {
          "speaker": "(14.58s - 14.6s) Isaac PANG",
          "line": "Yeah, that's okay."
        },
        {
          "speaker": "(14.64s - 14.82s) Suchi Dhir",
          "line": "And then once you complete this. Once you complete this, you have to work on splunk. So did you complete your activity? Lab activity?"
        },
        {
          "speaker": "(14.84s - 14.87s) Isaac PANG",
          "line": "Yes, I think I did. Yeah."
        },
        {
          "speaker": "(14.89s - 14.98s) Suchi Dhir",
          "line": "Okay, great. How are you finding this plank tool? Is it manageable? Is it."
        },
        {
          "speaker": "(15.0s - 15.06s) Isaac PANG",
          "line": "Yeah, manageable. Yeah. Yeah."
        },
        {
          "speaker": "(15.06s - 15.74s) Suchi Dhir",
          "line": "That's good. That's good. I will be sharing some instructions regarding assessment three as well. Just waiting, you know, few more days. Yeah, for that. That assignment, Zach, lab is important. You have to sit on Splunk and you have to do the investigation. But I. Equally important is your. No. Working on splunk, so I will."
        },
        {
          "speaker": "(15.76s - 15.87s) Isaac PANG",
          "line": "Sorry, you just cut out the whole time you were saying. What's equally important as kill chain."
        },
        {
          "speaker": "(15.87s - 16.28s) Suchi Dhir",
          "line": "Understand? Kill chain. Lockheed Martin kill chain. And then your mitre, ATT and CK framework, because you have to align your investigation with these frameworks and kill chain, and then provide a detailed diagram, you know, about your different phases of these chains and the framework."
        },
        {
          "speaker": "(16.29s - 16.31s) Isaac PANG",
          "line": "Yeah. So."
        },
        {
          "speaker": "(16.31s - 16.51s) Suchi Dhir",
          "line": "So your investigation should be complete at least by end of week five so that you can focus on kill chain and mitre diagnostic, book, align your investigation, then write the reports."
        },
        {
          "speaker": "(16.53s - 16.55s) Isaac PANG",
          "line": "Yeah, okay, I'll do that."
        },
        {
          "speaker": "(16.56s - 16.64s) Suchi Dhir",
          "line": "Okay, so I will. I'll definitely keep guiding. So can I book our call next week? Same time?"
        },
        {
          "speaker": "(16.65s - 16.68s) Isaac PANG",
          "line": "Same time. 05:00. Friday."
        },
        {
          "speaker": "(16.68s - 16.71s) Suchi Dhir",
          "line": "Yes, 05:00, right?"
        },
        {
          "speaker": "(16.71s - 16.74s) Isaac PANG",
          "line": "Yeah, son. Yeah, no worries."
        },
        {
          "speaker": "(16.75s - 16.78s) Suchi Dhir",
          "line": "Great. I'll speak to you next week. All the best."
        },
        {
          "speaker": "(16.78s - 16.87s) Isaac PANG",
          "line": "Okay. Yeah, I'll email you my thing when I'm finished. It should be in a few days."
        },
        {
          "speaker": "(16.88s - 16.91s) Suchi Dhir",
          "line": "Sure. Definitely. No worries."
        },
        {
          "speaker": "(16.91s - 16.97s) Isaac PANG",
          "line": "Cool. Thank you very much. Okay. Thanks for your call. Bye."
        }
      ],
      "date": "2023-05-19T09:01:50.09876Z"
    },
    {
      "file_name": "8319bc09-9635-4d8e-a126-1ea969ed4e2b.wav",
      "file_url": "https://s3-ap-southeast-2.amazonaws.com/linc-recordings/8319bc09-9635-4d8e-a126-1ea969ed4e2b.wav",
      "duration": 226,
      "transcription": [
        {
          "speaker": "(0.02s - 0.03s) Isaac PANG",
          "line": "Hello."
        },
        {
          "speaker": "(0.04s - 0.09s) Suchi Dhir",
          "line": "Hi, Zach. Doctor Shuchi here from ECU. How are you doing?"
        },
        {
          "speaker": "(0.09s - 0.12s) Isaac PANG",
          "line": "Hi, how are you going? You all right?"
        },
        {
          "speaker": "(0.12s - 0.32s) Suchi Dhir",
          "line": "I'm doing great, yes, thank you. So how is your progress, Zach? Your assessment is complete, the second one. So did you start working on assessment three?"
        },
        {
          "speaker": "(0.33s - 0.61s) Isaac PANG",
          "line": "No, I haven't finished. I haven't started assessment three. I've just been adding my final touches. Pretty much finished the assessment two now. I was just, like, editing it this week and making sure it was all okay for submission. So I'll get started on this week, this weekend."
        },
        {
          "speaker": "(0.63s - 0.76s) Suchi Dhir",
          "line": "Okay, that's good. And your lab activities on Splunk, have you started working on that?"
        },
        {
          "speaker": "(0.77s - 1.0s) Isaac PANG",
          "line": "No, I didn't end up doing this week's lab activities yet. I'll also do that this weekend. Yeah, I've pretty much just been, like, finishing and editing my assignment, making sure it's all okay."
        },
        {
          "speaker": "(1.01s - 1.89s) Suchi Dhir",
          "line": "Okay. So I did share, you know, once you complete your assessment two and start working on assessment three, I did share, you know, two emails which are related to assessment three. In the first email, I did share some videos. There are four parts of those videos, and those parts are related to the lab activity that you would be doing in week four as well. So, because in week four, you'll be working on version one data set. So you can go through those videos and they will help you in understanding the requirement of assessment tree. So the similar way how the. You know, those videos, the similar way you have to investigate the attack in bots version three data sets, right?"
        },
        {
          "speaker": "(1.89s - 2.02s) Isaac PANG",
          "line": "Yes. Yep. So you can finish week three and fours activities before starting assessment three?"
        },
        {
          "speaker": "(2.02s - 2.04s) Suchi Dhir",
          "line": "Yes."
        },
        {
          "speaker": "(2.05s - 2.06s) Isaac PANG",
          "line": "Yeah."
        },
        {
          "speaker": "(2.07s - 3.1s) Suchi Dhir",
          "line": "And then. And then for assessment three, I have shared another email that is groundwork which is required for assessment three. So the trails of, you know, in the data set, you may find that there are some trails of hacking an AWS server in bots version three data set. So before you start working on assessment, re investigating the data set, it would be wise if you can actually understand what is AWS environment, what is its architecture, what are different components and how those, you know, the vulnerabilities that can exist and how those vulnerabilities can be exploited. So I did share some articles with you. Please go through them. They would be really helpful for you to understand the scenario and also understand the indicators of compromises that you would be looking at in the data set."
        },
        {
          "speaker": "(3.11s - 3.37s) Isaac PANG",
          "line": "Sure. Yeah, I can do that. Yeah, I'm going to do all of that this weekend. So I guess I will email you if I have any problems with it, but I think I'm on the right track. So far at the moment."
        },
        {
          "speaker": "(3.38s - 3.54s) Suchi Dhir",
          "line": "Great. So in any case, I'll book our call for the next week. Is that in case, if there would be some requirement, we can have a quick discussion during that time."
        },
        {
          "speaker": "(3.54s - 3.59s) Isaac PANG",
          "line": "Not a problem. Yeah, not a problem at all. That's great."
        },
        {
          "speaker": "(3.59s - 3.64s) Suchi Dhir",
          "line": "Great. Then. Good evening. Sorry. All the best."
        },
        {
          "speaker": "(3.64s - 3.72s) Isaac PANG",
          "line": "And I'll speak to you. No worries. Thank you, Shuchi. All right, have a. Have a good night. See you later."
        },
        {
          "speaker": "(3.73s - 3.74s) Suchi Dhir",
          "line": "Bye."
        }
      ],
      "date": "2023-05-26T09:00:28.653012Z"
    },
    {
      "file_name": "db044153-2dfc-4157-9d47-76156fd68515.wav",
      "file_url": "https://s3-ap-southeast-2.amazonaws.com/linc-recordings/db044153-2dfc-4157-9d47-76156fd68515.wav",
      "duration": 231,
      "transcription": [
        {
          "speaker": "(0.03s - 0.03s) Isaac PANG",
          "line": "Hello."
        },
        {
          "speaker": "(0.03s - 0.08s) Suchi Dhir",
          "line": "Hi, is that doctor Shuchi here from. How are you doing?"
        },
        {
          "speaker": "(0.08s - 0.12s) Isaac PANG",
          "line": "I'm good, thank you. Shuchi, how are you?"
        },
        {
          "speaker": "(0.12s - 0.23s) Suchi Dhir",
          "line": "I'm doing great. Is. That's good. How's your progress? Were you able to complete that snort activity?"
        },
        {
          "speaker": "(0.23s - 0.43s) Isaac PANG",
          "line": "Yeah, yeah, I managed to finish all of week three's content this week. So this weekend I aim to complete week four so I can start on assessment three. So that's kind of where I'm at at the moment."
        },
        {
          "speaker": "(0.43s - 0.51s) Suchi Dhir",
          "line": "Have you started working on assessment to assessment two?"
        },
        {
          "speaker": "(0.51s - 0.61s) Isaac PANG",
          "line": "Yes, I finished assessment too. Like the. I finished it a week ago."
        },
        {
          "speaker": "(0.62s - 0.65s) Suchi Dhir",
          "line": "Okay, that's great. So yeah, I'm just."
        },
        {
          "speaker": "(0.65s - 0.74s) Isaac PANG",
          "line": "I'm just ready to submit it when I'm. When I'm. I'll just. Can submit it tonight even if you want."
        },
        {
          "speaker": "(0.75s - 0.87s) Suchi Dhir",
          "line": "Okay. Yes, that would be great. You can do that. So how are you finding the assessment tree? Any queries on assessment tree?"
        },
        {
          "speaker": "(0.88s - 1.18s) Isaac PANG",
          "line": "Well, honestly, I haven't started it yet. Just because I remember you saying that you need to complete week four first, so. Well, this week I finished week three and then this weekend I aim to finish week four. So I'll be able to start assessment three probably on Sunday."
        },
        {
          "speaker": "(1.19s - 1.82s) Suchi Dhir",
          "line": "Okay, that's really good for assessment three. Is that before you start, as you mentioned, you have to complete week four. There are lab activities based on Splunk where you would be analyzing version one, version two data sets. And I did share some videos. Please go through them. The four videos, part one, part two, part three. They will help you in understanding how to align the ATT and Ck to the kill chain and mitre framework. That's the major requirement for your assessment tree. Next, you have to complete the groundwork. I did share some articles with you."
        },
        {
          "speaker": "(1.83s - 1.84s) Isaac PANG",
          "line": "Yeah."
        },
        {
          "speaker": "(1.84s - 2.34s) Suchi Dhir",
          "line": "And so please complete that because the version three data set is having a scenario of hacking of AWS server. So you need to understand the AWS environment, how it works, different components of AWS environment, and obviously the vulnerabilities that exist and how those vulnerabilities can be exploited. So if you go through all that, your investigation becomes more meaningful and more."
        },
        {
          "speaker": "(2.38s - 2.41s) Isaac PANG",
          "line": "Yeah, perfect. Yeah. Well, I'll do that. Yeah."
        },
        {
          "speaker": "(2.42s - 3.08s) Suchi Dhir",
          "line": "And I would be sharing email with all of you regarding assessment. A little more guidance on that so that you can follow it correctly. There are CTF questions, the link to CTF questions given in the. In the assignment page. But along with that, I will be sharing question and answers. You can use them as hints to. That will help you in navigating your investigation. But obviously, until you understand the AWS environment, it is difficult for you to. You know, to progress in your investigation. So."
        },
        {
          "speaker": "(3.08s - 3.09s) Isaac PANG",
          "line": "Yeah."
        },
        {
          "speaker": "(3.09s - 3.17s) Suchi Dhir",
          "line": "And whether how to go ahead in an event, you know. So."
        },
        {
          "speaker": "(3.17s - 3.22s) Isaac PANG",
          "line": "Yeah, yeah, yeah. That's fine. Yeah, sure."
        },
        {
          "speaker": "(3.22s - 3.31s) Suchi Dhir",
          "line": "And whenever you get stuck, do let out, do reach out to me."
        },
        {
          "speaker": "(3.33s - 3.52s) Isaac PANG",
          "line": "I will. Yeah. Yeah. So, yeah, I'll aim to finish week four by this weekend and get started on assessment three. So I'll be sure to shoot you any. Any queries I have about that."
        },
        {
          "speaker": "(3.53s - 3.66s) Suchi Dhir",
          "line": "Great. So I'll book our call next week, same time, just to have some quick discussion on assessment or if you have any queries."
        },
        {
          "speaker": "(3.67s - 3.71s) Isaac PANG",
          "line": "Yeah, perfect. Not a problem. Thank you very much for the call, Shuchi."
        },
        {
          "speaker": "(3.71s - 3.73s) Suchi Dhir",
          "line": "All the best. Bye bye."
        },
        {
          "speaker": "(3.73s - 3.8s) Isaac PANG",
          "line": "Thank you. Have a good weekend. You too. See you later. Thank you."
        },
        {
          "speaker": "(3.8s - 3.8s) Suchi Dhir",
          "line": "All right."
        },
        {
          "speaker": "(3.8s - 3.82s) Isaac PANG",
          "line": "See you later. Bye."
        }
      ],
      "date": "2023-06-02T09:01:01.036933Z"
    },
    {
      "file_name": "61bb1430-3e35-42d1-a68e-44f3ad1ca16e.wav",
      "file_url": "https://s3-ap-southeast-2.amazonaws.com/linc-recordings/61bb1430-3e35-42d1-a68e-44f3ad1ca16e.wav",
      "duration": 411,
      "transcription": [
        {
          "speaker": "(0.2s - 0.21s) Suchi Dhir",
          "line": "Hello?"
        },
        {
          "speaker": "(0.23s - 0.25s) Isaac PANG",
          "line": "Hello?"
        },
        {
          "speaker": "(0.25s - 0.38s) Suchi Dhir",
          "line": "Hi, is that doctor Shuchi here from Ecu? How are you doing? Hi, can you hear me?"
        },
        {
          "speaker": "(0.39s - 0.4s) Isaac PANG",
          "line": "Hello."
        },
        {
          "speaker": "(0.41s - 0.45s) Suchi Dhir",
          "line": "Hi, I'm Doctor Shuchi from Ecuador. How are you doing?"
        },
        {
          "speaker": "(0.46s - 0.58s) Isaac PANG",
          "line": "Yeah, how are you doing? Good, thank you. Yeah, yeah. I think I remember you from my unit, what, a month and a half ago?"
        },
        {
          "speaker": "(0.59s - 0.68s) Suchi Dhir",
          "line": "Yes, that's true. So we were together for network security unit."
        },
        {
          "speaker": "(0.69s - 0.76s) Isaac PANG",
          "line": "Was it networks or was it. It was networks, right?"
        },
        {
          "speaker": "(0.77s - 0.79s) Suchi Dhir",
          "line": "Yes, network security."
        },
        {
          "speaker": "(0.8s - 0.84s) Isaac PANG",
          "line": "Yeah, that's right. Yeah. Okay, cool."
        },
        {
          "speaker": "(0.84s - 1.62s) Suchi Dhir",
          "line": "Great. So this unit, like, you know, the cybersecurity incident detection, if you have the network security, it would be really easy for you to at least complete the first two weeks again. You will learn about snot as an ids. You will learn about incident detection, how basically, a cyber security incident has to be detected. There are frameworks, like, you know, Lockheed Martin framework and Mitre ATT and CK framework. You will learn about the kill chain, the attack framework, and then splunk. So is that. Have you worked on Splunk before?"
        },
        {
          "speaker": "(1.64s - 1.66s) Isaac PANG",
          "line": "No, I haven't. No."
        },
        {
          "speaker": "(1.68s - 2.27s) Suchi Dhir",
          "line": "Okay, so in this unit, major lead of the major assignment. The last assignment is an activity based on splunk. So I would suggest that, like, you know, from today onwards, if you can. If you can at least go through some of the courses on splanc in LinkedIn learnings, so that you understand about the splanc, its usage, the components of the splanc, and the various ways it ingests the data. And so is that."
        },
        {
          "speaker": "(2.27s - 2.33s) Isaac PANG",
          "line": "S p l u n k. Splunk."
        },
        {
          "speaker": "(2.33s - 2.38s) Suchi Dhir",
          "line": "S p l u n k. Right?"
        },
        {
          "speaker": "(2.39s - 2.45s) Isaac PANG",
          "line": "Yeah, yeah. Okay, sure."
        },
        {
          "speaker": "(2.46s - 3.04s) Suchi Dhir",
          "line": "Yes. So it would be easy for you to start working on the lab activities which are given in week three. You have an introduction to splunk. Then you have, every week, you have small activities to do in plank. So if you can just go through about this plank, its components, and how it. You know, how it manages with the dashboards, reports and various ways it ingests the data. Sure. I just."
        },
        {
          "speaker": "(3.04s - 3.22s) Isaac PANG",
          "line": "Yeah, I saw something. Can I use my virtual machine instead of setting up with them? The Microsoft thing?"
        },
        {
          "speaker": "(3.23s - 3.76s) Suchi Dhir",
          "line": "Yeah, you can do. That's completely fine. But for the last assignment, you have to work on bots version three data set, which is already installed in the azure virtual machine, the splunk. And so it would be easier for you to use that otherwise, if you want. And if you can install it on your machine, then that's also fine. So you can take your call. Yeah, you can take your call once you start working on the assessment tree."
        },
        {
          "speaker": "(3.77s - 3.86s) Isaac PANG",
          "line": "Yeah. Okay. I'll figure something out. That shouldn't be too much of a problem. Yeah."
        },
        {
          "speaker": "(3.87s - 5.31s) Suchi Dhir",
          "line": "Great. So more important, start working on this plank along with week one studies. Whatever you are doing, it is the basic part. Then complete the lab activities. Week three, week four, and as soon as you can, start working on the assessment tree. That would be really wise. Sure. Because assessment to ISAc is going to be really easy. It's straightforward for you because you have completed network security. You understand what is a sock, you understand what is the scene of. There is a scenario given. You have to suggest either a SoC solution or a seam solution for the given scenario and you have to justify your recommendation. So that's pretty straightforward as you have completed network security unit. So I would suggest try to complete it in a week or in two weeks time and then quickly focus on the assessment tree. It's very interesting and very lengthy, I would say, and complex also because you have a data set and you have to investigate the cyber security incidents in that data set. So which is going to take some good amount of time and that will be the major learning outcome, you know, from, from this course."
        },
        {
          "speaker": "(5.32s - 5.51s) Isaac PANG",
          "line": "Yeah, sure. That's fine. I'll try and get the assessment workshop stuff out the way. Maybe next week, in the week after, then start assignment three."
        },
        {
          "speaker": "(5.52s - 5.8s) Suchi Dhir",
          "line": "Sure. And yes. And you know the way we book, you can email me your query and yes. And can I schedule our weekly calls the same time every week so that we can."
        },
        {
          "speaker": "(5.82s - 5.94s) Isaac PANG",
          "line": "Is that for Friday at 05:00 p.m. yes, every Friday. Yeah, sure. That should be a problem. That's fine."
        },
        {
          "speaker": "(5.94s - 6.03s) Suchi Dhir",
          "line": "Great. So I would like to discuss assignment two next week with you."
        },
        {
          "speaker": "(6.03s - 6.03s) Isaac PANG",
          "line": "Yeah."
        },
        {
          "speaker": "(6.03s - 6.31s) Suchi Dhir",
          "line": "So it would be great if you can go through the requirements of the assignment two and if you have any ideas, just discuss them with me. Some rough points you can, you know, just jot down, write down and we can have a discussion on that."
        },
        {
          "speaker": "(6.32s - 6.69s) Isaac PANG",
          "line": "Yep, not a problem. I'll do that. That's fine. Yeah, that is cool. I'll get up to assignment two by next Friday then, so we can talk about it on our call. Hello?"
        }
      ],
      "date": "2023-05-05T09:00:13.79763Z"
    },
    {
      "file_name": "c15f0325-d3fd-4c14-99e4-27b1966fd066.wav",
      "file_url": "https://s3-ap-southeast-2.amazonaws.com/linc-recordings/c15f0325-d3fd-4c14-99e4-27b1966fd066.wav",
      "duration": 65,
      "transcription": [
        {
          "speaker": "(0.01s - 0.3s) Suchi Dhir",
          "line": "What? Yeah, sorry for that. I was just saying, is there anything specific that you would like me to do for, you know, just to ensure that you. This, you know, the learning outcome is really excellent for you from the study?"
        },
        {
          "speaker": "(0.32s - 0.71s) Isaac PANG",
          "line": "Not at the moment. What I'll do is I'll start working tomorrow on the work and then I'll do the workshops and I'll try and get started on assignment two before our call next Friday. So I have questions to ask. Then I'll probably have a better idea of what I need to know for next week's call because I haven't. I haven't actually started any of the work yet. On the weekend."
        },
        {
          "speaker": "(0.72s - 0.8s) Suchi Dhir",
          "line": "Yeah, no worries. So I'll speak to you next week. I'll schedule a call."
        },
        {
          "speaker": "(0.8s - 0.83s) Isaac PANG",
          "line": "Yeah, perfect. So Friday, 05:00."
        },
        {
          "speaker": "(0.83s - 0.95s) Suchi Dhir",
          "line": "P.M. friday, 05:00 p.m. yeah. Brilliant. Great. Then a sec. Welcome to this unit and all the best. Thanks."
        },
        {
          "speaker": "(0.95s - 0.96s) Isaac PANG",
          "line": "Yeah. Nice to meet you again."
        }
      ],
      "date": "2023-05-05T09:08:11.437733Z"
    },
    {
      "file_name": "13795362-fd1f-464d-9b36-06d4bae43062.wav",
      "file_url": "https://s3-ap-southeast-2.amazonaws.com/linc-recordings/13795362-fd1f-464d-9b36-06d4bae43062.wav",
      "duration": 144,
      "transcription": [
        {
          "speaker": "(0.02s - 0.03s) Isaac PANG",
          "line": "Hello, Isaac speaking."
        },
        {
          "speaker": "(0.04s - 0.09s) Suchi Dhir",
          "line": "Hi, Isaac. Doctor Shuchi here from ECU. How are you doing?"
        },
        {
          "speaker": "(0.09s - 0.13s) Isaac PANG",
          "line": "Oh, hi, Shuchi. I'm good, thank you. And yourself?"
        },
        {
          "speaker": "(0.13s - 0.26s) Suchi Dhir",
          "line": "Yes, I'm doing great. So how is your progress on the unit? Have you started working on assessment two?"
        },
        {
          "speaker": "(0.27s - 0.53s) Isaac PANG",
          "line": "Not assessment two. I just finished both week one and week two's content today. And starting on week three's content, I haven't gotten. I'll get started on assessment two this week, though. This weekend? Yeah."
        },
        {
          "speaker": "(0.53s - 0.64s) Suchi Dhir",
          "line": "Okay. So yes, if you are able to complete, that would be really, you know."
        },
        {
          "speaker": "(0.65s - 0.82s) Isaac PANG",
          "line": "Yeah, I will. Yeah, yeah, yeah. I just wanted to do the content first. Just get the first two weeks out of the way before I, like, started, you know?"
        },
        {
          "speaker": "(0.85s - 0.93s) Suchi Dhir",
          "line": "Okay. So that's good. So do you have any queries? Did you go through the requirements of the segment?"
        },
        {
          "speaker": "(0.96s - 1.17s) Isaac PANG",
          "line": "No, I don't have any queries. I sent you a text message earlier, but I figured that one out so that didn't end up being too much of an issue. But outside of that, no, I haven't gotten any current problems right now."
        },
        {
          "speaker": "(1.17s - 1.52s) Suchi Dhir",
          "line": "Okay. I will also keep sharing information about, I want to specifically about assessment tree because that's 50% of your overall grades. And I want that, you know, students, they wisely utilize their time. At least three weeks. You have to spend on that assignment on number."
        },
        {
          "speaker": "(1.52s - 1.53s) Isaac PANG",
          "line": "Sorry."
        },
        {
          "speaker": "(1.53s - 1.55s) Suchi Dhir",
          "line": "Or number three."
        },
        {
          "speaker": "(1.55s - 1.56s) Isaac PANG",
          "line": "Right, yeah."
        },
        {
          "speaker": "(1.56s - 1.95s) Suchi Dhir",
          "line": "Because you have to, you know, spend time on the investigation and then you have to understand how to, how this investigation is aligned with the cyber kill change mitre attach framework. These, these frameworks are very, very important and they provide. Yeah. So I will be sharing. Yes. Some notes on that as well. So."
        },
        {
          "speaker": "(1.95s - 1.98s) Isaac PANG",
          "line": "Yeah. Okay. That'll be great."
        },
        {
          "speaker": "(1.99s - 2.05s) Suchi Dhir",
          "line": "So if you don't have any of the queries, can I book our call next week, same time?"
        },
        {
          "speaker": "(2.06s - 2.22s) Isaac PANG",
          "line": "Of course, yeah, that's great. I'll probably, I'll get started on assessment two this weekend and if I have any problems, I'll fire you a text message, I guess that will probably."
        },
        {
          "speaker": "(2.22s - 2.23s) Suchi Dhir",
          "line": "Yeah."
        },
        {
          "speaker": "(2.23s - 2.38s) Isaac PANG",
          "line": "Yeah, no worries. That, that's probably the best. Yeah. Thanks a lot for your call. Okay, I'll speak to you next week. All right then. See you later. Bye."
        }
      ],
      "date": "2023-05-12T09:01:15.549405Z"
    },
    {
      "file_name": "d3400b84-459b-4b8f-b2a2-79995f020a81.wav",
      "file_url": "https://s3-ap-southeast-2.amazonaws.com/linc-recordings/d3400b84-459b-4b8f-b2a2-79995f020a81.wav",
      "duration": 835,
      "transcription": [
        {
          "speaker": "(0.02s - 0.03s) Isaac PANG",
          "line": "Hello."
        },
        {
          "speaker": "(0.03s - 0.09s) Suchi Dhir",
          "line": "Hi, is that doctor Shuchi here from Ecu? How are you doing?"
        },
        {
          "speaker": "(0.1s - 0.11s) Isaac PANG",
          "line": "I'm good, how are you?"
        },
        {
          "speaker": "(0.12s - 0.31s) Suchi Dhir",
          "line": "I'm doing great, thank you. How about your progress? Is that, have you completed your activities, lab activities, reading activities, week four, week five, any queries?"
        },
        {
          "speaker": "(0.32s - 0.44s) Isaac PANG",
          "line": "No queries. I've been doing the final assignment. That's what I've been working on the last few days."
        },
        {
          "speaker": "(0.44s - 0.5s) Suchi Dhir",
          "line": "Okay. And how is the investigation going on?"
        },
        {
          "speaker": "(0.5s - 0.68s) Isaac PANG",
          "line": "Yeah, good. Yeah. It's a bit challenging, I'd say a little bit challenging, but it's quite interesting. So, yeah, just working through it as best as I can."
        },
        {
          "speaker": "(0.69s - 0.86s) Suchi Dhir",
          "line": "Okay, great. So if you can, I mean, like, you may find some cyber attacks related to coin mining attack as well."
        },
        {
          "speaker": "(0.86s - 0.88s) Isaac PANG",
          "line": "I have found those, yeah."
        },
        {
          "speaker": "(0.89s - 1.07s) Suchi Dhir",
          "line": "Oh, did you find that? That's, that's crazy. Yeah, that's, that's really good. So did you decide the format of the running sheet or the format of the report?"
        },
        {
          "speaker": "(1.09s - 1.35s) Isaac PANG",
          "line": "That's what I was actually going to ask. Like I saw there was that template, downloadable template on the assignment page. Is that what you want us to be using or do you want us to come up with our own kind of thing?"
        },
        {
          "speaker": "(1.36s - 1.97s) Suchi Dhir",
          "line": "You can come up with your own. That's just an example template that you have to follow. Obviously there has to be a summary introduction to your investigation. What you did apart from that, describe, provide the technical details of all major events. For example, if you identified an event related to misuse of s three bucket or let's say, access key leaks, so, you know, section, make a subsection on that and provide technical details related to that."
        },
        {
          "speaker": "(1.98s - 2.11s) Isaac PANG",
          "line": "So would that be in the technical analysis section then? Like, if I was to use that format, then I would put all that stuff in there."
        },
        {
          "speaker": "(2.11s - 2.26s) Suchi Dhir",
          "line": "Exactly. That would be part of that. So have an introduction, have a summary, have an introduction, then provide investigation details."
        },
        {
          "speaker": "(2.26s - 2.61s) Isaac PANG",
          "line": "Okay, so maybe in like, so introduction. Sorry. And then the summary would be like kind of just explaining, like, like in layman's terms, kind of like the attack. And then like the technical. The next section, the technical would be like explaining each, like each finding kind of thing."
        },
        {
          "speaker": "(2.62s - 3.54s) Suchi Dhir",
          "line": "Yes. So your summary will be, you know, an introduction where you provide indicators of major indicators of compromises, which. Through which and the attack, let's say, if you have identified coin mining attacks. So you can say that, you know, this report constitutes your assessment or investigation of suspected coin mining attack in, I guess it's frothley Beers infrastructure. And then describe some of the indicators of compromises that were detected. Major in, you know, indicators which helped you in, under. Helped you in understanding the coin mining attack and then overview of investigation. If you have used open source investigation, you can also provide information about that."
        },
        {
          "speaker": "(3.55s - 3.83s) Isaac PANG",
          "line": "Yeah, I just. Yeah, what was I going to say? And with the Mitre ATT and CK framework and the Lockheed Martin kill chain thing, what section would we put that in? The technical analysis."
        },
        {
          "speaker": "(3.86s - 4.91s) Suchi Dhir",
          "line": "Okay, so you can have first section as summary. Second is your investigation. Let's say this is just an example I'm giving you. You can obviously make changes. So in the investigation you can have an introduction and then you can have, you know, all the major events. Let's say if section two is investigation 2.1 is introduction where you just explain your, whatever you have identified and you provide your Lockheed Martin kill chain and other diagrams, Mitre ATT and CK framework diagrams. So that would be an introduction where you say that what you identified and how it is aligned to these frameworks. And then comes your 2.1 section where you describe the first major event, the first indicator of compromise or event, whatever you say. Let's say it is two point. Yeah."
        },
        {
          "speaker": "(4.92s - 5.17s) Isaac PANG",
          "line": "Yeah. So it's summary and then investigation. And then in that investigation you have an introduction which includes the Lockheed Martin stuff. And then 2.2 under that would be the major event."
        },
        {
          "speaker": "(5.18s - 5.97s) Suchi Dhir",
          "line": "Yes. For example, let's say the keys exposed and exploited event AWS keys exposed. Fitzhe again, it will be 2.3. Let's say you have identified event s, three bucket misuse event like that. All the events you will describe at the end, if you, if you, if you have identified some events which are not related to the coin mining attack, but you know they, they are there. So you can have one section at the end stating, you know, the further, the other other incidents which coins towards compromising AWS infrastructure or whatever, you can describe them. So this is all section two, like."
        },
        {
          "speaker": "(5.97s - 6.01s) Isaac PANG",
          "line": "A further findings kind of section?"
        },
        {
          "speaker": "(6.01s - 6.4s) Suchi Dhir",
          "line": "Yes, this is your section two. Third section, you have to provide about your mitigation strategies, countermeasures and in that you can provide best practices, countermeasures, mitigation strategies, lessons learned and lessons learned. You can keep it in the final section if you want."
        },
        {
          "speaker": "(6.41s - 6.45s) Isaac PANG",
          "line": "Not in the section three."
        },
        {
          "speaker": "(6.45s - 7.03s) Suchi Dhir",
          "line": "No, not in the section three. The section three is about countermeasures, response and recovery. You can say that what response and recovery actions were taken. You may find that somewhere some response, recovery actions have been taken place. You can specify here, maybe coin mining attack was blocked. So all those things you have to specify here and then further countermeasures, best practices, all those things you can describe in this section three. And then finally the section four would be your lessons learned."
        },
        {
          "speaker": "(7.04s - 7.05s) Isaac PANG",
          "line": "Yeah."
        },
        {
          "speaker": "(7.05s - 7.26s) Suchi Dhir",
          "line": "And then afterwards at the end, you can have all appendix appendices where you can provide the running sheet and references, all those sort of things."
        },
        {
          "speaker": "(7.27s - 7.81s) Isaac PANG",
          "line": "Yep. Okay, I'll just, so I'll just read that out, like summary to begin section one. Section two is the actual investigation with an introduction, and then the major events after that, and then after that, as well as further findings. And all of that is in section two. And then section three is the mitigation, countermeasures, best practices, etcetera. And then lesson, section four is lessons learned. Section five. I guess I just put a conclusion."
        },
        {
          "speaker": "(7.81s - 7.83s) Suchi Dhir",
          "line": "Yes."
        },
        {
          "speaker": "(7.83s - 7.92s) Isaac PANG",
          "line": "Oh yeah. And then section six would be like the appendix with the timesheet, I guess."
        },
        {
          "speaker": "(7.93s - 8.11s) Suchi Dhir",
          "line": "Exactly. So your lessons learned and your conclusion is the same thing because if you're just writing an investigation report, so you don't have a conclusion section here you have less."
        },
        {
          "speaker": "(8.13s - 8.39s) Isaac PANG",
          "line": "Okay, cool. And then, so the timesheet, that's like, kind of like all the search query commands with the timestamps in the table to find all the, what was like the commands we used to find the ATT and CK."
        },
        {
          "speaker": "(8.39s - 9.25s) Suchi Dhir",
          "line": "Yes. So the timesheet running sheet or running sheet, whatever you call it, should have the command that you have executed in splunk. It should have an expected result or reason why you executed that command. Anything will do. And then the actual result, which will be the screenshot of the output of your splunk and then the consequence. So what happened after executing that query? Did it give you some clues, something or it was a dead end and you had to stop your investigation here itself and you could not move further after running this query. Timestamp and then the timestamp. And the timestamp is the time when you have executed the query."
        },
        {
          "speaker": "(9.26s - 9.62s) Isaac PANG",
          "line": "Yeah, okay, cool. Another thing is like, I was looking through all the capture the flag questions for this, for this data set. And obviously there's a lot of questions. Just with that, you obviously don't need to answer all of them to write."
        },
        {
          "speaker": "(9.62s - 10.12s) Suchi Dhir",
          "line": "This is not regarding your answering CTF questions. This assignment is not, you don't need to answer the CTF questions. We have just provided you so that students can understand the queries and they can get some pointers on how to start with their investigation. So nowhere, you know, we want you to solve. So if you have identified a cyber attack, some events associated to it, you can conclude your report. I mean, you can start working on your report and conclude it."
        },
        {
          "speaker": "(10.12s - 10.19s) Isaac PANG",
          "line": "Yeah, okay. Yeah, sure, that's fine."
        },
        {
          "speaker": "(10.2s - 11.24s) Suchi Dhir",
          "line": "You know, you can also try to, that would be additional if you can, if you can make, when these kind of investigations are done, cybersecurity, you can also make evidence, infrastructure, evidence, landscaping, you know, you can do that. So you can create a diagram where, you know, you can find out a complete landscape of the infrastructure, which includes your AWS cloud. It includes your, let's say, s three buckets. It includes, you know, whatever, let's say, b's tall user, you would have identified, you know, involved. So whatever users were, you know, identified, they were, they were, they were part of this attack. So all those, all those, you know, things that you have identified were part of the attack. You know, you can create an infrastructure landscape and then find out from where you got the evidences."
        },
        {
          "speaker": "(11.25s - 11.29s) Isaac PANG",
          "line": "Okay. Yeah, sure."
        },
        {
          "speaker": "(11.29s - 11.33s) Suchi Dhir",
          "line": "I hope I'm making sense and you're able to understand."
        },
        {
          "speaker": "(11.34s - 11.4s) Isaac PANG",
          "line": "Yeah, yeah, I do. I do understand. Yeah."
        },
        {
          "speaker": "(11.4s - 11.54s) Suchi Dhir",
          "line": "Great. So that would be something, you know, additional bonus if you can create and if you have time, definitely do that."
        },
        {
          "speaker": "(11.56s - 11.57s) Isaac PANG",
          "line": "Yeah."
        },
        {
          "speaker": "(11.58s - 11.84s) Suchi Dhir",
          "line": "Want me to look into your report? Please do share it. Because it's more about learning to, not for the grading point of view, but definitely, I just want that you also, you know, come up with a great assignment and report."
        },
        {
          "speaker": "(11.85s - 12.0s) Isaac PANG",
          "line": "Yeah, yeah, definitely. So with that infrastructure thing, like it would be to just like a bit more added depth to the assignment."
        },
        {
          "speaker": "(12.01s - 12.03s) Suchi Dhir",
          "line": "Right?"
        },
        {
          "speaker": "(12.03s - 12.07s) Isaac PANG",
          "line": "Yeah. Okay, great."
        },
        {
          "speaker": "(12.07s - 12.32s) Suchi Dhir",
          "line": "So I'm booking the call next week in case if there would be some discussions around report, we can have that. Otherwise, if you complete your work before that, and you don't need to have a discussion, you can let me know."
        },
        {
          "speaker": "(12.32s - 12.65s) Isaac PANG",
          "line": "Sure. I'll probably send you my report mid next week when I've completed it, or like an overview, if that's okay, as I did with the previous one. Yes, I'll probably do that and then. Yeah, but other than that, I'll probably speak to you next Friday."
        },
        {
          "speaker": "(12.66s - 12.69s) Suchi Dhir",
          "line": "Sure, I'll speak to you next Friday."
        },
        {
          "speaker": "(12.73s - 12.83s) Isaac PANG",
          "line": "Sorry. Sorry. Also with the marks for the previous assignment, are they going to be released next week?"
        },
        {
          "speaker": "(12.84s - 12.98s) Suchi Dhir",
          "line": "I guess Tuesday or Monday. I'm still grading the papers and I guess it should be available Monday or Tuesday."
        },
        {
          "speaker": "(12.99s - 13.09s) Isaac PANG",
          "line": "Yeah. Okay. You don't even have. You don't have my mark yet?"
        },
        {
          "speaker": "(13.13s - 13.23s) Suchi Dhir",
          "line": "No, I don't think so. Yes, I didn't, I didn't. I didn't grade your paper still."
        },
        {
          "speaker": "(13.24s - 13.3s) Isaac PANG",
          "line": "Ah, okay. Well, I was hoping to find out."
        },
        {
          "speaker": "(13.31s - 13.48s) Suchi Dhir",
          "line": "I would be. I have to complete grading by today or tomorrow. And then Doctor Leslie would be, um, you know, checking will be doing the second grading."
        },
        {
          "speaker": "(13.48s - 13.52s) Isaac PANG",
          "line": "Are you not marking my."
        },
        {
          "speaker": "(13.53s - 13.54s) Suchi Dhir",
          "line": "Yes."
        },
        {
          "speaker": "(13.56s - 13.59s) Isaac PANG",
          "line": "Are you not marking my paper?"
        },
        {
          "speaker": "(13.59s - 13.62s) Suchi Dhir",
          "line": "No, I will be marking your paper."
        },
        {
          "speaker": "(13.62s - 13.65s) Isaac PANG",
          "line": "Oh, yeah. Yeah, I see."
        },
        {
          "speaker": "(13.65s - 13.75s) Suchi Dhir",
          "line": "The final marking will be done by Doctor Leslie. So he will be the grades which I have provided yet."
        },
        {
          "speaker": "(13.75s - 13.81s) Isaac PANG",
          "line": "Right. I see. Perfect. No problems. That's okay."
        },
        {
          "speaker": "(13.81s - 13.83s) Suchi Dhir",
          "line": "Great. I'll speak to you next week."
        },
        {
          "speaker": "(13.83s - 13.85s) Isaac PANG",
          "line": "Is that okay?"
        },
        {
          "speaker": "(13.85s - 13.87s) Suchi Dhir",
          "line": "Thank you. Thank you."
        },
        {
          "speaker": "(13.87s - 13.9s) Isaac PANG",
          "line": "All right. You too. See you later. Bye."
        }
      ],
      "date": "2023-06-09T09:04:29.075768Z"
    },
    {
      "file_name": "42f9b663-09c9-496c-82b0-fcbf85d3776b.wav",
      "file_url": "https://s3-ap-southeast-2.amazonaws.com/linc-recordings/42f9b663-09c9-496c-82b0-fcbf85d3776b.wav",
      "duration": 469,
      "transcription": [
        {
          "speaker": "(0.03s - 0.04s) Isaac PANG",
          "line": "What?"
        },
        {
          "speaker": "(0.04s - 0.26s) Suchi Dhir",
          "line": "Hi, Zach. Doctor Shuchi here from ECU. This is. How are you doing? And. Great. Great. So I did share my feedback with you on the draft that you submitted."
        },
        {
          "speaker": "(0.27s - 0.39s) Isaac PANG",
          "line": "Yeah, I briefly looked at that. So maybe we could go over it a little bit because I guess on this call."
        },
        {
          "speaker": "(0.42s - 0.51s) Suchi Dhir",
          "line": "Great. Any queries? Do you have any queries on that, Orlando? Any other you would like to discuss?"
        },
        {
          "speaker": "(0.51s - 0.7s) Isaac PANG",
          "line": "Not really. Maybe strengthening the technical description. What? So what could I add to it just to strengthen it."
        },
        {
          "speaker": "(0.72s - 1.11s) Suchi Dhir",
          "line": "Okay, so for technical description, add the screenshots and explain the events properly. You know, how it has happened. That's what we are expecting. I'll do one thing. I'll share a good link with you and if I have not, I guess I did share with you."
        },
        {
          "speaker": "(1.13s - 1.17s) Isaac PANG",
          "line": "You shared me a solar winds one."
        },
        {
          "speaker": "(1.17s - 1.28s) Suchi Dhir",
          "line": "Yes. If you can look into that. And, you know. And technical description."
        },
        {
          "speaker": "(1.29s - 1.3s) Isaac PANG",
          "line": "Yeah."
        },
        {
          "speaker": "(1.31s - 1.77s) Suchi Dhir",
          "line": "Yes. So if you can start with the synopsis of the attack, explain in detail about. About the attack, about the vulnerability, how it was exploited, and then provide the screenshots from the splunk that made you help, you know, understanding about this attack is happening. So I felt a bit more description could be added in the technical section."
        },
        {
          "speaker": "(1.78s - 1.89s) Isaac PANG",
          "line": "Is that in the. In the start when I had that general kind of explanation."
        },
        {
          "speaker": "(1.9s - 2.04s) Suchi Dhir",
          "line": "No, in the summary? No, it's not in the start. It should be when you are talking about the major events."
        },
        {
          "speaker": "(2.05s - 2.12s) Isaac PANG",
          "line": "Oh, I see. Okay."
        },
        {
          "speaker": "(2.12s - 2.67s) Suchi Dhir",
          "line": "If you can present the screenshots, more diagrams, provide some synopsis privilege. For example, here you have this privilege escalation or s three bucket. What is s three bucket? What do you mean by privilege escalation? Provide a synopsis of the attack, if possible. Have more diagrams and whatever you have explained. If you can just present the screenshots, that would be better."
        },
        {
          "speaker": "(2.68s - 3.2s) Isaac PANG",
          "line": "Okay, sure. I'll do that. I'll do that tonight. Give me one sec. The timeline of the event in order, would that not be in the appendix bit where I kind of put a timeline in the table and then each. I've done that. I did that, though. It's in my report. It's at the bottom."
        },
        {
          "speaker": "(3.24s - 3.28s) Suchi Dhir",
          "line": "Let me quickly open that and see."
        },
        {
          "speaker": "(3.28s - 3.35s) Isaac PANG",
          "line": "Yeah, it's in section. Okay."
        },
        {
          "speaker": "(3.35s - 3.55s) Suchi Dhir",
          "line": "You have not. Yes. So you didn't create any diagrams, right? Yes. Okay. Yeah, that's in the table. Right. That's good. No problem."
        },
        {
          "speaker": "(3.56s - 3.58s) Isaac PANG",
          "line": "Yeah."
        },
        {
          "speaker": "(3.58s - 3.7s) Suchi Dhir",
          "line": "And there's. You have to have visualizations that's missing. Lockheed Martin kill chain."
        },
        {
          "speaker": "(3.71s - 3.88s) Isaac PANG",
          "line": "Oh, yeah. Do you want me to, like, how can I draw diagrams to visualize that? What are you looking for?"
        },
        {
          "speaker": "(3.9s - 4.37s) Suchi Dhir",
          "line": "Okay, there are various ways through which you can do that you can have an activity diagram if you want, or if you want, let's say, individual events. When you are talking at the. At the bottom of. At the end of the individual events description, you can explain, you know, you can draw a diagram where you can align the individual incident with the different phases of Lockheed Martin chain, or."
        },
        {
          "speaker": "(4.4s - 4.57s) Isaac PANG",
          "line": "Is that similar to the, you know, in the splunk, the bots one activity where they had the diagram and then they show. Is it the same as that?"
        },
        {
          "speaker": "(4.57s - 4.59s) Suchi Dhir",
          "line": "Yes. Yes."
        },
        {
          "speaker": "(4.6s - 4.65s) Isaac PANG",
          "line": "Okay, I'll do that tonight as well. That's good."
        },
        {
          "speaker": "(4.71s - 4.76s) Suchi Dhir",
          "line": "Add more diagrams to your report. That's very important."
        },
        {
          "speaker": "(4.77s - 5.07s) Isaac PANG",
          "line": "Yeah, I pretty much just finished the bulk of it. I was working on it quite hard for the last days, and so I just wanted to send in the content mainly. But, yeah, so I'll just work on adding diagrams and it seems like the main. Main thing."
        },
        {
          "speaker": "(5.1s - 5.13s) Suchi Dhir",
          "line": "Yeah, that's the main thing. Yes."
        },
        {
          "speaker": "(5.14s - 5.25s) Isaac PANG",
          "line": "Yeah. Okay, well, in that case, that's fine. That shouldn't be a problem. Yeah."
        },
        {
          "speaker": "(5.26s - 5.66s) Suchi Dhir",
          "line": "Great. In the introduction as well, if you can talk, you know, a bit more about the attack, if you can present the evidence landscape in the sense where you got the evidences from. So that will also be, you know, an additional, I would say a value addition to your report."
        },
        {
          "speaker": "(5.67s - 5.73s) Isaac PANG",
          "line": "Oh, sorry, what do you mean by that?"
        },
        {
          "speaker": "(5.74s - 6.4s) Suchi Dhir",
          "line": "Okay, so evidence landscape is when you do cyber security incident detection or investigation like this, you can present diagram a landscape like where all you got the investigation, where all you got the clues, your evidence is from, for example, bs tall, or maybe s three bucket and AWS cloud. So you can draw that and explain, or maybe, let's say, from the semantic log. So whatever key, you know, places from where you have got your evidences that you can just present in the. In the form of a diagram."
        },
        {
          "speaker": "(6.41s - 6.46s) Isaac PANG",
          "line": "Right. And that can be in the summary at the start."
        },
        {
          "speaker": "(6.46s - 6.49s) Suchi Dhir",
          "line": "In the introduction. Yeah. In the starting."
        },
        {
          "speaker": "(6.49s - 6.53s) Isaac PANG",
          "line": "Right, yeah. Okay, cool."
        },
        {
          "speaker": "(6.53s - 6.62s) Suchi Dhir",
          "line": "So that will aid in presenting the information. You know, what you are."
        },
        {
          "speaker": "(6.63s - 6.8s) Isaac PANG",
          "line": "Sure. Okay. Yeah, that's fine. I'll work on doing that tonight and tomorrow, then I guess I'll finish that off. Yeah. This is quite a big assignment, actually."
        },
        {
          "speaker": "(6.81s - 6.87s) Suchi Dhir",
          "line": "It is very. Right. That's why 50% of the."
        },
        {
          "speaker": "(6.87s - 6.95s) Isaac PANG",
          "line": "Yeah. Quite hard work today."
        },
        {
          "speaker": "(6.99s - 7.2s) Suchi Dhir",
          "line": "Yes. But that. That's a credit, you know, you can definitely use this because working on bots version three will add credit to your resume. So it's actually."
        },
        {
          "speaker": "(7.26s - 7.31s) Isaac PANG",
          "line": "It was very interesting. I thought it was quite hard work."
        },
        {
          "speaker": "(7.37s - 7.6s) Suchi Dhir",
          "line": "Great. Then is that this may be the last call because this is the final week. But it was really nice. I have worked with you on multiple units. So I wish you good luck, you know. I wish you good luck for your future. Yes, thanks."
        },
        {
          "speaker": "(7.6s - 7.67s) Isaac PANG",
          "line": "You too. I hope maybe you will be tutor for another, you know."
        },
        {
          "speaker": "(7.68s - 7.76s) Suchi Dhir",
          "line": "Let's see. Yes. All the best, right? Yes. Thank you."
        },
        {
          "speaker": "(7.77s - 7.8s) Isaac PANG",
          "line": "All right, bye."
        }
      ],
      "date": "2023-06-16T09:19:38.341573Z"
    },
    {
      "file_name": "2dc4683c-5836-4abb-9ce4-76c2d8e4373a.wav",
      "file_url": "https://s3-ap-southeast-2.amazonaws.com/linc-recordings/2dc4683c-5836-4abb-9ce4-76c2d8e4373a.wav",
      "duration": 239,
      "transcription": [
        {
          "speaker": "(0.03s - 0.04s) Isaac PANG",
          "line": "Hello, Isaac speaking."
        },
        {
          "speaker": "(0.05s - 0.1s) Suchi Dhir",
          "line": "Hi, Isaac. Doctor Shuchi here from ECU. How are you doing?"
        },
        {
          "speaker": "(0.1s - 0.13s) Isaac PANG",
          "line": "Hi, I'm good. And yourself?"
        },
        {
          "speaker": "(0.13s - 0.16s) Suchi Dhir",
          "line": "Yeah, I'm doing great."
        },
        {
          "speaker": "(0.16s - 0.22s) Isaac PANG",
          "line": "So I think I remember. I think I remember you from one of my other units."
        },
        {
          "speaker": "(0.26s - 0.3s) Suchi Dhir",
          "line": "How many units have you completed so far?"
        },
        {
          "speaker": "(0.3s - 0.51s) Isaac PANG",
          "line": "I'm close. I'm finishing at the end of the year. Yeah. So I'm actually overloading right now. Got. I've got two units to do in this semester."
        },
        {
          "speaker": "(0.52s - 0.59s) Suchi Dhir",
          "line": "Okay. Okay. So did you get a chance to."
        },
        {
          "speaker": "(0.59s - 0.89s) Isaac PANG",
          "line": "Look into the content of this unit briefly this morning? I had a look. I downloaded the Azure lab to my desktop and that's pretty much the extent. I had a quick look at the assignment and that was it. I was planning on having a bit more of a look lighter today."
        },
        {
          "speaker": "(0.89s - 1.06s) Suchi Dhir",
          "line": "Okay, good, good. That's good. So see, uh, I guess splunk is a tool that you would be using over here, not splunk. Yeah, splunk. And."
        },
        {
          "speaker": "(1.07s - 1.09s) Isaac PANG",
          "line": "Oh my God, I hated spunk."
        },
        {
          "speaker": "(1.1s - 1.23s) Suchi Dhir",
          "line": "Yes. And you have, you have learned that you have worked on it in cybersecurity incident detection and management unit."
        },
        {
          "speaker": "(1.23s - 1.25s) Isaac PANG",
          "line": "Yeah, yeah."
        },
        {
          "speaker": "(1.25s - 1.33s) Suchi Dhir",
          "line": "So you have those common then wireshark you would have done in networking."
        },
        {
          "speaker": "(1.33s - 1.36s) Isaac PANG",
          "line": "Yeah, I've got them all. Yeah."
        },
        {
          "speaker": "(1.36s - 1.45s) Suchi Dhir",
          "line": "Yes. So Surikata is another ideas that you would be learning over here. And."
        },
        {
          "speaker": "(1.45s - 1.47s) Isaac PANG",
          "line": "What's it called? Sorry?"
        },
        {
          "speaker": "(1.47s - 1.49s) Suchi Dhir",
          "line": "Surikata."
        },
        {
          "speaker": "(1.5s - 1.51s) Isaac PANG",
          "line": "Oh, okay."
        },
        {
          "speaker": "(1.52s - 1.89s) Suchi Dhir",
          "line": "Right. So you would be doing that. Plus additionally, lot of theoretical concepts surrounding around, around ids, ips, specifically from the point of view of their placement in a network. And then you will also understand how to design a security operation center soc."
        },
        {
          "speaker": "(1.9s - 1.91s) Isaac PANG",
          "line": "Yeah."
        },
        {
          "speaker": "(1.91s - 2.64s) Suchi Dhir",
          "line": "So that is something. Honey pot. You will learn about it and how to identify a suitable honey pot. Apart from that, NIST, that's the very common frameworks for, you know, penetration testing, vulnerability management, risk assessments. So you'll have a brief look at those standards also then. Yeah. For vulnerability assessment, there is Nick two tool that you would be working on, Nikto and some forensic concepts, audit logging, all that you would be, you know, doing in. So how do you plan? Like, do you want to have weekly check in calls at some point?"
        },
        {
          "speaker": "(2.64s - 2.68s) Isaac PANG",
          "line": "Yeah, that's fine. I'm happy with that. That's good."
        },
        {
          "speaker": "(2.68s - 2.71s) Suchi Dhir",
          "line": "Can we do it this time every."
        },
        {
          "speaker": "(2.73s - 2.78s) Isaac PANG",
          "line": "Wednesday, 10:00 a.m. yes."
        },
        {
          "speaker": "(2.78s - 2.95s) Suchi Dhir",
          "line": "Let's. Let's fix this for the next six weeks. Right. So, yeah, please do connect with the issuer. That's. That's what is required in week zero."
        },
        {
          "speaker": "(2.95s - 2.96s) Isaac PANG",
          "line": "Yeah."
        },
        {
          "speaker": "(2.96s - 3.15s) Suchi Dhir",
          "line": "Start engaging with the content and, you know, for the assignment and for. For the other stuff, we will have a discussion, you know, going week one or week two?"
        },
        {
          "speaker": "(3.16s - 3.3s) Isaac PANG",
          "line": "Yeah, yeah, I'm planning on starting some of the content this week or maybe today or tomorrow. So I'll let you know next week how I'm tracking."
        },
        {
          "speaker": "(3.3s - 3.4s) Suchi Dhir",
          "line": "Okay, great. So anything else that you would like to discuss today or you should want to."
        },
        {
          "speaker": "(3.41s - 3.58s) Isaac PANG",
          "line": "No, that's okay. I think I'll have a look at everything today and then on our call next week I'll come with you with any concerns that I have or any issues."
        },
        {
          "speaker": "(3.58s - 3.81s) Suchi Dhir",
          "line": "Right, sure. I'll also discuss with you regarding the study plan. And you know, there are something. Key points to be discussed for weekly topics that we will have from next week onwards."
        },
        {
          "speaker": "(3.81s - 3.84s) Isaac PANG",
          "line": "Sure, yeah, not a problem."
        },
        {
          "speaker": "(3.85s - 3.91s) Suchi Dhir",
          "line": "All the best is that for this unit and I'll speak to you next week."
        },
        {
          "speaker": "(3.91s - 3.95s) Isaac PANG",
          "line": "Thanks so much. Sushi. All right then. See you later."
        },
        {
          "speaker": "(3.95s - 3.96s) Suchi Dhir",
          "line": "Take care."
        },
        {
          "speaker": "(3.96s - 3.96s) Isaac PANG",
          "line": "Bye."
        }
      ],
      "date": "2024-07-03T02:02:40.554373Z"
    },
    {
      "file_name": "4cfd9259-d894-4026-903a-be0fac7ed232.wav",
      "file_url": "https://s3-ap-southeast-2.amazonaws.com/linc-recordings/4cfd9259-d894-4026-903a-be0fac7ed232.wav",
      "duration": 350,
      "transcription": [
        {
          "speaker": "(0.01s - 0.02s) Isaac PANG",
          "line": "Hello."
        },
        {
          "speaker": "(0.03s - 0.08s) Suchi Dhir",
          "line": "Hi, Zach. Doctor Shuchi here. Good morning. How are you doing?"
        },
        {
          "speaker": "(0.08s - 0.11s) Isaac PANG",
          "line": "I'm good, thank you. And yourself?"
        },
        {
          "speaker": "(0.12s - 0.26s) Suchi Dhir",
          "line": "I'm doing great, thank you. So I went through your notes that you have submitted to me."
        },
        {
          "speaker": "(0.27s - 0.28s) Isaac PANG",
          "line": "Yeah."
        },
        {
          "speaker": "(0.29s - 0.56s) Suchi Dhir",
          "line": "So this is what you know is required. Like, you know, you have mentioned that correctly. You can create a table like this is include all the assets, not necessarily everyone, but try to cover as many assets as possible."
        },
        {
          "speaker": "(0.57s - 0.59s) Isaac PANG",
          "line": "Every what, sir?"
        },
        {
          "speaker": "(0.6s - 1.26s) Suchi Dhir",
          "line": "Try to cover as many assets as possible. Like, you know, the major assets in the network. And once you explain this, then find out which vulnerabilities are very high and what you need to do for. And you have also presented the same study. Yeah, that is what is required. You have also presented the case studies. So that's good, you know, because there are grades for justifying your, you know, justifying your approach as well for selecting the high risk. So this is excellent work. Good."
        },
        {
          "speaker": "(1.26s - 1.33s) Isaac PANG",
          "line": "Sorry, what was good? What was good, sir? I missed that."
        },
        {
          "speaker": "(1.35s - 1.43s) Suchi Dhir",
          "line": "Okay, I'm saying that you have also provided the case studies, right?"
        },
        {
          "speaker": "(1.44s - 1.45s) Isaac PANG",
          "line": "So, yes."
        },
        {
          "speaker": "(1.45s - 1.52s) Suchi Dhir",
          "line": "Okay. That is a good way to justify your selection."
        },
        {
          "speaker": "(1.53s - 2.06s) Isaac PANG",
          "line": "Yeah, yeah. So I just noticed with, I mean, I followed the layout that you suggested initially with the table and the assets and the risks. There's quite a lot of, as you can see obviously with the table that I've made a lot of risks for those two servers. In terms of CVE. I'm just wondering, will I need to include all of those as well as more assets or can I cut some of those out?"
        },
        {
          "speaker": "(2.08s - 2.43s) Suchi Dhir",
          "line": "You can cut some of those and just discuss about the high ones. But if you want to include in the table, you can know, okay, you are presenting it to the, to the board of directors. So if you can present the table with all the risk, that would be, you know, better. That would be."
        },
        {
          "speaker": "(2.43s - 2.56s) Isaac PANG",
          "line": "Yeah, sure. I'm just add on more assets. Yeah. Okay."
        },
        {
          "speaker": "(2.57s - 2.66s) Suchi Dhir",
          "line": "And the case studies are also good, like how you are presenting the case studies. That's very important."
        },
        {
          "speaker": "(2.66s - 2.68s) Isaac PANG",
          "line": "Stuck to cool."
        },
        {
          "speaker": "(2.69s - 2.7s) Suchi Dhir",
          "line": "Yes."
        },
        {
          "speaker": "(2.74s - 2.94s) Isaac PANG",
          "line": "One thing I was just going to ask, when it says the server upgrades, does that mean just updating the software or replacing the hardware completely?"
        },
        {
          "speaker": "(2.99s - 3.25s) Suchi Dhir",
          "line": "That's replacing the software, not replacing the hardware. So we are upgrading the server to a new, new version so that it does not. It patches all the vulnerabilities, you know, that exists in the previous versions."
        },
        {
          "speaker": "(3.25s - 3.62s) Isaac PANG",
          "line": "Yeah, yeah, that's fine. I was just clarifying that. And then, and so I guess if we upgrade the software, we're still liable to the cost of the legacy software renewal at 25,000, right, right, yeah. Okay. That's cool, that's fine."
        },
        {
          "speaker": "(3.65s - 3.82s) Suchi Dhir",
          "line": "So now, like, you know, the approach, what you have taken is good. That's what I was looking at. The next thing is how you're going to present this information."
        },
        {
          "speaker": "(3.83s - 3.83s) Isaac PANG",
          "line": "Yeah."
        },
        {
          "speaker": "(3.84s - 3.98s) Suchi Dhir",
          "line": "Because you have ten minutes and you need to ensure that at least major assets you have covered in your table."
        },
        {
          "speaker": "(3.99s - 4.0s) Isaac PANG",
          "line": "Yeah."
        },
        {
          "speaker": "(4.02s - 4.23s) Suchi Dhir",
          "line": "And like, for example, for Siemens, you can just talk about the first vulnerability, which is high, and rest of them, you can just hide it. You know, that's not required."
        },
        {
          "speaker": "(4.23s - 4.26s) Isaac PANG",
          "line": "Let's talk about."
        },
        {
          "speaker": "(4.28s - 4.46s) Suchi Dhir",
          "line": "Because in any case, you would be first, you know, this financial year, you can only handle the vulnerabilities, which are high risk."
        },
        {
          "speaker": "(4.47s - 4.64s) Isaac PANG",
          "line": "Yes. And so I guess for the ScADA server, just talk about the ones that are ranked 9.8, those really high ones."
        },
        {
          "speaker": "(4.65s - 4.69s) Suchi Dhir",
          "line": "That's very high. Yeah. These two you can."
        },
        {
          "speaker": "(4.71s - 4.95s) Isaac PANG",
          "line": "Yeah, that's fine. Okay, sure. That's not a problem. I was just mainly wanting to clarify that as well as the server question and I think all should be well now. Yeah, great. That's awesome."
        },
        {
          "speaker": "(4.95s - 4.98s) Suchi Dhir",
          "line": "Any other questions?"
        },
        {
          "speaker": "(4.99s - 5.28s) Isaac PANG",
          "line": "Do you have any one? Maybe one sec. I noticed in the. Actually, don't worry, that's fine. No, all good. Yeah, that's fine. Great."
        },
        {
          "speaker": "(5.28s - 5.58s) Suchi Dhir",
          "line": "Then I speak to you next Wednesday. Presentation would be ready, but I'm sure now you have. You have selected the right approach, so you would be able to, you know, align your answer accordingly."
        },
        {
          "speaker": "(5.58s - 5.65s) Isaac PANG",
          "line": "Yeah. Yes. Yeah, yeah. Thank you. You've provided great insight."
        },
        {
          "speaker": "(5.66s - 5.69s) Suchi Dhir",
          "line": "Yeah, no worries."
        },
        {
          "speaker": "(5.7s - 5.76s) Isaac PANG",
          "line": "Thanks very much. Thank you, Shuchi. All right, I'll speak to you next week."
        },
        {
          "speaker": "(5.77s - 5.79s) Suchi Dhir",
          "line": "Yes. Bye bye. Thank you."
        },
        {
          "speaker": "(5.79s - 5.8s) Isaac PANG",
          "line": "Thank you. Goodbye."
        }
      ],
      "date": "2024-07-24T02:34:27.742351Z"
    },
    {
      "file_name": "9da2c1a4-2695-447b-89e5-27838ed3eb9e.wav",
      "file_url": "https://s3-ap-southeast-2.amazonaws.com/linc-recordings/9da2c1a4-2695-447b-89e5-27838ed3eb9e.wav",
      "duration": 111,
      "transcription": [
        {
          "speaker": "(0.01s - 0.02s) Isaac PANG",
          "line": "Hello?"
        },
        {
          "speaker": "(0.03s - 0.07s) Suchi Dhir",
          "line": "Hi, is that doctor Shuchi here? How are you doing?"
        },
        {
          "speaker": "(0.08s - 0.1s) Isaac PANG",
          "line": "Good, thank you."
        },
        {
          "speaker": "(0.1s - 0.17s) Suchi Dhir",
          "line": "Yeah, I'm doing great, thank you. So how is your progress on the assignment?"
        },
        {
          "speaker": "(0.2s - 0.29s) Isaac PANG",
          "line": "I'm good. I just. I need to record it and then that should be fine."
        },
        {
          "speaker": "(0.29s - 0.33s) Suchi Dhir",
          "line": "Okay, great. Any questions? Any queries?"
        },
        {
          "speaker": "(0.41s - 0.57s) Isaac PANG",
          "line": "No, I don't. I don't think so. Is there any leeway over the ten minutes? Is there, like, plus or -10% or anything like that?"
        },
        {
          "speaker": "(0.59s - 0.65s) Suchi Dhir",
          "line": "Yes. Plus or -10% should be acceptable, yes."
        },
        {
          "speaker": "(0.66s - 0.89s) Isaac PANG",
          "line": "Okay. What else? No, I think that's fine, I guess. How much in text referencing do you want to see in the PowerPoint slideshow?"
        },
        {
          "speaker": "(0.89s - 1.1s) Suchi Dhir",
          "line": "How much? I mean, like, whatever you are, you know, wherever you are, you know, providing the facts, please ensure that, you know, you support them with the references."
        },
        {
          "speaker": "(1.11s - 1.29s) Isaac PANG",
          "line": "That okay? Yeah. Oh, yeah. Fine. And then I think. I think that's okay, to be honest. Like, I just record it and then put it together and I'll submit it."
        },
        {
          "speaker": "(1.3s - 1.36s) Suchi Dhir",
          "line": "Okay, sure. No worries. Any other questions? Any other worries?"
        },
        {
          "speaker": "(1.37s - 1.56s) Isaac PANG",
          "line": "Um, not really, actually. I think. I think that should all be pretty okay for now. Okay. Yeah, I think I've got everything."
        },
        {
          "speaker": "(1.56s - 1.66s) Suchi Dhir",
          "line": "Okay, then I'll book our call for next week and. Yeah, we can discuss."
        },
        {
          "speaker": "(1.69s - 1.71s) Isaac PANG",
          "line": "Yes, that should be fun."
        },
        {
          "speaker": "(1.71s - 1.73s) Suchi Dhir",
          "line": "Okay, sure."
        },
        {
          "speaker": "(1.74s - 1.75s) Isaac PANG",
          "line": "Awesome."
        },
        {
          "speaker": "(1.75s - 1.78s) Suchi Dhir",
          "line": "Have a great day. Bye."
        },
        {
          "speaker": "(1.78s - 1.8s) Isaac PANG",
          "line": "Awesome. You too. Thank you very much. Bye."
        }
      ],
      "date": "2024-07-31T06:02:25.191678Z"
    },
    {
      "file_name": "ffe1aeff-b3f1-4ea3-88fa-e44e31a43be3.wav",
      "file_url": "https://s3-ap-southeast-2.amazonaws.com/linc-recordings/ffe1aeff-b3f1-4ea3-88fa-e44e31a43be3.wav",
      "duration": 853,
      "transcription": [
        {
          "speaker": "(0.02s - 0.03s) Isaac PANG",
          "line": "Hello."
        },
        {
          "speaker": "(0.04s - 0.08s) Suchi Dhir",
          "line": "Hi, good morning. Is that, how are you doing?"
        },
        {
          "speaker": "(0.09s - 0.11s) Isaac PANG",
          "line": "Good, thank you. How are you?"
        },
        {
          "speaker": "(0.12s - 0.29s) Suchi Dhir",
          "line": "I'm doing great, thank you. That's good. Yeah. Would like to know your issue. So with this not so."
        },
        {
          "speaker": "(0.29s - 0.5s) Isaac PANG",
          "line": "Yep. I just sent you some, some more images of my rules on email. So you had like a better understanding of what, what I'm doing."
        },
        {
          "speaker": "(0.53s - 0.58s) Suchi Dhir",
          "line": "When did you share it with me? Because I didn't receive any email."
        },
        {
          "speaker": "(0.59s - 0.62s) Isaac PANG",
          "line": "I just sent it like just then."
        },
        {
          "speaker": "(0.63s - 0.64s) Suchi Dhir",
          "line": "Okay."
        },
        {
          "speaker": "(0.65s - 0.66s) Isaac PANG",
          "line": "Yeah."
        },
        {
          "speaker": "(1.35s - 1.42s) Suchi Dhir",
          "line": "I didn't receive your email. Is that, do you want me to connect through any desk?"
        },
        {
          "speaker": "(1.5s - 1.7s) Isaac PANG",
          "line": "Sure, yeah, I just sent it a minute ago. But yeah, we can connect via. I'm not sure how, how do you normally connect?"
        },
        {
          "speaker": "(1.71s - 1.75s) Suchi Dhir",
          "line": "I have received it now. Just give me a second."
        },
        {
          "speaker": "(1.75s - 1.77s) Isaac PANG",
          "line": "Oh, you got it? Yeah."
        },
        {
          "speaker": "(1.94s - 2.1s) Suchi Dhir",
          "line": "Attachment. So can you just give me an overview of what you are doing and."
        },
        {
          "speaker": "(2.14s - 5.46s) Isaac PANG",
          "line": "Yeah, so, yeah, yeah. So hold on, I'm just going to get up the instructions so I can follow through. Okay. So the first, the first task was to do with the SSH stuff. So I installed the openssh and then I used the command like Ssh keygen RSA 4096 to generate ssh keys on the windows machine. And then I copied those over to the Ubuntu machine. And then I went into the config file, into SshD config. And then I configured the SsH to use only key based authentication. So I changed password authentication to no, and then pub key authentication to yes. And then I also changed the ports to 22 33. I created a banner in a file, and then I unhashtag the banner line and then put the path to where the banner is. So that was in the issue.net file. Then I disabled all of those settings as like shown in the instructions, the tcp forwarding, the gateway port, I just said no to all of those. Then I saved the file and restarted the Ssh service using the Sudo system Ctl restart my Sshd command. So that was my, that was for step one, and then moving on to, sorry, step two. So I configured, oh yeah, I configured the snort for whitelisting. So I went into the snort configuration file, and next to the home. Net kind of line, I added the IP address of the windows machine, which is 1921-6801 sorry. And then I created rules for their SSH connection. So they're the ones that you kind of can see in the snort configuration file. And then I started snort, so like start listening. And then in the IP tables, that's where I just set up all those, you know, I'm sure you can see, those rules that I've put in ips."
        },
        {
          "speaker": "(5.48s - 5.76s) Suchi Dhir",
          "line": "The screenshots that you have shared with me, they all look good. Like, whatever configurations are required, you have completed them. So then when you are running this notch, are you able to see the messages? Like, you know."
        },
        {
          "speaker": "(5.81s - 6.34s) Isaac PANG",
          "line": "I'm not sure. I get, like, strange. I get these like from like 8888 and I know that's the Google DNS server. I'm just not sure, like, what all that is. And I can see like block traffic and stuff. So, you know, my rules are working. I'm pretty sure they're working, and I don't see why they wouldn't be working, but. Yeah."
        },
        {
          "speaker": "(6.34s - 6.58s) Suchi Dhir",
          "line": "One question. When you have created your ssh key to login into the SsH server step by step. So are you able to login into SSH server?"
        },
        {
          "speaker": "(6.59s - 7.49s) Isaac PANG",
          "line": "Yeah, so it's working. So I can log into the ssh via the host machine, the windows, and then I can't log in via Kali. So I know that it's working properly. I guess my thing is I can't seem to find, like the ssh. What's the message that we've got? It needs to say Ssh traffic. I'm not sure, like wherever. Like all these log entries are because I went through all the tasks to do for the recording and it seems to be okay. Like, you know, they seem to be performing as I would want them to perform. But then it. When it says for step eight, filter the firewall and ids logs to explain the evidence, I think my problem. I'm not sure if I'm, like, looking in the right areas for these logs because I can't seem to find them."
        },
        {
          "speaker": "(7.56s - 7.66s) Suchi Dhir",
          "line": "Okay, so you're not able to find the logs which were exactly in the snot."
        },
        {
          "speaker": "(7.66s - 7.71s) Isaac PANG",
          "line": "Yeah, I'm just having trouble where to look exactly."
        },
        {
          "speaker": "(7.72s - 7.83s) Suchi Dhir",
          "line": "Okay, see, alerts, the logs in the snot would be stored in where? Log and snot folder."
        },
        {
          "speaker": "(7.87s - 7.93s) Isaac PANG",
          "line": "Log snow."
        },
        {
          "speaker": "(7.93s - 8.07s) Suchi Dhir",
          "line": "No, log and snore folder. That's where you have to, you know, look your alerts into."
        },
        {
          "speaker": "(8.08s - 8.13s) Isaac PANG",
          "line": "Yeah. So that's log snore."
        },
        {
          "speaker": "(8.15s - 9.07s) Suchi Dhir",
          "line": "Yes. So if you. Because rules are correct. I have seen your rules. And if you know the rules are correct. And when you start wrong running this not into logging mode, you have to run snot into logging mode, not into the test mode. So when you run this not in test mode, you should see all the alerts on the screen itself. And if you're running this not in logging mode, then it will log all the messages, all the alerts in the log file. And you can find the log file at this location where locks not. Okay, so there would be an alerts file, you know, so when you go to where logs not an alerts file, you see that, you know, all the alerts would be saved over there."
        },
        {
          "speaker": "(9.09s - 9.16s) Isaac PANG",
          "line": "Okay, so I need to run it in logging mode."
        },
        {
          "speaker": "(9.16s - 9.36s) Suchi Dhir",
          "line": "Yes. So there is a different command to, you know, run snot in logging mode. And there is a different command to run snot in a testing mode."
        },
        {
          "speaker": "(9.39s - 9.4s) Isaac PANG",
          "line": "Okay."
        },
        {
          "speaker": "(9.41s - 10.09s) Suchi Dhir",
          "line": "When you run snot in logging mode, then only it's going to generate the log and store it in the log file. And another thing, you need to ensure that in your snot configuration file you have specified the permission to change and edit the Verilog snort file. So that is something you just check your configuration file and just see that this directory is accessible."
        },
        {
          "speaker": "(10.1s - 10.16s) Isaac PANG",
          "line": "So it needs to be to the log var snort file."
        },
        {
          "speaker": "(10.18s - 10.23s) Suchi Dhir",
          "line": "Yes, where lock not I have."
        },
        {
          "speaker": "(10.24s - 10.26s) Isaac PANG",
          "line": "Okay. Yeah, sure."
        },
        {
          "speaker": "(10.28s - 10.59s) Suchi Dhir",
          "line": "Right. And you have to execute this not in logging mode then only it's going to log the information and store the information in the alerts file. And if you just run it in the testing mode, then it's not going to log it into the log file."
        },
        {
          "speaker": "(10.59s - 10.77s) Isaac PANG",
          "line": "Okay, and then when I go into the alerts file, can I just cat or can I cat the alert file and then it will show all the logs."
        },
        {
          "speaker": "(10.78s - 10.81s) Suchi Dhir",
          "line": "Yes, that's what you have to do."
        },
        {
          "speaker": "(10.81s - 10.92s) Isaac PANG",
          "line": "Okay. And then I guess, can I also grep it like use the grep command to find specific things?"
        },
        {
          "speaker": "(10.94s - 10.96s) Suchi Dhir",
          "line": "Yeah, you can do."
        },
        {
          "speaker": "(10.96s - 11.04s) Isaac PANG",
          "line": "So, okay, so either is okay, right?"
        },
        {
          "speaker": "(11.04s - 11.3s) Suchi Dhir",
          "line": "I, so first you look into see another thing that these, you know, files, you can view them in the wireshark. So you know, either you will have to use TCP dump or you'll have to use wireshark to actually view these files."
        },
        {
          "speaker": "(11.34s - 11.42s) Isaac PANG",
          "line": "Oh, so yeah, I have to use wireshark door."
        },
        {
          "speaker": "(11.43s - 11.74s) Suchi Dhir",
          "line": "Yes. Either wireshark or you, you will have to use TCP dump to view these files because they won't be in your plaintext format, they would be in a binary format. So you cannot view them directly when you see these files."
        },
        {
          "speaker": "(11.77s - 11.78s) Isaac PANG",
          "line": "Okay."
        },
        {
          "speaker": "(11.79s - 12.11s) Suchi Dhir",
          "line": "When you go to this directory, log directory where log snort directory, you will see that all these alert files would be generated with some number, right? So you know, there would be, you have to just open them in Wireshark."
        },
        {
          "speaker": "(12.13s - 12.15s) Isaac PANG",
          "line": "Okay."
        },
        {
          "speaker": "(12.17s - 12.38s) Suchi Dhir",
          "line": "And in wireshark you don't need to use Grep command, but there you would be having the filter box and you can just write down the commands over there and you can view what you want to, you know."
        },
        {
          "speaker": "(12.38s - 12.52s) Isaac PANG",
          "line": "Okay, that's fine. So yeah, so maybe that was my issue. I wasn't using wireshark to view them."
        },
        {
          "speaker": "(12.58s - 12.85s) Suchi Dhir",
          "line": "So maybe you're not using the right command to run the wireshark. I think if you do little more research, you will find out different commands, you know, to run the wireshark in test mode. To run wireshark and logging mode."
        },
        {
          "speaker": "(12.85s - 12.88s) Isaac PANG",
          "line": "Do you mean, do you mean snort?"
        },
        {
          "speaker": "(12.89s - 12.92s) Suchi Dhir",
          "line": "Yeah, snort. Sorry."
        },
        {
          "speaker": "(12.92s - 13.01s) Isaac PANG",
          "line": "Yeah. Yes, no, okay. Yeah, that'll be the first thing then, that I'll do."
        },
        {
          "speaker": "(13.03s - 13.08s) Suchi Dhir",
          "line": "Yes, so do that and let me know how it goes."
        },
        {
          "speaker": "(13.09s - 13.25s) Isaac PANG",
          "line": "Yeah, I will. Yeah, I think, I think because all the commands are fine. Seem to be okay. It's just this final bit, I just need a. Yeah, yeah."
        },
        {
          "speaker": "(13.26s - 13.49s) Suchi Dhir",
          "line": "Your screenshots look good. Your IP tables rules are correct. And then the alerts that you have created, they're also correct. And you're saying that you're able to log in, into SsH server with the ss?"
        },
        {
          "speaker": "(13.52s - 13.65s) Isaac PANG",
          "line": "Yeah, it seems to be working fine. So that's why I was just confused with the logs."
        },
        {
          "speaker": "(13.68s - 13.83s) Suchi Dhir",
          "line": "Yes. So that's a bit, I think. Yeah, you complete that and if, in case, if you have any issues, let me know."
        },
        {
          "speaker": "(13.83s - 13.91s) Isaac PANG",
          "line": "Yeah, I will. But thanks for your advice. I'll work on that now. Try and get that sorted."
        },
        {
          "speaker": "(13.92s - 13.95s) Suchi Dhir",
          "line": "Sure. Any other queries?"
        },
        {
          "speaker": "(13.96s - 14.07s) Isaac PANG",
          "line": "Um, no, no, I think, I think that's all good. Um, yeah, no thanks. That's, that's a big help."
        },
        {
          "speaker": "(14.08s - 14.1s) Suchi Dhir",
          "line": "Okay. All the best."
        },
        {
          "speaker": "(14.1s - 14.18s) Isaac PANG",
          "line": "Have a great day. Thanks very much. Bye bye. See ya."
        }
      ],
      "date": "2024-08-11T02:03:09.503731Z"
    },
    {
      "file_name": "285508b1-92ff-456f-839f-203f9f14f8a9.wav",
      "file_url": "https://s3-ap-southeast-2.amazonaws.com/linc-recordings/285508b1-92ff-456f-839f-203f9f14f8a9.wav",
      "duration": 182,
      "transcription": [
        {
          "speaker": "(0.01s - 0.02s) Isaac PANG",
          "line": "Hello?"
        },
        {
          "speaker": "(0.03s - 0.14s) Suchi Dhir",
          "line": "Hi, is that doctor Shuchi here? I'm sorry, got little delayed in connecting with you. Is it good to connect with you?"
        },
        {
          "speaker": "(0.15s - 0.17s) Isaac PANG",
          "line": "Yes, ma'am."
        },
        {
          "speaker": "(0.18s - 0.27s) Suchi Dhir",
          "line": "Okay, great. So how is your progress? Have you started working on week one content?"
        },
        {
          "speaker": "(0.28s - 0.33s) Isaac PANG",
          "line": "I finished week one content and I finished the quiz."
        },
        {
          "speaker": "(0.34s - 0.48s) Suchi Dhir",
          "line": "Okay, that's really good to know. So amalek, iptables, UFW. Any questions? Any queries?"
        },
        {
          "speaker": "(0.51s - 0.72s) Isaac PANG",
          "line": "No, not really. Everything seems to be okay right now. I'm currently just doing the week two content. I'm doing the snort stuff in week two. That's what I'm doing right now."
        },
        {
          "speaker": "(0.73s - 0.74s) Suchi Dhir",
          "line": "Okay."
        },
        {
          "speaker": "(0.74s - 0.75s) Isaac PANG",
          "line": "Yep."
        },
        {
          "speaker": "(0.75s - 1.93s) Suchi Dhir",
          "line": "So these tools like iptables and snort surikata, all these tools are very, very important. So if possible, spend additional time. Let me know if you need any notes on iptables or snot. If you have some time and want to spend additional time working on this course, I will share with you. And if you have gone through the assignment. So for the first assignment from week one, ScAdA security is important. Then understanding firewall management, that's also very important. So that's for the first assignment, media assignment, you know, where you have to submit a video. And for the second assignment, again, your ids, which is not a surikata or maybe iptables. So all those things are important. So ensure that when you are going through these topics, you also look into the assignment requirements so that, you know, you study or you study these topics as per the requirements of the assignment."
        },
        {
          "speaker": "(1.94s - 2.11s) Isaac PANG",
          "line": "Yeah, sure. I'll go back and have a look at the assignment today. I think the first one with the second quiz is that just week two content."
        },
        {
          "speaker": "(2.15s - 2.24s) Suchi Dhir",
          "line": "The second quiz has to be, I think, from week one and week two both."
        },
        {
          "speaker": "(2.24s - 2.34s) Isaac PANG",
          "line": "So yeah, the second quiz is week one and week two. So once I finish week two content, I'll be able to do the second quiz."
        },
        {
          "speaker": "(2.35s - 2.46s) Suchi Dhir",
          "line": "Right. So once you complete that, then you can take the second quiz, right?"
        },
        {
          "speaker": "(2.46s - 2.51s) Isaac PANG",
          "line": "Yeah. Yeah. Awesome. Yeah, no problems. That's cool."
        },
        {
          "speaker": "(2.52s - 2.55s) Suchi Dhir",
          "line": "Great. Any other questions?"
        },
        {
          "speaker": "(2.57s - 2.7s) Isaac PANG",
          "line": "Not right now. I think. I think I'm all good at the moment. When I get to the assignment, I'll probably have more questions then. But as for now."
        },
        {
          "speaker": "(2.71s - 2.84s) Suchi Dhir",
          "line": "Yeah, so I will connect with you next week. Wednesday, 10:00 a.m. i'm sorry, I just the invite which I have sent you."
        },
        {
          "speaker": "(2.85s - 2.91s) Isaac PANG",
          "line": "Yeah, that's okay. Yeah, not a problem."
        },
        {
          "speaker": "(2.91s - 2.92s) Suchi Dhir",
          "line": "Great then."
        },
        {
          "speaker": "(2.95s - 2.99s) Isaac PANG",
          "line": "Thanks so much. All right then, see you later."
        },
        {
          "speaker": "(2.99s - 3.0s) Suchi Dhir",
          "line": "Goodbye."
        }
      ],
      "date": "2024-07-11T02:41:53.845209Z"
    },
    {
      "file_name": "935775e8-a18f-4121-9bdd-4aa23d6f607f.wav",
      "file_url": "https://s3-ap-southeast-2.amazonaws.com/linc-recordings/935775e8-a18f-4121-9bdd-4aa23d6f607f.wav",
      "duration": 466,
      "transcription": [
        {
          "speaker": "(0.02s - 0.03s) Isaac PANG",
          "line": "Hello?"
        },
        {
          "speaker": "(0.05s - 0.09s) Suchi Dhir",
          "line": "Hi, is that doctor Shuchi here from UC?"
        },
        {
          "speaker": "(0.11s - 0.13s) Isaac PANG",
          "line": "Hi, how are you doing?"
        },
        {
          "speaker": "(0.16s - 0.2s) Suchi Dhir",
          "line": "I'm doing great, thank you. How are you doing?"
        },
        {
          "speaker": "(0.21s - 0.23s) Isaac PANG",
          "line": "I'm good, thank you."
        },
        {
          "speaker": "(0.23s - 0.26s) Suchi Dhir",
          "line": "Can you hear me okay?"
        },
        {
          "speaker": "(0.26s - 0.33s) Isaac PANG",
          "line": "Great. Yeah, I can hear you a little bit. Yeah. Yeah."
        },
        {
          "speaker": "(0.38s - 0.5s) Suchi Dhir",
          "line": "So how is your progress on your studies? Have you started working on week two content? Any questions?"
        },
        {
          "speaker": "(0.53s - 0.63s) Isaac PANG",
          "line": "I finished week three, so right now I'm just writing up the first assignment."
        },
        {
          "speaker": "(0.66s - 0.78s) Suchi Dhir",
          "line": "Oh, that's great. Good. Any questions on understanding the first assignment requirements?"
        },
        {
          "speaker": "(0.84s - 1.25s) Isaac PANG",
          "line": "I guess if we're picking the second option, which is $60,000, the other options, because the budget is 70,000, there's no option for a $10,000 option. So obviously would we have to argue why we'd need something else?"
        },
        {
          "speaker": "(1.31s - 4.24s) Suchi Dhir",
          "line": "Yes, that's a, what you have to do. See, the first thing is you need, that's the first thing, like in the current system, you need to identify all the risk and vulnerabilities. Then you will have to use, you will have to use any risk assessment framework, let's say NIST or ISO framework. You need to prioritize the risk that you have identified. You have to do risk ranking. Right. And since you already only have $70,000 in your hand, you have to keep it for both, you know, operational expenditures, you will have to keep it for capital expenditures as well. So you cannot spend entire amount on procuring something. And I, you know, just don't keep it for any other expenditures that the organization may incur in the, you know, one year. So that is something. Another thing is, after you have done, after you applied the risk assessment framework and completed your risk ranking, you have to identify, you know, top two, or maybe, let's say top three, immediate, you know, risk that needs to be handled, that can actually hamper the working of the entire process, the working of that enterprise, not enterprise, but operational network, because you cannot make that operational network sit idle due to a ransomware attack or due to any other kind of attack. Right. So here we just want to see how students are able to understand, you know, doing risk rankings, how well they are able to justify the risk. You know, the top risk that needs to, that needs immediate attention. And another thing that you learned from this is budget planning. Because you have a limited budget in your hands now, you can go by the first option or second option. That's your choice. But I don't say that going by first option is better as compared to the second one because it all depends on how well students are justifying that. See, if you do not spend on security controls and you bring down entire operational network down. That also is inefficiency on your part. So it's more. Zach, we are looking into the justification kind of thing. You know how well you are able to justify this."
        },
        {
          "speaker": "(4.25s - 4.31s) Isaac PANG",
          "line": "Yeah, yeah. That's all good. Okay, cool. Thanks."
        },
        {
          "speaker": "(4.34s - 4.73s) Suchi Dhir",
          "line": "Yesterday, along with my mail, I also wanted to share one, you know, a book chapter on risk assessment, but I could not download it. I would be sharing it today. Just look into that. You know how this metrics and all those things are applied. Another thing in this report you have. You have to calculate the residual risk."
        },
        {
          "speaker": "(4.74s - 4.76s) Isaac PANG",
          "line": "The what? Sorry."
        },
        {
          "speaker": "(4.76s - 6.06s) Suchi Dhir",
          "line": "So residual. You have to calculate the residual risk. That is like, after applying the security controls, what risk is left with the organization? Right. By giving you presentation, you would say, these are the risk and these are the immediately immediate risk that needs attention because we have just connected our operational network to the enterprise network. And these are the residual risk. Visual risk are the risks that still remaining. But since you have applied some controls, they. The risk is moderate. You know, that's not very high. You have to ensure that all the high risk factors you have addressed, I mean, like, even if you have less jets and the factor is very high, you need to ask board of members that you need additional amount of money for this, or you may be spending entire $70,000 in implementing the controls. We are verifying with that. Right. Because your responsibility to address the high risk. Yeah, but moderate risk or less likely. Less likely risk can be, you know, addressed in the coming years."
        },
        {
          "speaker": "(6.09s - 6.11s) Isaac PANG",
          "line": "Yeah, sure. Okay."
        },
        {
          "speaker": "(6.11s - 6.47s) Suchi Dhir",
          "line": "So that. So basically, I think more of your efforts would be in identifying the threats and then doing the risk assessment. You know, I mean, like risk rankings, creating the risk metrics, understanding the residual risk. These are some of the key tasks of your assignments."
        },
        {
          "speaker": "(6.47s - 6.52s) Isaac PANG",
          "line": "Yep. That's fine. No worries."
        },
        {
          "speaker": "(6.55s - 6.66s) Suchi Dhir",
          "line": "Great. So if you want to, I mean, if your draft would be ready early, just share your draft with me. I look into that."
        },
        {
          "speaker": "(6.66s - 6.77s) Isaac PANG",
          "line": "I will. Yeah. Yeah. I'll probably get that to you tomorrow. I want to try and have it done. I'll send it to you."
        },
        {
          "speaker": "(6.77s - 6.85s) Suchi Dhir",
          "line": "Great. That's good progress. Sure. You just share it with me over email."
        },
        {
          "speaker": "(6.87s - 6.91s) Isaac PANG",
          "line": "Yeah, I'll send it to you. Yeah, not a problem."
        },
        {
          "speaker": "(6.94s - 7.15s) Suchi Dhir",
          "line": "Great. And then hands on activities like Surikata and the other tools. Are you comfortable? Have you completed all those activities?"
        },
        {
          "speaker": "(7.15s - 7.22s) Isaac PANG",
          "line": "Oh, yeah, I completed all those. They were fine. They were good. They were interesting."
        },
        {
          "speaker": "(7.25s - 7.32s) Suchi Dhir",
          "line": "Great. That's great. Any other questions that you would like to discuss?"
        },
        {
          "speaker": "(7.34s - 7.55s) Isaac PANG",
          "line": "No, what I'll do is I'll try and get that draft to you shortly. Like maybe by the end of day tomorrow. Just so you can have a look over it and see what it's like. And then it should be good from there."
        },
        {
          "speaker": "(7.58s - 7.66s) Suchi Dhir",
          "line": "Okay, sure. Thank you. Then I'll speak to you next week, same time. Bye. Take care."
        },
        {
          "speaker": "(7.66s - 7.74s) Isaac PANG",
          "line": "Cool, thanks. Thank you, Shuji. See you later. Thank you. Bye bye."
        },
        {
          "speaker": "(7.74s - 7.74s) Suchi Dhir",
          "line": "Take care."
        }
      ],
      "date": "2024-07-17T02:04:12.287732Z"
    },
    {
      "file_name": "01564bea-b614-44ae-bc64-d8833cdd8ede.wav",
      "file_url": "https://s3-ap-southeast-2.amazonaws.com/linc-recordings/01564bea-b614-44ae-bc64-d8833cdd8ede.wav",
      "duration": 1526,
      "transcription": [
        {
          "speaker": "(0.02s - 0.03s) Isaac PANG",
          "line": "Hello."
        },
        {
          "speaker": "(0.03s - 0.08s) Suchi Dhir",
          "line": "Hi, Zach. Doctor Shuchi here from ECU. How are you doing?"
        },
        {
          "speaker": "(0.09s - 0.1s) Isaac PANG",
          "line": "Good, and yourself?"
        },
        {
          "speaker": "(0.11s - 0.15s) Suchi Dhir",
          "line": "Yeah, I'm doing great, thank you."
        },
        {
          "speaker": "(0.15s - 0.18s) Isaac PANG",
          "line": "Good. Thank you for the call."
        },
        {
          "speaker": "(0.18s - 0.24s) Suchi Dhir",
          "line": "Yeah, no worries. What are your queries then, on the feedback?"
        },
        {
          "speaker": "(0.26s - 0.78s) Isaac PANG",
          "line": "Yeah, your feedback is fine. I just had a few questions. The first one was, so with option two, our budget is only 70,000. Right. But option two itself makes up 60,000 just by itself. And then in your email you mentioned, like, you have to talk about the ongoing cost for legacy renewal, and that's $25,000. So if you're picking, if you're picking. If you're picking option two, you're automatically going over budget."
        },
        {
          "speaker": "(0.78s - 2.02s) Suchi Dhir",
          "line": "Right. So if you are picking option two, you need to provide a sound justification of why you want organization to spend additional costs. So for that you need to do risk assessment really well. And your risk assessment should be accompanied with some case studies, some examples where, you know, do little research. Find out any examples where because of less security controls, organizations, you know, they have suffered terrible losses because of hacking of their operational network. So you need to find out some case studies just to ensure that if you do not spend another $30,000 now, or maybe let's say $25,000 this year, then it's going to have a massive impact on the reputation on the business because the network may be down. So, you know, we are not saying that option one is the best option. And option two, you should not select. It's how you are justifying it, you know, so you are, you need to know that this is important."
        },
        {
          "speaker": "(2.04s - 2.28s) Isaac PANG",
          "line": "Yeah, yeah, yeah, that's fine. I just, I just thought, I mean, really, then the budget is really only $45,000 outside of the ongoing cost."
        },
        {
          "speaker": "(2.28s - 2.32s) Suchi Dhir",
          "line": "Right, right."
        },
        {
          "speaker": "(2.32s - 2.55s) Isaac PANG",
          "line": "Because that takes up quite a huge portion of 70,025. So, yeah, I'm actually considering switching, switching to option one mixed with the Internet based."
        },
        {
          "speaker": "(2.59s - 3.2s) Suchi Dhir",
          "line": "That's your choice. But you can also think of other options, you know, like, anyhow, you have to have license renewal, you know, 25,000. But is there any way, like can you think of negotiating flexible payment terms with the vendor and, you know, somehow managing it in other ways, like finding out what are the other ways, any other subscription offers? I mean, think what, whatever you can justify. Well, you can present that."
        },
        {
          "speaker": "(3.21s - 3.22s) Isaac PANG",
          "line": "Okay."
        },
        {
          "speaker": "(3.23s - 3.32s) Suchi Dhir",
          "line": "But this is something you need the, you know, licenses because you're running the software."
        },
        {
          "speaker": "(3.35s - 3.76s) Isaac PANG",
          "line": "Yeah. Okay. Okay. The other thing was with the, the ranking, the risks. So I realized that I only had, you know, three security risks because I figured I'd just list the main ones but then when you mentioned, you know, list more, I've listed all."
        },
        {
          "speaker": "(3.76s - 4.84s) Suchi Dhir",
          "line": "First you have to list all, and then you're, you know, you're doing risk assessment. You need to think about all the assets which are there. You know, it's not only operational network, but now it's connected to the enterprise network as well. Find out, first list out all the assets that you have and ensure that you have done risk assessment for all the assets. And then do the ranking, you know, so first do the proper risk identification. And while doing risk identification, all assets needs to be taken care of. You know, everything, whatever you have. You have a web server, you have a mail server, VPN server. You know, there are computers, it department computers are there. So you need to think of all the, you know, assets which are there. At least find out the major threats that are possible and then do the, you know, ranking of those it and justify."
        },
        {
          "speaker": "(4.86s - 5.17s) Isaac PANG",
          "line": "Right. So with the security risks, it's not really just like lateral movement between networks. You want us to be more specific with like, the devices that are on the network."
        },
        {
          "speaker": "(5.18s - 5.89s) Suchi Dhir",
          "line": "Yes. That's how you identify the risk. You know, risks are always associated with the assets which are part of the organization. And once you have identified all the risk, then the next comes your risk ranking. Right. When you are doing risk ranking, either you will have to, either you will have to refer to NVD, you know, or you will have to refer to CVSS scoring scores just to justify that, you know, as per the CVSS score, this vulnerability is also in Nvidia. So then you can say that this is the highest risk that we have to."
        },
        {
          "speaker": "(5.89s - 6.28s) Isaac PANG",
          "line": "Yeah. So, yeah, I was wondering about the ranking of the risk. I mean, I'm using a risk matrix now. And would that be okay to justify like, you know, with the likelihood on one axis and impact on the other? And then you talk. I was going to rank it that way. But then you just mentioned CVSS score, CBSS scores, right."
        },
        {
          "speaker": "(6.28s - 6.56s) Suchi Dhir",
          "line": "You just refer to them as well. Or the recent threat reports, at least the risk that you have identified should be aligned with these reports or, you know, should be having a higher priority as per the CVSS scoring system also."
        },
        {
          "speaker": "(6.58s - 6.59s) Isaac PANG",
          "line": "Right."
        },
        {
          "speaker": "(6.6s - 7.12s) Suchi Dhir",
          "line": "That is important, you know. So see, you cannot, as a CISO, it's a very, very critical decision that you are taking. You are spending, you know, the amount. So when you are spending the amount, you need to be very sure that you are spending it for the correct thing. So see, you understand that we will be looking into your assessment as how well you have done the, you know, justification of the choice that you have proposed."
        },
        {
          "speaker": "(7.13s - 7.15s) Isaac PANG",
          "line": "Right."
        },
        {
          "speaker": "(7.19s - 8.43s) Suchi Dhir",
          "line": "If you go with first option, then there are so many things that you can do actually. You know, you can have cyber security training which you would see that in most of the frameworks, you know, essentially NISD frameworks, they, they all always, you know, advise that cybersecurity training is must. And you know, you have seam as well for detecting. In fact you have different options, you know, for the scene that you can select. So you decide your own, you know, whatever you feel that you'll be able to justify. But before selecting any option, first do risk ranking by looking into NVD CBSS scoring scores and then decide that which risks are higher. And then as per that you can decide which option you would be able to justify. Well, but you cannot leave this option nine, you know, that is mandatory. Okay, which is license renewal because you are using legacy software. So for that you need to renew, you need to have the license."
        },
        {
          "speaker": "(8.44s - 8.78s) Isaac PANG",
          "line": "Yeah. And with that, see this is another thing I guess like in the explanation, it says we're not allowed to patch or upgrade the legacy software hardware stuff. Right. But then it says as an option you can have server upgrades for $40,000."
        },
        {
          "speaker": "(8.79s - 8.81s) Suchi Dhir",
          "line": "Right."
        },
        {
          "speaker": "(8.85s - 8.93s) Isaac PANG",
          "line": "Is that not contradictory to what the assessment task is?"
        },
        {
          "speaker": "(8.93s - 11.56s) Suchi Dhir",
          "line": "No, this is not contradictory, but we want students to go through the scenario well and understand it as whatever options are given. So if you think server upgrades are mandatory, there would be like every, you know, we know that, you know, these servers are very important. There would be 24 by seven, we need 24 by seven uptime, right. But there is always a maintenance period for all these servers. Think about, you know, the servers for air ticketing systems. They all would be having a maintenance period when they will be down for some time and there would be upgrade. Right. So that is something also which is part of the, you know, when you are doing the assessment, risk assessment, bia business impact analysis. So during that point of time you will find out that what is the best time to, you know, for the maintenance period when we can put the server on the maintenance period. Right. So you can do that calculation also that if this point of time we will the server upgrade, you can do little research and find out how much time does it take to upgrade a SCADA server, right? So you can find out if it's like one or 2 hours, then midnight when the systems are off and we are not using them, or when there is, you know, very less pressure on these servers, we can go for a server upgrade just to ensure that, you know, they are strong. So once you have hardened these servers, then you can relax and you can install other controls in the coming years, right? Okay. Think of it as your own organization, your own problem, which you have now to resolve, like. And then you would be able to get lot of options. See all the servers, they need to be, you know, up and running for, ideally for 100% of, you know, hundred percent uptime is required. But they all go for maintenance. You know, there is maintenance period for them as well. So you need to find out how much time carda server upgrade and all those things are required and then discuss about that, you know, that let's have them off on Sunday or Saturday or Friday, which is very less workload on them in the night. After twelve we'll put them into upgrade just to ensure that our servers are secure. That's why this option is so that students can think from that perspective as well."
        },
        {
          "speaker": "(11.58s - 11.6s) Isaac PANG",
          "line": "Okay? Yeah, sure."
        },
        {
          "speaker": "(11.63s - 12.11s) Suchi Dhir",
          "line": "We have to secure the servers first. Patching is very important activity all, you know, across the world, all the servers, there always will be a downtime when they would be under maintenance. Right. It's the responsibility of the officers, the team leaders to identify that when that maintenance period would be selected for a particular server, that's where the server upgrades are given over here."
        },
        {
          "speaker": "(12.13s - 12.35s) Isaac PANG",
          "line": "Okay. Just going back to the ranking. So is using a risk matrix, is that good enough to justify a ranking?"
        },
        {
          "speaker": "(12.35s - 12.54s) Suchi Dhir",
          "line": "Yes, that's, that's good. You have to use a risk matrix. And while, you know, selecting your top risk, please do refer to their scores also CVSS scores."
        },
        {
          "speaker": "(12.55s - 13.02s) Isaac PANG",
          "line": "CV's. So with this, I try to like, you know, find CV's scores for some of my vulnerabilities, but when I'm, when I'm looking up like, you know, exploitation of known vulnerabilities and legacy systems, it's quite a generic thing, unless I reference specific vulnerabilities. Is that, is that something, do you want me to, you know, find those specific vulnerabilities and reference those specific."
        },
        {
          "speaker": "(13.03s - 13.61s) Suchi Dhir",
          "line": "The scores are always for the specific vulnerabilities, like I told you, is associated with the assets. So for example, here in your diagram, you have, you know, let me open the diagram. Yep. So you have a scada server, Siemens, you know, win CCOA. Find out the vulnerabilities which are associated with this server. Right. Find out the scoring system of that vulnerability. Whenever you are identifying a risk, it's always associated with assets. It cannot be generic."
        },
        {
          "speaker": "(13.63s - 13.64s) Isaac PANG",
          "line": "Yeah."
        },
        {
          "speaker": "(13.66s - 14.02s) Suchi Dhir",
          "line": "So same way you need to, there is a feeder conveyor belt. You have Siemens simatic SS 1200. You need to find out what vulnerabilities are. There and then if you think that they need to be updated, you need to find out a particular time, then they will be updated. You can justify that, right?"
        },
        {
          "speaker": "(14.03s - 14.04s) Isaac PANG",
          "line": "Yeah. Okay."
        },
        {
          "speaker": "(14.05s - 14.47s) Suchi Dhir",
          "line": "Rather than these servers get hacked and you lose lot of amounts, you know, to a ransomware attack or maybe to some other attack, it's good to have to find or identify a time when these servers can be down for some period and they can be updated, they can be patched so that they are secured against these vulnerabilities as well."
        },
        {
          "speaker": "(14.49s - 14.58s) Isaac PANG",
          "line": "Right. I guess that's if you're picking server upgrade, right?"
        },
        {
          "speaker": "(14.58s - 14.59s) Suchi Dhir",
          "line": "Yes."
        },
        {
          "speaker": "(14.62s - 14.73s) Isaac PANG",
          "line": "Yeah, but if you're not picking server upgrade then you wouldn't discuss that. Really?"
        },
        {
          "speaker": "(14.74s - 14.75s) Suchi Dhir",
          "line": "Yes."
        },
        {
          "speaker": "(14.76s - 14.81s) Isaac PANG",
          "line": "Yeah. Okay. Yeah. All right."
        },
        {
          "speaker": "(14.82s - 15.71s) Suchi Dhir",
          "line": "Whatever security controls you apply, if your server is not secure, there are vulnerabilities. There are, you know, more than 80% of chances that those vulnerabilities will be exploited. Again, this statement, if I need to justify this, I'll try to do a little research and find out that, you know, why patching, why updating servers is very important. So once I get that, I'll add that citation and I'll justify that, you know, upgrading updating our servers, legacy servers is extremely important. Otherwise they will lead us to these vulnerabilities. And Covid first option, if you can upgrade your servers that's the best thing, you know, first you have to handle the vulnerabilities. But again, to decide that, find out what's the CVSS score of these vulnerabilities associated with these assets."
        },
        {
          "speaker": "(15.73s - 15.85s) Isaac PANG",
          "line": "Yeah, so are the ones that I've got in so far as well. Are they, are they okay to keep as well as adding on the."
        },
        {
          "speaker": "(15.86s - 16.24s) Suchi Dhir",
          "line": "You can? Yes, yes, you can. Yeah, but they are incomplete. Like, you know, these are what you are talking, these are very generic vulnerabilities, I would say, you know, risk are always associated with assets, right?"
        },
        {
          "speaker": "(16.24s - 16.26s) Isaac PANG",
          "line": "With what size?"
        },
        {
          "speaker": "(16.26s - 18.07s) Suchi Dhir",
          "line": "With assets. So, yes, so you can, you can claim it in some other ways. For example, for example, yes, contractors devices risk associated like, you know, make a table with assets in one of the column and you say contractors divided devices, third party contractors devices. So that's an asset. What's the risk associated with it? Unauthorized access and, you know, malware infection or other, you know, other infections. So make a table, you know, the way you are presenting effect in one of the columns and the risk associated with it. And then you can say, you know, is it, is the risk moderate, high or low? You know, so something like that. Justification of the risk. Yeah, try to present it in the form of table. The risk is always connected to assets. So you need to clearly identify the assets, list all of them, and then the risk associated with those assets. So the second. Yeah, the second point which you have listed the assets are the legacy systems, you know, so what are those assets? You need to write it clearly. The asset is carda server. The asset is plc, you know, Siemens Simatic s seven 1200. That's how you list it. So asset, carda server. What are the risks associated with this web server? Associated with the web server, main server, like that."
        },
        {
          "speaker": "(18.1s - 18.11s) Isaac PANG",
          "line": "Right."
        },
        {
          "speaker": "(18.11s - 18.49s) Suchi Dhir",
          "line": "If you go to organizations, you know, their risk assessment is very detailed. In fact, if a dustbin is there inside, you know, in a room that does bin is also an asset, and there would be, you know, risk associated with those dustbin also, because a lot of information would be thrown in the dustbin and you know, that information can also lead to some kind of insider attacks."
        },
        {
          "speaker": "(18.5s - 18.97s) Isaac PANG",
          "line": "Right, right. So rather than like, I'm obviously going to be like, speaking because it's a talk, but on the, on the slides, you know, you'd say like, have the table set out. We have all the, like, assets in one column, and then the risks associated with them in the next, and then the likelihood of them happening, the. The intensity of, if it happens, maybe the CV's scores in the next columns."
        },
        {
          "speaker": "(18.97s - 19.5s) Suchi Dhir",
          "line": "So and so, yes, that's it. And if you have presented that you don't need to even present risk matrix, you know, if you have present. If you present this table, then you don't need to even do the risk matrix. Right. Because you have discussed the likelihood over there only. And you can just highlight the top three risk or top four risk. And I from, you know, you can address all the high risk and moderate, you can just leave it for the next year. Even low, you don't need to think about."
        },
        {
          "speaker": "(19.51s - 19.59s) Isaac PANG",
          "line": "Yeah, that's fine. Just address the highest risk ones."
        },
        {
          "speaker": "(19.59s - 19.6s) Suchi Dhir",
          "line": "Yes."
        },
        {
          "speaker": "(19.6s - 19.77s) Isaac PANG",
          "line": "Yeah. And just to confirm, when you say asset, you mean like the PLC, the HMI, the laptops and all that?"
        },
        {
          "speaker": "(19.77s - 20.04s) Suchi Dhir",
          "line": "Yeah. And you have to refer. You have to write that name specifically. Risk are always associated with assets. So we cannot just say computers, you know, it has to be specific to the environment for which you are doing the risk assessment."
        },
        {
          "speaker": "(20.06s - 20.24s) Isaac PANG",
          "line": "Yep, that's fine. Okay. That's fine. Yeah. So I, you know. Yes, sorry."
        },
        {
          "speaker": "(20.26s - 20.78s) Suchi Dhir",
          "line": "And the table where you are presenting, like, you know, you are talking about the budget. So one table for the risk. Right. Another table should be of the budget. You know, where you are, like how the budget table is given in the assignment. So, same way you will also have to present a table, clearly where you are saying that, you know, I am going with proposed option one. It will be having three firewalls cost. So like, that, you know, whatever options you're selecting out of it. So that should be clearly mentioned in the table."
        },
        {
          "speaker": "(20.8s - 21.07s) Isaac PANG",
          "line": "Okay. With the budget and like, all the spending and stuff. Yeah. Okay. Yeah. Because it looks like by default, you're probably gonna go over really, like, at least a little."
        },
        {
          "speaker": "(21.07s - 21.29s) Suchi Dhir",
          "line": "We know that, you know, we had. The scenario is drafted in a way that it's very, very difficult to, you know, to secure the current network in $70,000. It's highly impossible."
        },
        {
          "speaker": "(21.3s - 21.32s) Isaac PANG",
          "line": "Yeah, yeah."
        },
        {
          "speaker": "(21.32s - 22.49s) Suchi Dhir",
          "line": "At all possible. We are looking for the justifications, how well you are able to justify, and what approach you are taking to harden the system. Like some of the things we have just discussed. Like you may think that adding security controls is important rather than updating and patching. Then again, did you refer to the essential aid guidelines? NISD guidelines? What does it say? NISD guidelines always find out what the guidelines say. Do they prioritize updating and patching over implementing security controls, or for them, security controls is more important than patching. So if you didn't refer to the guidelines and you are saying that, you know, let's spend 60,000 and install all the security controls and leave the updating path, we don't need to patch. Are you right? Have you, have you have, have you referred to these guidelines, what the frameworks are suggesting? That's what we are looking into. Whether students have followed the correct and the right approach to understand the problem and provide, recommend the solution."
        },
        {
          "speaker": "(22.51s - 22.57s) Isaac PANG",
          "line": "Okay, yeah, I think I understand a bit better now. Yeah."
        },
        {
          "speaker": "(22.57s - 23.23s) Suchi Dhir",
          "line": "Right. Look into any one guidelines. If you. If you think NIST is good, you can follow that. You can also follow essential eight. Right. So any one of these guidelines or frameworks, you can just follow and see that what they are suggesting, what is important now, these are guidelines. There are certain frameworks and regulations that this industry must be complying with or have to comply with. So you can also look into, I think, regulations you can just leave. That would be too complex right now to, you know, think of. But at least frameworks, you have to refer to these frameworks."
        },
        {
          "speaker": "(23.24s - 23.26s) Isaac PANG",
          "line": "Yeah, yeah."
        },
        {
          "speaker": "(23.26s - 23.38s) Suchi Dhir",
          "line": "So when I'm grading your assignments, I will see that whether students have at least understood that. What frameworks are suggesting them."
        },
        {
          "speaker": "(23.39s - 23.72s) Isaac PANG",
          "line": "Yeah, okay. Yeah, sure. That's fine. I think. Yeah, that's. That's a lot. A lot more clear. And I do understand what to do now because I kind of just, kind of just threw together a draft, and then, you know, this definitely clears up."
        },
        {
          "speaker": "(23.73s - 24.37s) Suchi Dhir",
          "line": "Yes. So, see, this assignment is, again, grades are not very important, but the way you approach this, it has to be aligned with the industry best practices, so that when you start working in the organizations as a cybersecurity consultant, you are able to reproduce what you have learned. Now, that's why this scenario is very, very. I would say you would find very tight constraints. If the constraints would have been easy and simple, it would have been a lot more easier for you to find out a proper solution and secure your network."
        },
        {
          "speaker": "(24.38s - 24.53s) Isaac PANG",
          "line": "Yeah, exactly. Yeah. Yeah. Okay. Sure. I'm gonna. I'll try and get that done tomorrow and."
        },
        {
          "speaker": "(24.57s - 24.74s) Suchi Dhir",
          "line": "Find out what they are suggesting. Whether upgrading and patching is the priority or installing security controls is a priority. So do a little research. It will require some."
        },
        {
          "speaker": "(24.74s - 24.83s) Isaac PANG",
          "line": "Yeah, yeah, sure. No, that's great. No, you've really cleared up a lot of that. Thank you so much."
        },
        {
          "speaker": "(24.84s - 24.89s) Suchi Dhir",
          "line": "That's great. Good to know. Any other questions?"
        },
        {
          "speaker": "(24.9s - 25.05s) Isaac PANG",
          "line": "No, not for now. I think that's perfect. You've cleared it up. When I finish this second draft, you're okay if I send it through to you?"
        },
        {
          "speaker": "(25.06s - 25.2s) Suchi Dhir",
          "line": "Okay. The second one I can take because the first one was really a draft, so. Yeah, no worries. You can share it."
        },
        {
          "speaker": "(25.2s - 25.24s) Isaac PANG",
          "line": "Yeah, that's exactly."
        },
        {
          "speaker": "(25.27s - 25.31s) Suchi Dhir",
          "line": "Thank you. Bye bye. Take care."
        },
        {
          "speaker": "(25.31s - 25.36s) Isaac PANG",
          "line": "No, thank you so much. Have a good weekend."
        },
        {
          "speaker": "(25.36s - 25.39s) Suchi Dhir",
          "line": "You, too. Have a great one. Bye bye."
        },
        {
          "speaker": "(25.39s - 25.41s) Isaac PANG",
          "line": "Okay, see you later. Bye."
        }
      ],
      "date": "2024-07-20T08:31:39.169173Z"
    },
    {
      "file_name": "646ffb87-4936-449b-80a5-cc779cf31853.wav",
      "file_url": "https://s3-ap-southeast-2.amazonaws.com/linc-recordings/646ffb87-4936-449b-80a5-cc779cf31853.wav",
      "duration": 382,
      "transcription": [
        {
          "speaker": "(0.01s - 0.02s) Isaac PANG",
          "line": "Hello."
        },
        {
          "speaker": "(0.03s - 0.09s) Suchi Dhir",
          "line": "Hi Zack. Doctor Shichi here. Good morning, how are you doing?"
        },
        {
          "speaker": "(0.1s - 0.13s) Isaac PANG",
          "line": "I'm good, thank you. How are you?"
        },
        {
          "speaker": "(0.14s - 0.55s) Suchi Dhir",
          "line": "I'm doing great, thank you, Zach. So how is your progress this week? I mean like reading activities. Okay, so have you started working on that?"
        },
        {
          "speaker": "(0.56s - 0.68s) Isaac PANG",
          "line": "I started about now, getting everything."
        },
        {
          "speaker": "(0.75s - 1.22s) Suchi Dhir",
          "line": "Okay. That's all lab activity, rate based. So it's important that, you know, you start implementing them and start from scratch. Like if you have done some configurations for testing, just, you know, undo them and then restart installing SsH server. Because you have to demonstrate installation and configuration. Both of them."
        },
        {
          "speaker": "(1.22s - 1.3s) Isaac PANG",
          "line": "Yeah, yeah, yeah sure, that's fine. I'll do that."
        },
        {
          "speaker": "(1.32s - 1.84s) Suchi Dhir",
          "line": "And there are multiple tasks you would have seen. If you want, you can just start recording one, one task that you complete and then you can later on merge all the videos. Yes. Hardening of ship server is important. Ensure that you try all the methods. It's not only for the assignment, but if you can try all the methods that exist. So it would be very helpful for you."
        },
        {
          "speaker": "(1.86s - 1.9s) Isaac PANG",
          "line": "Sorry, what do you mean? What do you mean by that?"
        },
        {
          "speaker": "(1.92s - 2.4s) Suchi Dhir",
          "line": "See, for hardening in the sense securing the SSH server. So basically I have seen that students would be adding a banner, student would be adding password access, implementing password access to that rather than using a default password. Apart from that you can also try key based authentication. And there are various other ways through which you can actually, you know, harden this SSH server."
        },
        {
          "speaker": "(2.4s - 2.41s) Isaac PANG",
          "line": "Okay."
        },
        {
          "speaker": "(2.41s - 2.47s) Suchi Dhir",
          "line": "Is there anything that you have planned of? Have you done any?"
        },
        {
          "speaker": "(2.48s - 2.58s) Isaac PANG",
          "line": "Not yet. I've really only just opened it and started having a race about the requirements."
        },
        {
          "speaker": "(2.61s - 2.9s) Suchi Dhir",
          "line": "Okay, then you start step by step and if you have any confusion, any, any, you know, help, any assistance regarding hardening of this openss server. So please do let me know."
        },
        {
          "speaker": "(2.91s - 3.03s) Isaac PANG",
          "line": "I will. Thank you. I have one question regarding do you know when the marks will be released?"
        },
        {
          "speaker": "(3.05s - 3.13s) Suchi Dhir",
          "line": "It's been over a week now for the assignment too."
        },
        {
          "speaker": "(3.15s - 3.24s) Isaac PANG",
          "line": "Well, both I guess. The second quiz I was asking, I guess initially."
        },
        {
          "speaker": "(3.26s - 3.37s) Suchi Dhir",
          "line": "Okay, let me remind Doctor Ahmed because that should have been released by now. Okay."
        },
        {
          "speaker": "(3.37s - 3.38s) Isaac PANG",
          "line": "Yeah."
        },
        {
          "speaker": "(3.42s - 3.48s) Suchi Dhir",
          "line": "Okay. Let me remind Doctor Hammethe, he would be doing it."
        },
        {
          "speaker": "(3.48s - 3.5s) Isaac PANG",
          "line": "Yeah."
        },
        {
          "speaker": "(3.59s - 3.72s) Suchi Dhir",
          "line": "Okay, sure. I will be doing that. Yes. Okay. Any other question, anything else that you would like to discuss?"
        },
        {
          "speaker": "(3.74s - 3.87s) Isaac PANG",
          "line": "Not yet. I think once I get started on this, I'll probably have a few questions and maybe I'll send you an email and I'll let you know then."
        },
        {
          "speaker": "(3.88s - 4.35s) Suchi Dhir",
          "line": "See, key based authentication is little complex and it takes some time to do it properly. So ensure that you try to do all that in this week so that you don't get stuck in completing hardening Ssh server because that's the most, I would say, difficult part of this. Then rest of the create table hardening Ssh server."
        },
        {
          "speaker": "(4.36s - 4.39s) Isaac PANG",
          "line": "Hardening Ssh server."
        },
        {
          "speaker": "(4.4s - 4.58s) Suchi Dhir",
          "line": "You have to install Ssh server. You have to configure Ssh server and then you have to demonstrate some steps that you have done for hardening it."
        },
        {
          "speaker": "(4.6s - 4.61s) Isaac PANG",
          "line": "Okay."
        },
        {
          "speaker": "(4.63s - 5.0s) Suchi Dhir",
          "line": "Then you have to create ip tables. So iptables is something which is easy to implement in this scenario. But the first step that is hardening SsH server specifically, you know, using key based authentication. That is something which will take a lot of time. Okay, complex."
        },
        {
          "speaker": "(5.02s - 5.06s) Isaac PANG",
          "line": "Yeah. Implement keyboard."
        },
        {
          "speaker": "(5.07s - 5.39s) Suchi Dhir",
          "line": "Yes. Another thing that you're going to stuck on is configuring snot. So yeah, there is one option where you have to, in the task, there is one requirement where you have to configure whitelisting and blacklisting of the rules."
        },
        {
          "speaker": "(5.39s - 5.4s) Isaac PANG",
          "line": "Yeah."
        },
        {
          "speaker": "(5.4s - 5.6s) Suchi Dhir",
          "line": "That is which I have seen in the past that students, you know, struggle to do or they don't do it properly, you know. So you please do check me with that part."
        },
        {
          "speaker": "(5.62s - 5.63s) Isaac PANG",
          "line": "I will."
        },
        {
          "speaker": "(5.63s - 5.85s) Suchi Dhir",
          "line": "When you are listing and whitelisting the rules. Yeah, yeah. So these are some of the things I think if you can complete SsH server and snot configuration, then the project becomes easy."
        },
        {
          "speaker": "(5.86s - 5.94s) Isaac PANG",
          "line": "Okay. So it's really just those first two steps that are the most challenging."
        },
        {
          "speaker": "(5.95s - 5.96s) Suchi Dhir",
          "line": "Yes."
        },
        {
          "speaker": "(5.98s - 6.06s) Isaac PANG",
          "line": "Yep. Okay, great."
        },
        {
          "speaker": "(6.07s - 6.21s) Suchi Dhir",
          "line": "Zach, I'll speak to you next week. Meanwhile, if you start working on this assignment, please do reach out to me with your queries."
        },
        {
          "speaker": "(6.21s - 6.26s) Isaac PANG",
          "line": "I will, yes. Thank you very much for the call."
        },
        {
          "speaker": "(6.26s - 6.28s) Suchi Dhir",
          "line": "You're welcome. Bye bye. Take care."
        },
        {
          "speaker": "(6.28s - 6.33s) Isaac PANG",
          "line": "Have a goodbye."
        },
        {
          "speaker": "(6.35s - 6.36s) Suchi Dhir",
          "line": "Goodbye. Goodbye."
        }
      ],
      "date": "2024-08-07T02:32:59.455671Z"
    },
    {
      "file_name": "4c8735e6-3f81-483c-a225-ea711b6aa5a3.wav",
      "file_url": "https://s3-ap-southeast-2.amazonaws.com/linc-recordings/4c8735e6-3f81-483c-a225-ea711b6aa5a3.wav",
      "duration": 109,
      "transcription": [
        {
          "speaker": "(0.02s - 0.02s) Isaac PANG",
          "line": "Hello?"
        },
        {
          "speaker": "(0.02s - 0.94s) Suchi Dhir",
          "line": "Hello? Hi, Zach. Can you hear me now? Yeah. Yeah. So I was saying that for getting the high distinction grades in portfolio activity, you will have to ensure that scripts are competent. So if you look at the rubrics, yeah, if you look at the rubrics, it says the most competent script. The script is competent for getting high distinction grades. And you also have to ensure that it is well commented, well indented, it has references and obviously the user menu. Adding functions wherever possible, adding error functions and doing extensive error handling. You will have to do error handling rigorously if you want to get high distinction on the part, on your scripts, for example. So all those things, if you can just add, you have time in your hand. So if you can just, you know."
        },
        {
          "speaker": "(0.95s - 0.97s) Isaac PANG",
          "line": "Yeah, I can do that."
        },
        {
          "speaker": "(0.97s - 1.06s) Suchi Dhir",
          "line": "Yes. So that would be great. Please look at the example script which I have shared with you."
        },
        {
          "speaker": "(1.07s - 1.09s) Isaac PANG",
          "line": "I will. Yes, no problem."
        },
        {
          "speaker": "(1.11s - 1.18s) Suchi Dhir",
          "line": "Okay. So do you want me to call on teams?"
        },
        {
          "speaker": "(1.19s - 1.42s) Isaac PANG",
          "line": "Yeah, the Microsoft Teams on my computer isn't working, so I can't do a screen share, but I might be able to do it on my iPad and then face the iPad towards my screen. Would that work?"
        },
        {
          "speaker": "(1.44s - 1.62s) Suchi Dhir",
          "line": "Okay, can I do a video call to you? I'll just disconnect this call and share a link. You join me through that link on."
        },
        {
          "speaker": "(1.63s - 1.67s) Isaac PANG",
          "line": "Yeah. So you email me and then I'll join."
        },
        {
          "speaker": "(1.67s - 1.77s) Suchi Dhir",
          "line": "Yes, yes, yes. Okay, I'll do that. Yeah. Bye bye. Take care. Have a great day."
        },
        {
          "speaker": "(1.77s - 1.79s) Isaac PANG",
          "line": "Yeah, no problems."
        },
        {
          "speaker": "(1.79s - 1.8s) Suchi Dhir",
          "line": "Bye."
        }
      ],
      "date": "2023-02-23T09:40:08.056433Z"
    },
    {
      "file_name": "ec3409f5-bfc1-4a16-adb6-7bc8927840f1.wav",
      "file_url": "https://s3-ap-southeast-2.amazonaws.com/linc-recordings/ec3409f5-bfc1-4a16-adb6-7bc8927840f1.wav",
      "duration": 124,
      "transcription": [
        {
          "speaker": "(0.01s - 0.02s) Isaac PANG",
          "line": "Hello."
        },
        {
          "speaker": "(0.03s - 0.08s) Suchi Dhir",
          "line": "Hi, is that doctor Shuchi here from Ecu? How are you doing?"
        },
        {
          "speaker": "(0.09s - 0.12s) Isaac PANG",
          "line": "Hi, I'm good, thank you. How are you?"
        },
        {
          "speaker": "(0.12s - 0.3s) Suchi Dhir",
          "line": "I'm doing great, thank you. So how is your progress now? Have you been able to configure the openssh server and iptable rules? Are they working now?"
        },
        {
          "speaker": "(0.3s - 0.36s) Isaac PANG",
          "line": "Yes, I think I've got it working. I think I fixed it all last night."
        },
        {
          "speaker": "(0.37s - 0.48s) Suchi Dhir",
          "line": "Okay, that's good. And your snot configuration file, I hope you have done all the necessary configuration."
        },
        {
          "speaker": "(0.49s - 0.57s) Isaac PANG",
          "line": "Yes, yes, they're all, they're all good as well. I'm gonna record everything today."
        },
        {
          "speaker": "(0.58s - 0.74s) Suchi Dhir",
          "line": "Okay, that's great. So, yes, if your IP label rules are working and snort alerts are working, then I guess rest of the assignments is quite simple and easy."
        },
        {
          "speaker": "(0.75s - 0.99s) Isaac PANG",
          "line": "Yeah, it's got it recorded and all of that. So with the. When I'm demonstrating the snort rules to show that they're like, they're working, I also have to show the IP tables as well, right?"
        },
        {
          "speaker": "(1.0s - 1.58s) Suchi Dhir",
          "line": "Right. You have to show all the configurations. You have to show SSH configuration file, the snot configuration file. Then you have to list all the iptable rules and show which rules you have done. And then you have to demonstrate alert. I mean, it's not configuration file. You have to walk us through all the configurations that you have done. Yeah, like adding the port number, adding a particular rule file. Open. The rule file shows the alerts. It has to be very detailed. Like you need to demonstrate what all you have done in detail."
        },
        {
          "speaker": "(1.58s - 1.66s) Isaac PANG",
          "line": "Yes, yes, that's fine. No problem. I'll do that."
        },
        {
          "speaker": "(1.66s - 1.72s) Suchi Dhir",
          "line": "Yeah, it's really good. Any other queries that you have that you would like?"
        },
        {
          "speaker": "(1.73s - 1.84s) Isaac PANG",
          "line": "No, no queries right now. I think, I think I'll record everything today and if I have any issues, I'll. I'll shoot you an email."
        },
        {
          "speaker": "(1.85s - 1.89s) Suchi Dhir",
          "line": "That's great. All the best is that."
        },
        {
          "speaker": "(1.9s - 1.92s) Isaac PANG",
          "line": "Thank you so much."
        },
        {
          "speaker": "(1.92s - 1.96s) Suchi Dhir",
          "line": "Yeah. Bye. Take care then."
        },
        {
          "speaker": "(1.96s - 1.99s) Isaac PANG",
          "line": "Yeah. Thanks for all your help this semester."
        },
        {
          "speaker": "(1.99s - 2.02s) Suchi Dhir",
          "line": "You're welcome. Bye bye. Take care."
        },
        {
          "speaker": "(2.02s - 2.04s) Isaac PANG",
          "line": "Thank you. Bye bye. See ya."
        },
        {
          "speaker": "(2.05s - 2.06s) Suchi Dhir",
          "line": "Bye."
        }
      ],
      "date": "2024-08-14T02:32:01.068057Z"
    }
  ],
            "video": [
                {
                  "file_name": "RMb0eaee8e5d2bc265f3df5396e10c544a",
                  "file_url": "https://s3-ap-southeast-2.amazonaws.com/linc-video-recording-staging/RMb0eaee8e5d2bc265f3df5396e10c544a",
                  "duration": 1045,
                  "transcription": [
                    {
                      "speaker": "(1.07s - 1.1s) Suchi Dhir",
                      "line": "Hi, Zach, can you hear me?"
                    },
                    {
                      "speaker": "(1.1s - 1.12s) Isaac PANG",
                      "line": "Hello, how are you going?"
                    },
                    {
                      "speaker": "(1.13s - 1.37s) Suchi Dhir",
                      "line": "Yeah, I'm doing great, thank you. If you want, you can just turn off the video. You'll see that all the buttons on the palette and there is also one button to share your screen. So if you can click on that."
                    },
                    {
                      "speaker": "(1.38s - 1.62s) Isaac PANG",
                      "line": "Yeah, sure. I'm just gonna. Okay. Can you see my screen?"
                    },
                    {
                      "speaker": "(1.62s - 1.64s) Suchi Dhir",
                      "line": "Yes, I can."
                    },
                    {
                      "speaker": "(1.65s - 3.56s) Isaac PANG",
                      "line": "Okay, cool. Give me one sec. Sorry. Okay. Um, so my query is, I guess when I've been, I've been watching a few walkthroughs for the capture the flag questions. I'm like all of and well, someone that I have confusion with. I'll go through and for instance, I feel like there's some data possibly missing. I'm not sure, but when I, for example, this search query here. Sorry, if he's here, that's okay. For example, this search query here, if I compare it to like one sec to here, um, 2904, like he's talking about, um, if you can see. Yeah, so like if we look through the field here, I guess they're nothing. It's not really the same. It's not the same if you can see like especially the important stuff where here key is the open bucket. This just doesn't have any of that at all. And this is just one example of like some stuff missing. Like when I try to go through the other questions as well, like I often won't be able to like find all the, all the things."
                    },
                    {
                      "speaker": "(3.58s - 3.63s) Suchi Dhir",
                      "line": "Can you just show me the query again that you're typing?"
                    },
                    {
                      "speaker": "(3.63s - 3.64s) Isaac PANG",
                      "line": "Yes."
                    },
                    {
                      "speaker": "(3.65s - 3.8s) Suchi Dhir",
                      "line": "Possible that this is only attack only version of the data set and that says, you know, maybe they must be working on the full fledged."
                    },
                    {
                      "speaker": "(3.8s - 3.89s) Isaac PANG",
                      "line": "That. Yeah, that probably. That probably. Yeah, I guess."
                    },
                    {
                      "speaker": "(3.92s - 4.25s) Suchi Dhir",
                      "line": "I. Okay, so you are looking for TXT. Can you click on the source type and just see what all is available in the source type?"
                    },
                    {
                      "speaker": "(4.25s - 4.3s) Isaac PANG",
                      "line": "Yeah, it's this one."
                    },
                    {
                      "speaker": "(4.35s - 4.8s) Suchi Dhir",
                      "line": "Yeah. Because you have selected. So, okay. It might be possible that it's in a tak only version and, and that's why you are not able to see all the information that others are saying. Is that. Did I share any detailed information regarding this assignment with you? Any further understanding?"
                    },
                    {
                      "speaker": "(4.8s - 5.35s) Isaac PANG",
                      "line": "Not really. Like when I've watched, when I've kind of gone through the CTF questions, I've got a good understanding of the attack itself and I've written, I've actually written the summary, but it's just my problem is when it's coming up to doing the commands myself and getting my screenshots so I can show evidence and stuff of how I did it, I can't seem to get like my answer is because not all the data seems to be like. Yeah, if you know what I mean."
                    },
                    {
                      "speaker": "(5.35s - 5.97s) Suchi Dhir",
                      "line": "Understood. So I'll do one thing. I'll share some, I will share some more information with you regarding this. You don't need to follow. Maybe, you know, you can refine further, don't look for the similar kind of queries. If you're not getting the information, you can further refine your queries. Maybe you will have to add a little more information to get the similar kind of results. What, you know, the other one, what you are seeing in the video. Yes. So might be possible. There would be, yeah."
                    },
                    {
                      "speaker": "(5.97s - 6.05s) Isaac PANG",
                      "line": "So what's the difference then between the attack only and the full support?"
                    },
                    {
                      "speaker": "(6.08s - 6.37s) Suchi Dhir",
                      "line": "Attack only will be having little, you know, events. Not all, because it's, the full data set is very huge and attack only has, is a smaller version of your full data set."
                    },
                    {
                      "speaker": "(6.37s - 6.5s) Isaac PANG",
                      "line": "I actually did try downloading from GitHub the data set, but it's too large to import."
                    },
                    {
                      "speaker": "(6.51s - 6.87s) Suchi Dhir",
                      "line": "Exactly. That one is too large. So. Okay, so I'm just sharing more detailed information about this assessment with you. You can just follow that. And instead of following the videos which you are doing right now, I will share an email. Just go through that."
                    },
                    {
                      "speaker": "(6.93s - 6.97s) Isaac PANG",
                      "line": "I'm just a little bit confused, that's all."
                    },
                    {
                      "speaker": "(6.99s - 7.01s) Suchi Dhir",
                      "line": "Understood."
                    },
                    {
                      "speaker": "(7.01s - 7.54s) Isaac PANG",
                      "line": "Started writing my thing, as you can see, my summary, I've got the whole summary of what's going on. And then it's just when I come to like here, like, I can do some of it because some of it's okay. But it seems to be like, as I get deeper into the, for example, the weaponization area, like, I just, some stuff won't appear similar to how I've like seen it, you know, the walkthroughs kind of."
                    },
                    {
                      "speaker": "(7.58s - 7.59s) Suchi Dhir",
                      "line": "Yes."
                    },
                    {
                      "speaker": "(7.59s - 7.61s) Isaac PANG",
                      "line": "Yeah."
                    },
                    {
                      "speaker": "(7.61s - 7.99s) Suchi Dhir",
                      "line": "Okay. It might be confusing only because of the wrong, maybe it looks good, you know, let me share some more information with you. I'll share a good link with you. Follow that to frame your queries and follow the steps. I'm sure you should get that."
                    },
                    {
                      "speaker": "(8.0s - 8.01s) Isaac PANG",
                      "line": "Okay."
                    },
                    {
                      "speaker": "(8.02s - 8.36s) Suchi Dhir",
                      "line": "Because you're following the video and you're not able to get that information because it's quite strange. And let me share that, is that you follow the links which I'm sharing and more, you know, more information on this and then let me know how it goes."
                    },
                    {
                      "speaker": "(8.36s - 8.54s) Isaac PANG",
                      "line": "Okay. Yeah. I was just hoping that I'd be able to like, finish it today. I was working on it all day, but I couldn't seem to figure out what the problem was. That's why I ended up texting you."
                    },
                    {
                      "speaker": "(8.55s - 8.84s) Suchi Dhir",
                      "line": "No, that's, that's good that you have informed me. I'm just sharing now. Look into that and then let me know if you need more assistance on this in framing your queries or if you're not able to get the information, do just let me know."
                    },
                    {
                      "speaker": "(8.91s - 8.93s) Isaac PANG",
                      "line": "Is that on email?"
                    },
                    {
                      "speaker": "(8.94s - 8.98s) Suchi Dhir",
                      "line": "Yes, I just shared it with you now."
                    },
                    {
                      "speaker": "(8.98s - 9.07s) Isaac PANG",
                      "line": "Okay. I'm sure it will come through."
                    },
                    {
                      "speaker": "(9.16s - 9.71s) Suchi Dhir",
                      "line": "You can just refresh and to see if. Yeah. So look into that and I'm sure I have to be. It should come. It should come. I reach here now. So just, you know, follow this. Even open the zip folder. This article is really good. The one which link I have provided you."
                    },
                    {
                      "speaker": "(9.75s - 10.14s) Isaac PANG",
                      "line": "Because these queries, every single capture the flag question. So I do have a solid understanding of the attack and all of that. It really is just like now that I'm going back and like getting all the stuff for myself to put in my report, I just can't seem to find, doesn't seem to come up. But I will have a look at what you sent me. Yeah."
                    },
                    {
                      "speaker": "(10.16s - 10.34s) Suchi Dhir",
                      "line": "Okay. Now it looks like good, you know, your report, what you showed me, it's only the matter of the queries that you're writing. I think you have to refine your queries a bit more."
                    },
                    {
                      "speaker": "(10.34s - 10.35s) Isaac PANG",
                      "line": "Yeah."
                    },
                    {
                      "speaker": "(10.35s - 10.47s) Suchi Dhir",
                      "line": "Okay. Yeah. So I think you should get that once you start refining your queries a bit more."
                    },
                    {
                      "speaker": "(10.48s - 11.1s) Isaac PANG",
                      "line": "I will. Okay. Um. And then I guess, and the final question would be just based on like my out, like how I'm, the structure of my report. I just was gonna check, I know I wrote down how you told me to do it, but I thought I might as well confirm now that you can see my screen. So, yeah, I've started with summary here, like, of the attack, just, you know, just to get started. And then, um, into the investigation, just an introduction to it. And then, um, the major events, as you said. And then in here, I was going to talk about the kill chain. So like each section of the kill chain I was planning to go through."
                    },
                    {
                      "speaker": "(11.11s - 11.51s) Suchi Dhir",
                      "line": "Um, one thing is that care, uh, for reconnanza weaponization, these are something you don't need to because see, these are something that would be happening outside the outside. And you may not get information about these events in the data set. It's not required that you need to talk about these things."
                    },
                    {
                      "speaker": "(11.52s - 11.69s) Isaac PANG",
                      "line": "Okay. Because in the marking rubric, it says, like, discuss, like the Lockheed Martin and the Marder attack frame of frameworks."
                    },
                    {
                      "speaker": "(11.69s - 12.01s) Suchi Dhir",
                      "line": "You have to align it with the mitre, ATT and CK framework and Lockheed Martin Kilchain. But it's not necessary that, you know, you have to align all the phases. So whatever information you are getting from the data set, from the investigation, you can align that to the phases."
                    },
                    {
                      "speaker": "(12.02s - 12.28s) Isaac PANG",
                      "line": "Right. So I can kind of just, I guess maybe instead of like highlighting each, um, subcategory of the kill train and trying to fit, fit information into each one, I can kind of discuss how I got all my results for this."
                    },
                    {
                      "speaker": "(12.28s - 13.55s) Suchi Dhir",
                      "line": "And then like, I would rather suggest, uh, you know, before you start your reconnaissance weaponization, uh, you know, you, like, you have written major events. So here in the major events, um, find out the, you know, discuss the major events and technical details associated with them. And later you assign them, you know, just align them to the mitre, ATT and CK framework. That would be a better approach. For example, first event, let's say you identified the misconfiguration of s three buckets, or s three buckets made public. Yes, event one. So in major events, event one, event three, even four. And once you have described the technical details of these events, then comes, you know, your mitre attach framework and cyber kill chain. You can discuss about them and align the events to the phases. Now, it's not necessary that all the events that you have identified would be aligned to all the phases which are there. So you should not worry about it. There may be some phases for which you did not get any information. Yes, just leave it blank."
                    },
                    {
                      "speaker": "(13.56s - 13.91s) Isaac PANG",
                      "line": "Yeah, that clears it up a lot. So then, for instance, in the major events, let's say my first, for example, major event would be the s three bucket. Being public would then in that kind of section, would I kind of show as I've, I guess, for example here, like the search queries that I've done and then pictures to like, show."
                    },
                    {
                      "speaker": "(13.92s - 14.27s) Suchi Dhir",
                      "line": "Yeah. First you have to explain what is s three bucket and how, what ways it can be exploited if it's public. And what tactic was used by the hacker here to exploit the history bucket because there would be various ways through which this vulnerability can be exploited."
                    },
                    {
                      "speaker": "(14.27s - 14.39s) Isaac PANG",
                      "line": "Yeah, yeah. Okay. That makes a lot more sense then. Yeah. I think, I think I'm, I think I'm a lot more clear on, on how to do this then."
                    },
                    {
                      "speaker": "(14.4s - 14.64s) Suchi Dhir",
                      "line": "Yes. So, you know, you need to add some diagrams related to s three bucket, explain what would have gone wrong. And so that's an event. You have to explain the events, the technical details related to the events extremely well."
                    },
                    {
                      "speaker": "(14.64s - 14.75s) Isaac PANG",
                      "line": "Yeah, yeah, fine. That's, that's fine. Okay, I'll do that. I've got a much better understanding now. Yeah."
                    },
                    {
                      "speaker": "(14.76s - 15.0s) Suchi Dhir",
                      "line": "So just look into the data set and the zip file which I have shared with you. What is this one article? Yeah, this is basically the CTF questions. Hence. So if you want, you can just look into that as well."
                    },
                    {
                      "speaker": "(15.0s - 15.01s) Isaac PANG",
                      "line": "Yeah."
                    },
                    {
                      "speaker": "(15.02s - 15.15s) Suchi Dhir",
                      "line": "And scroll down. There is one link. That's excellent. Yeah. This. Yes. James Gibbons."
                    },
                    {
                      "speaker": "(15.15s - 15.16s) Isaac PANG",
                      "line": "Okay."
                    },
                    {
                      "speaker": "(15.16s - 15.35s) Suchi Dhir",
                      "line": "Yeah, so this one is really good. And you can get lot of, you know, information about the way you have to frame your queries."
                    },
                    {
                      "speaker": "(15.35s - 15.58s) Isaac PANG",
                      "line": "Right. Okay. I'm just going to open that for. Maybe it's not working. Can you see this?"
                    },
                    {
                      "speaker": "(15.6s - 15.66s) Suchi Dhir",
                      "line": "Can you just type James Gibbons bot version three?"
                    },
                    {
                      "speaker": "(15.67s - 15.68s) Isaac PANG",
                      "line": "Yeah."
                    },
                    {
                      "speaker": "(15.71s - 15.77s) Suchi Dhir",
                      "line": "I don't know why this is not working. I actually tested it."
                    },
                    {
                      "speaker": "(15.79s - 15.8s) Isaac PANG",
                      "line": "Um."
                    },
                    {
                      "speaker": "(15.8s - 15.82s) Suchi Dhir",
                      "line": "Scroll down."
                    },
                    {
                      "speaker": "(15.84s - 15.86s) Isaac PANG",
                      "line": "This is strange."
                    },
                    {
                      "speaker": "(15.88s - 15.92s) Suchi Dhir",
                      "line": "It's working at my end."
                    },
                    {
                      "speaker": "(15.94s - 16.13s) Isaac PANG",
                      "line": "That is very weird. I wonder if it's because we're in a different country. That's strange."
                    },
                    {
                      "speaker": "(16.14s - 16.19s) Suchi Dhir",
                      "line": "Yeah, it's completely. Can I share the link again?"
                    },
                    {
                      "speaker": "(16.23s - 16.26s) Isaac PANG",
                      "line": "Well, I might just click these just."
                    },
                    {
                      "speaker": "(16.27s - 16.36s) Suchi Dhir",
                      "line": "In case I have shared the link with you in the chat box. Can you just check that?"
                    },
                    {
                      "speaker": "(16.44s - 16.72s) Isaac PANG",
                      "line": "Where is the. Is this the chat room? Oh, yeah. Is this it?"
                    },
                    {
                      "speaker": "(16.73s - 16.74s) Suchi Dhir",
                      "line": "Yes."
                    },
                    {
                      "speaker": "(16.75s - 16.77s) Isaac PANG",
                      "line": "Yeah. Okay."
                    },
                    {
                      "speaker": "(16.78s - 16.85s) Suchi Dhir",
                      "line": "Just look at the queries, what they have used."
                    },
                    {
                      "speaker": "(16.85s - 16.9s) Isaac PANG",
                      "line": "I've actually gone through this exact website."
                    },
                    {
                      "speaker": "(16.92s - 16.93s) Suchi Dhir",
                      "line": "Okay."
                    },
                    {
                      "speaker": "(16.93s - 17.52s) Isaac PANG",
                      "line": "Actually, I've actually done a lot of this. I've looked at this a lot and that's where I got my understanding from. But when it came to going back and doing it myself, I guess that was what the problem was, was that I couldn't seem to get. Well, for instance, like, I mean, if I went down to the questions like which one particular. It was like this, like this one, it wouldn't seem to work when I typed in the commands in the search query. So I feel like, as you said before, it's probably because."
                    },
                    {
                      "speaker": "(17.53s - 17.67s) Suchi Dhir",
                      "line": "Yeah. You change some of the. Some of the parameters, some of the values, and I guess it should work. Yes."
                    },
                    {
                      "speaker": "(17.67s - 17.75s) Isaac PANG",
                      "line": "I think they're slightly different. Um. Because they. Maybe it's maybe."
                    },
                    {
                      "speaker": "(17.76s - 17.87s) Suchi Dhir",
                      "line": "Yeah, they're. Yeah, maybe they are not. They're not. They're working on the full data set and just working on attack on inversion."
                    },
                    {
                      "speaker": "(17.88s - 18.06s) Isaac PANG",
                      "line": "Yeah. Okay. Okay. Okay. Well, that's fine. I'll keep looking through and um. I actually will go back and I'm going to try and write this up to tonight as much as I can."
                    },
                    {
                      "speaker": "(18.07s - 18.08s) Suchi Dhir",
                      "line": "Okay."
                    },
                    {
                      "speaker": "(18.09s - 18.15s) Isaac PANG",
                      "line": "Yeah, that's good though. I've got a much better understanding now."
                    },
                    {
                      "speaker": "(18.16s - 18.28s) Suchi Dhir",
                      "line": "Great. Then let me know how it goes. And if you have more queries, then you can connect to me through me."
                    },
                    {
                      "speaker": "(18.28s - 18.3s) Isaac PANG",
                      "line": "Perfect."
                    },
                    {
                      "speaker": "(18.3s - 18.33s) Suchi Dhir",
                      "line": "Okay. All the best. Bye bye."
                    },
                    {
                      "speaker": "(18.33s - 18.46s) Isaac PANG",
                      "line": "Thank you very much for your help. Okay, you too. See you later. Bye bye. Bye bye. It."
                    }
                  ],
                  "date": "2023-06-13T10:05:29.871163Z"
                },
                {
                  "file_name": "RM35ea9450f4dbfed599439a441142cda9",
                  "file_url": "https://s3-ap-southeast-2.amazonaws.com/linc-video-recording-staging/RM35ea9450f4dbfed599439a441142cda9",
                  "duration": 475,
                  "transcription": [
                    {
                      "speaker": "(2.11s - 2.12s) Isaac PANG",
                      "line": "Hello?"
                    },
                    {
                      "speaker": "(2.13s - 2.15s) Suchi Dhir",
                      "line": "Hi, is that, can you hear me?"
                    },
                    {
                      "speaker": "(2.16s - 2.2s) Isaac PANG",
                      "line": "Hey Shuji. Yes, I can hear you."
                    },
                    {
                      "speaker": "(2.2s - 2.23s) Suchi Dhir",
                      "line": "Yeah. If you want you can just turn off your video."
                    },
                    {
                      "speaker": "(2.24s - 2.3s) Isaac PANG",
                      "line": "So that's, I don't really, I don't really mind, but I can turn it off."
                    },
                    {
                      "speaker": "(2.31s - 2.42s) Suchi Dhir",
                      "line": "Okay. And that's, that's for better bandwidth. Can you share your screen? You'll see one arrow."
                    },
                    {
                      "speaker": "(2.42s - 2.59s) Isaac PANG",
                      "line": "Yes, let me just see if I can. Okay, can you see."
                    },
                    {
                      "speaker": "(2.63s - 2.66s) Suchi Dhir",
                      "line": "Yes, I can."
                    },
                    {
                      "speaker": "(2.66s - 2.69s) Isaac PANG",
                      "line": "Can you see this screen here?"
                    },
                    {
                      "speaker": "(2.69s - 2.71s) Suchi Dhir",
                      "line": "Yeah, I can."
                    },
                    {
                      "speaker": "(2.71s - 2.73s) Isaac PANG",
                      "line": "My virtual machine?"
                    },
                    {
                      "speaker": "(2.74s - 2.75s) Suchi Dhir",
                      "line": "Yes."
                    },
                    {
                      "speaker": "(2.75s - 3.77s) Isaac PANG",
                      "line": "Okay, let me just get up. Okay. Okay. Yeah, so just putting the, I've completed all the tasks for week two, so just putting them into the GitHub thing, a repository. I followed these commands here, but as you can see, maybe on my screen I started it from up here, add scripts and then I did the second command here, but then when I got to the push the git, push here, it says, failed to push some refs to this, to the."
                    },
                    {
                      "speaker": "(3.77s - 3.82s) Suchi Dhir",
                      "line": "Can you show me a GitHub repository?"
                    },
                    {
                      "speaker": "(3.82s - 3.87s) Isaac PANG",
                      "line": "Yeah, sure. It's here."
                    },
                    {
                      "speaker": "(3.89s - 4.07s) Suchi Dhir",
                      "line": "Yeah. So you can see that, you know, your first commit is on main branch. So you'll have to commit, you'll have to push to the main branch. There is no master branch."
                    },
                    {
                      "speaker": "(4.08s - 4.17s) Isaac PANG",
                      "line": "Okay, so do I need to make a week two folder in here too?"
                    },
                    {
                      "speaker": "(4.2s - 4.33s) Suchi Dhir",
                      "line": "You have to create the folders on your local machine and from there you have to push. So when you push it from here it should go. Yes."
                    },
                    {
                      "speaker": "(4.33s - 4.4s) Isaac PANG",
                      "line": "So if I push to you just say git, push."
                    },
                    {
                      "speaker": "(4.4s - 4.57s) Suchi Dhir",
                      "line": "No, just write the command. No, go back to your, yeah, terminal git, push u origin main instead of master."
                    },
                    {
                      "speaker": "(4.58s - 4.59s) Isaac PANG",
                      "line": "Yep."
                    },
                    {
                      "speaker": "(4.59s - 4.6s) Suchi Dhir",
                      "line": "Yes."
                    },
                    {
                      "speaker": "(4.6s - 4.62s) Isaac PANG",
                      "line": "And execute."
                    },
                    {
                      "speaker": "(4.63s - 5.01s) Suchi Dhir",
                      "line": "Yes. This is the token, the security token."
                    },
                    {
                      "speaker": "(5.02s - 5.3s) Isaac PANG",
                      "line": "Oh, the security token. Yeah, that's in my email. Actually I have to go into my email, sorry, you're gonna be in my email inbox for a bit."
                    },
                    {
                      "speaker": "(5.31s - 5.33s) Suchi Dhir",
                      "line": "No worries."
                    },
                    {
                      "speaker": "(5.35s - 5.68s) Isaac PANG",
                      "line": "Where is it? Is that it?"
                    },
                    {
                      "speaker": "(5.69s - 5.81s) Suchi Dhir",
                      "line": "Yes. So your branch is main, it's not master. So when you're pushing, you have to push to the correct branch."
                    },
                    {
                      "speaker": "(5.81s - 5.86s) Isaac PANG",
                      "line": "Right, right. And should it, where will it appear?"
                    },
                    {
                      "speaker": "(5.86s - 5.87s) Suchi Dhir",
                      "line": "Here."
                    },
                    {
                      "speaker": "(5.87s - 5.89s) Isaac PANG",
                      "line": "Sorry, I've never used, you have to."
                    },
                    {
                      "speaker": "(5.89s - 5.93s) Suchi Dhir",
                      "line": "Just refresh, you have to just refresh it."
                    },
                    {
                      "speaker": "(5.93s - 6.11s) Isaac PANG",
                      "line": "Yep. Okay, cool. There it is. And then it should be more, oh, it's in the things in my password folder or the scripts."
                    },
                    {
                      "speaker": "(6.11s - 6.12s) Suchi Dhir",
                      "line": "Yes."
                    },
                    {
                      "speaker": "(6.12s - 6.17s) Isaac PANG",
                      "line": "See what I mean? Like it's a bit fiddler."
                    },
                    {
                      "speaker": "(6.18s - 6.24s) Suchi Dhir",
                      "line": "Yes. So that's how it, yeah, yeah that's, that's fine."
                    },
                    {
                      "speaker": "(6.25s - 6.26s) Isaac PANG",
                      "line": "Is that okay?"
                    },
                    {
                      "speaker": "(6.27s - 6.3s) Suchi Dhir",
                      "line": "Yeah, that's completely fine. No worries."
                    },
                    {
                      "speaker": "(6.31s - 6.46s) Isaac PANG",
                      "line": "And then, yeah, so these are all the scripts. Um, I was going to say you do look over those and give feedback at all or."
                    },
                    {
                      "speaker": "(6.47s - 6.73s) Suchi Dhir",
                      "line": "Yes, I will be. And you need to share. You need to provide me with a collaborator access if you want to share this. Yeah, just provide me with the collaborator access. I will, yeah. I look into your work and share my feedback with you."
                    },
                    {
                      "speaker": "(6.73s - 6.78s) Isaac PANG",
                      "line": "Sure. How do I actually provide you with that?"
                    },
                    {
                      "speaker": "(6.79s - 6.83s) Suchi Dhir",
                      "line": "I'll share the instructions with you over email."
                    },
                    {
                      "speaker": "(6.84s - 6.87s) Isaac PANG",
                      "line": "Yeah. So you'll email that to me?"
                    },
                    {
                      "speaker": "(6.88s - 6.9s) Suchi Dhir",
                      "line": "Yes, I will be."
                    },
                    {
                      "speaker": "(6.9s - 7.1s) Isaac PANG",
                      "line": "Cool. Cool. Okay, thanks. I'll guess I'll just go on with week three then. And I think you said try and get up to week four out the way. Is that correct?"
                    },
                    {
                      "speaker": "(7.11s - 7.76s) Suchi Dhir",
                      "line": "Yes, exactly. So try to complete all your scripts up to week four and week five. You have awkward regular expressions. That's going to take some good amount of time. And awk. Awk. Awk. And regular expressions. Yeah, that's going to take some good amount of time because that's for formatting your output. And then regular expressions is to, obviously, to, you know, do the text passing properly. So that's going to take some good amount of time. So please complete your week four so that you can spend more time on these."
                    },
                    {
                      "speaker": "(7.76s - 8.04s) Isaac PANG",
                      "line": "Yeah, sure. That's cool. And in terms of starting the project, obviously the project will require, um, not like all the techniques that we learn in the unit."
                    },
                    {
                      "speaker": "(8.05s - 8.07s) Suchi Dhir",
                      "line": "Yeah. Up to week five. Right."
                    },
                    {
                      "speaker": "(8.07s - 8.11s) Isaac PANG",
                      "line": "Up to week five is up to week five."
                    },
                    {
                      "speaker": "(8.12s - 8.13s) Suchi Dhir",
                      "line": "Yes."
                    },
                    {
                      "speaker": "(8.13s - 8.2s) Isaac PANG",
                      "line": "So if I can just. If I can just get that out the way early, then I can start the project?"
                    },
                    {
                      "speaker": "(8.2s - 8.22s) Suchi Dhir",
                      "line": "Yes, you can."
                    },
                    {
                      "speaker": "(8.22s - 8.36s) Isaac PANG",
                      "line": "Yes. Perfect. Perfect. Yeah. I was just. I'm reiterating what you said just to confirm. Yeah, that's all good."
                    },
                    {
                      "speaker": "(8.36s - 8.67s) Suchi Dhir",
                      "line": "I would suggest that quickly complete your work until week four and start working at week five and start looking at week, you know, assessment instructions. We will be speaking. Yeah, we will be discussing your assessment in detail. That's completely. Yeah, you should not. Yeah, you should not worry about that."
                    },
                    {
                      "speaker": "(8.67s - 8.78s) Isaac PANG",
                      "line": "The quizzes, what. What are those time limit kind of thing or."
                    },
                    {
                      "speaker": "(8.78s - 8.8s) Suchi Dhir",
                      "line": "No, they are not."
                    },
                    {
                      "speaker": "(8.8s - 8.97s) Isaac PANG",
                      "line": "They're not timed. And what, will they require us to use the terminal to answer questions or is it kind of a multi choice thing?"
                    },
                    {
                      "speaker": "(8.97s - 9.07s) Suchi Dhir",
                      "line": "Yes, you will have to, because there are codes. You will have to execute them and you'll have to see what is the output."
                    },
                    {
                      "speaker": "(9.08s - 9.15s) Isaac PANG",
                      "line": "I see, yep. That's cool. And there's no time limit on those. Just get those done."
                    },
                    {
                      "speaker": "(9.15s - 9.2s) Suchi Dhir",
                      "line": "No, no, it's an open book. It's. It's an open book exam."
                    },
                    {
                      "speaker": "(9.2s - 9.47s) Isaac PANG",
                      "line": "Yeah. Yeah, yeah. Okay, cool. Well, I guess tomorrow I'll get started on week three and try and finish. And then the day after I'll try and finish week four, but. And then I'll talk to you on is our usual. Is our time Thursday? Is that what we organize?"
                    },
                    {
                      "speaker": "(9.47s - 9.49s) Suchi Dhir",
                      "line": "Yes. Yes."
                    },
                    {
                      "speaker": "(9.49s - 9.53s) Isaac PANG",
                      "line": "Did you say 05:30 p.m. is that correct?"
                    },
                    {
                      "speaker": "(9.56s - 9.61s) Suchi Dhir",
                      "line": "Yes. I did share the invite with you. Yeah."
                    },
                    {
                      "speaker": "(9.62s - 9.76s) Isaac PANG",
                      "line": "Yeah. Okay. I'll have a look. But either way, I'll try and finish all of up to week four. So before our next consult on Thursday."
                    },
                    {
                      "speaker": "(9.77s - 9.79s) Suchi Dhir",
                      "line": "Okay? Sure."
                    },
                    {
                      "speaker": "(9.79s - 9.8s) Isaac PANG",
                      "line": "Yeah."
                    },
                    {
                      "speaker": "(9.81s - 9.83s) Suchi Dhir",
                      "line": "All the best. Yeah. Bye."
                    },
                    {
                      "speaker": "(9.83s - 9.93s) Isaac PANG",
                      "line": "Thank you so much for helping me. Okay, bye bye. Bye."
                    },
                    {
                      "speaker": "(10.62s - 10.63s) Suchi Dhir",
                      "line": "It."
                    }
                  ],
                  "date": "2023-01-16T10:01:37.508823Z"
                },
                {
                  "file_name": "RM38a85c507728e38b34149577b48126e1",
                  "file_url": "https://s3-ap-southeast-2.amazonaws.com/linc-video-recording-staging/RM38a85c507728e38b34149577b48126e1",
                  "duration": 557,
                  "transcription": [
                    {
                      "speaker": "(0.33s - 0.37s) Suchi Dhir",
                      "line": "Hello? Hi, can you hear me?"
                    },
                    {
                      "speaker": "(0.38s - 0.4s) Isaac PANG",
                      "line": "Yes, I can hear you."
                    },
                    {
                      "speaker": "(0.4s - 0.63s) Suchi Dhir",
                      "line": "Okay, if you want, you can just disconnect your video and there is one screen share option which is there on the bottom. You can just click on that and share your screen."
                    },
                    {
                      "speaker": "(0.72s - 0.77s) Isaac PANG",
                      "line": "Okay. Can you see me on my screen?"
                    },
                    {
                      "speaker": "(0.77s - 0.79s) Suchi Dhir",
                      "line": "Yes, I can. Yes."
                    },
                    {
                      "speaker": "(0.82s - 1.26s) Isaac PANG",
                      "line": "Here's my terminal here. I think if you scroll, if I scroll up here some places. One sec. Yes, I've got week six in here. Yeah. And I just, yeah, I don't know, it wasn't working when I was doing like the git add thing like that."
                    },
                    {
                      "speaker": "(1.31s - 1.32s) Suchi Dhir",
                      "line": "Can you try?"
                    },
                    {
                      "speaker": "(1.35s - 1.44s) Isaac PANG",
                      "line": "Yeah, sure. It was git get add and the."
                    },
                    {
                      "speaker": "(1.45s - 1.49s) Suchi Dhir",
                      "line": "Name of the folder. Slash, star."
                    },
                    {
                      "speaker": "(1.51s - 1.55s) Isaac PANG",
                      "line": "Is it slash week six like that?"
                    },
                    {
                      "speaker": "(1.56s - 1.64s) Suchi Dhir",
                      "line": "No, git add week six and then slash and star."
                    },
                    {
                      "speaker": "(1.68s - 1.69s) Isaac PANG",
                      "line": "Like that?"
                    },
                    {
                      "speaker": "(1.71s - 1.72s) Suchi Dhir",
                      "line": "Yes."
                    },
                    {
                      "speaker": "(1.77s - 1.79s) Isaac PANG",
                      "line": "Oh, okay."
                    },
                    {
                      "speaker": "(1.79s - 1.81s) Suchi Dhir",
                      "line": "And then git commit."
                    },
                    {
                      "speaker": "(1.82s - 1.84s) Isaac PANG",
                      "line": "Yeah, that's."
                    },
                    {
                      "speaker": "(1.89s - 1.98s) Suchi Dhir",
                      "line": "Hyphen m. No, hyphen m. M for."
                    },
                    {
                      "speaker": "(2.01s - 2.05s) Isaac PANG",
                      "line": "Do I write the like adding script?"
                    },
                    {
                      "speaker": "(2.06s - 2.34s) Suchi Dhir",
                      "line": "Yes, yes, some message. Okay, it says, have you been uploading your work from, from this command prompt?"
                    },
                    {
                      "speaker": "(2.35s - 2.44s) Isaac PANG",
                      "line": "No, I've been doing it from, from my virtual machine here."
                    },
                    {
                      "speaker": "(2.44s - 2.64s) Suchi Dhir",
                      "line": "Yeah, it's not happening because you have not set your git config, username, email address. All those things have not been set here. Is it possible for you to do it from Azure lab?"
                    },
                    {
                      "speaker": "(2.66s - 2.68s) Isaac PANG",
                      "line": "From what, sir?"
                    },
                    {
                      "speaker": "(2.68s - 2.96s) Suchi Dhir",
                      "line": "From Azure lab itself. Can you do it from Azure lab, this here? Yes, from the terminal and not from the, not from, not from the visual studio code window?"
                    },
                    {
                      "speaker": "(3.02s - 3.11s) Isaac PANG",
                      "line": "I don't think it would, I tried from this and it didn't seem like my week six stuff wasn't in here."
                    },
                    {
                      "speaker": "(3.11s - 3.2s) Suchi Dhir",
                      "line": "So that you have to download week six, work has to be here."
                    },
                    {
                      "speaker": "(3.22s - 3.43s) Isaac PANG",
                      "line": "Yeah, okay. Yeah, I'm in like the week six folder that I created a while ago."
                    },
                    {
                      "speaker": "(3.44s - 3.49s) Suchi Dhir",
                      "line": "Okay, can I just say lsl in."
                    },
                    {
                      "speaker": "(3.49s - 3.62s) Isaac PANG",
                      "line": "Week six and I have no content in it? This is a, this is like an empty week six folder I created back in week three, I think."
                    },
                    {
                      "speaker": "(3.62s - 3.72s) Suchi Dhir",
                      "line": "So you will have to copy the files here from your windows."
                    },
                    {
                      "speaker": "(3.73s - 3.79s) Isaac PANG",
                      "line": "Yeah, um, do you know, I'm not actually entirely sure how to do that."
                    },
                    {
                      "speaker": "(3.81s - 3.98s) Suchi Dhir",
                      "line": "You'll have to upload it, I guess, because I don't know whether you will be able to copy directly from, you know, windows. Do you have copy pasting from windows and virtual machine? Is it?"
                    },
                    {
                      "speaker": "(3.98s - 4.27s) Isaac PANG",
                      "line": "Yeah, yeah, I do, I might, what I might do is just copy and paste all the scripts from week six from my visual code in windows, save it to a visual code in Kali, Linux in here, and then save that to the scripts in week six."
                    },
                    {
                      "speaker": "(4.29s - 4.33s) Suchi Dhir",
                      "line": "Yeah, you can do that page if possible."
                    },
                    {
                      "speaker": "(4.35s - 4.53s) Isaac PANG",
                      "line": "Yeah, that's why, but the reason I was doing it in here was because that's what the instructions were. They wanted to do it through the Windows command."
                    },
                    {
                      "speaker": "(4.54s - 5.12s) Suchi Dhir",
                      "line": "Okay, so if you want to do, then you will have to run this git config command, which it is saying because you have not configured your git repository in Windows. It is configured, it is configured in a shared lab. So you have to do some of the configurations over here. So if you want to do it, you can just run these commands. Get config global user email. Do you see the error which it gives you? It says you have to run this command git config user dot email and your email address. If you want, you can run these commands."
                    },
                    {
                      "speaker": "(5.13s - 5.19s) Isaac PANG",
                      "line": "I might as well user dot email."
                    },
                    {
                      "speaker": "(5.2s - 5.23s) Suchi Dhir",
                      "line": "No, first you have to write user dot email."
                    },
                    {
                      "speaker": "(5.23s - 5.25s) Isaac PANG",
                      "line": "Oh, you do?"
                    },
                    {
                      "speaker": "(5.25s - 5.32s) Suchi Dhir",
                      "line": "Yes. And then you have to write your email address."
                    },
                    {
                      "speaker": "(5.35s - 5.39s) Isaac PANG",
                      "line": "In the double quote."
                    },
                    {
                      "speaker": "(5.4s - 5.73s) Suchi Dhir",
                      "line": "Yes, enter. And the same thing is with your user dot name. After this, please run git remote command. We will see whether remote repository is set or not. You didn't write global correctly."
                    },
                    {
                      "speaker": "(5.74s - 5.76s) Isaac PANG",
                      "line": "I didn't. Okay."
                    },
                    {
                      "speaker": "(5.97s - 6.08s) Suchi Dhir",
                      "line": "Okay, now can you just simply type git remote git space remote."
                    },
                    {
                      "speaker": "(6.09s - 6.1s) Isaac PANG",
                      "line": "Yeah."
                    },
                    {
                      "speaker": "(6.11s - 6.31s) Suchi Dhir",
                      "line": "Enter origin git. Okay, so which means that it is set over here. Now can you again execute the command."
                    },
                    {
                      "speaker": "(6.31s - 6.37s) Isaac PANG",
                      "line": "Git commit, git commit, or git get."
                    },
                    {
                      "speaker": "(6.37s - 6.46s) Suchi Dhir",
                      "line": "Add git commit, git commit space, hyphen m and that command."
                    },
                    {
                      "speaker": "(6.53s - 6.55s) Isaac PANG",
                      "line": "Like that."
                    },
                    {
                      "speaker": "(6.57s - 6.59s) Suchi Dhir",
                      "line": "Yes."
                    },
                    {
                      "speaker": "(6.66s - 6.74s) Isaac PANG",
                      "line": "Hmm. I think it's adding."
                    },
                    {
                      "speaker": "(6.76s - 6.8s) Suchi Dhir",
                      "line": "Yes. Something it's doing. Let's see."
                    },
                    {
                      "speaker": "(6.8s - 6.83s) Isaac PANG",
                      "line": "It's adding, it's adding everything."
                    },
                    {
                      "speaker": "(6.83s - 7.79s) Suchi Dhir",
                      "line": "Yeah. Now can you just say git push u origin main ma I n. Yes. You have to add your username and token. I think rejected main fetch. Okay that's, that's a problem because you're not pushing it from here. No, it will cause some errors. Okay, just try to run git pull command git space pull origin main and entertained. Okay, now what it says please move or remove them. Yeah, because it's not able to find these files. It's not there in your local repository."
                    },
                    {
                      "speaker": "(7.8s - 7.8s) Isaac PANG",
                      "line": "No."
                    },
                    {
                      "speaker": "(7.8s - 7.84s) Suchi Dhir",
                      "line": "Do you have these files in your local repository?"
                    },
                    {
                      "speaker": "(7.84s - 7.87s) Isaac PANG",
                      "line": "No, I only have them in my virtual machine."
                    },
                    {
                      "speaker": "(7.87s - 7.91s) Suchi Dhir",
                      "line": "Then you'll not be able to push from here."
                    },
                    {
                      "speaker": "(7.91s - 8.03s) Isaac PANG",
                      "line": "Yeah, yeah, that's fine. What I'll do is I'll copy all the scripts my to, to this here and then I'll just push them from here."
                    },
                    {
                      "speaker": "(8.03s - 8.11s) Suchi Dhir",
                      "line": "When you're pushing your local report and remote repository have to be same."
                    },
                    {
                      "speaker": "(8.12s - 8.12s) Isaac PANG",
                      "line": "Yeah."
                    },
                    {
                      "speaker": "(8.12s - 8.2s) Suchi Dhir",
                      "line": "You cannot push it like that. So it's not possible if that would be more work."
                    },
                    {
                      "speaker": "(8.2s - 8.28s) Isaac PANG",
                      "line": "Is that, yeah, that's fine. I'll sort that out."
                    },
                    {
                      "speaker": "(8.3s - 8.42s) Suchi Dhir",
                      "line": "Okay, great. And please do share your report with me if you want to share my feedback."
                    },
                    {
                      "speaker": "(8.42s - 8.44s) Isaac PANG",
                      "line": "Sure, I can."
                    },
                    {
                      "speaker": "(8.44s - 8.7s) Suchi Dhir",
                      "line": "Yes. And for the video is that you have to just record. You know, you have to run your script and you have to record, and you have to show that all the menu options are working correctly."
                    },
                    {
                      "speaker": "(8.71s - 8.8s) Isaac PANG",
                      "line": "So I just kind of like, go through each option and then, like, show them all working and stuff?"
                    },
                    {
                      "speaker": "(8.8s - 8.83s) Suchi Dhir",
                      "line": "Yes, that's what you have to do."
                    },
                    {
                      "speaker": "(8.84s - 8.89s) Isaac PANG",
                      "line": "Sure. Great. No problem."
                    },
                    {
                      "speaker": "(8.89s - 8.93s) Suchi Dhir",
                      "line": "That's great. Do you have any, please?"
                    },
                    {
                      "speaker": "(8.94s - 9.2s) Isaac PANG",
                      "line": "Um, no, I think that's completely fine. Um, I'll just, I'll fix up the portfolio stuff tomorrow, and I'll record my stuff later tomorrow probably as well, and submit it. I'll send you my report, though, after this call, so you can maybe have a look at that."
                    },
                    {
                      "speaker": "(9.21s - 9.3s) Suchi Dhir",
                      "line": "Sure, I'll do that. So this will be the last call. Uh, is that because this is the final week?"
                    },
                    {
                      "speaker": "(9.3s - 9.31s) Isaac PANG",
                      "line": "Yeah, sure."
                    },
                    {
                      "speaker": "(9.31s - 9.42s) Suchi Dhir",
                      "line": "All the best. All the best to you. And just, if you have any other queries, you can just."
                    },
                    {
                      "speaker": "(9.43s - 9.5s) Isaac PANG",
                      "line": "Yeah, of course. Yeah. Thank you very much for your help. You've been very helpful this semester."
                    },
                    {
                      "speaker": "(9.5s - 9.53s) Suchi Dhir",
                      "line": "You're welcome. Bye bye. Take care."
                    },
                    {
                      "speaker": "(9.53s - 9.55s) Isaac PANG",
                      "line": "Cool. Thank you. See you later."
                    },
                    {
                      "speaker": "(9.56s - 9.56s) Suchi Dhir",
                      "line": "Bye."
                    }
                  ],
                  "date": "2023-02-23T09:42:32.204584Z"
                }
              ],
            "sms": {
                "2024-08-20": [
                    {
                        "from_student": false,
                        "message": "Yes, it is uploaded now. Please do write to Dr Ahmed. ",
                        "time": "11:53:30.851552"
                    },
                    {
                        "from_student": true,
                        "message": "It says it is on my end ",
                        "time": "10:21:21.996827"
                    },
                    {
                        "from_student": true,
                        "message": "Can you check if it's uploaded now please? ",
                        "time": "10:21:14.800262"
                    },
                    {
                        "from_student": true,
                        "message": "Ok. I have evidence of the video being downloaded to my web browser on Aug 15. I will send this to you two now via email and upload it",
                        "time": "10:15:09.052066"
                    },
                    {
                        "from_student": false,
                        "message": "Otherwise, it may affect your grades. ",
                        "time": "10:08:35.038487"
                    },
                    {
                        "from_student": false,
                        "message": "If you have any message that proves that you have uploaded it on Thursday, please share it with Dr Ahmed, and me.",
                        "time": "10:08:07.252680"
                    },
                    {
                        "from_student": true,
                        "message": "Ok for some reason it must not have uploaded. I'm going to reupload it now. I hope you won't take any marks away ",
                        "time": "09:59:36.417502"
                    },
                    {
                        "from_student": true,
                        "message": "I submitted it on Thursday I think last week ",
                        "time": "09:45:14.783464"
                    },
                    {
                        "from_student": true,
                        "message": "Hi Shuchi, I did submit it. I will check again but I made sure I submitted it ",
                        "time": "09:45:06.179917"
                    },
                    {
                        "from_student": false,
                        "message": "Hi, I noticed that you haven't submitted your assignment. Is there a reason for the delay? Please let me know if you need any assistance.",
                        "time": "09:26:15.542252"
                    }
                ],
                "2024-08-11": [
                    {
                        "from_student": false,
                        "message": "Hi Isaac,\nGood to know that you have sorted the issue out. ",
                        "time": "07:56:10.854098"
                    },
                    {
                        "from_student": true,
                        "message": "Actually I think have sorted it out, thanks anyway ",
                        "time": "04:27:12.301204"
                    },
                    {
                        "from_student": true,
                        "message": "Hi Shuchi, sorry to message you again. I am looking through the logs in wire shark, however, there don't seem to be any ping requests (ICMP) or SSH connections logged...I'm not too sure what I'm doing wrong and was hoping for some further guidance. Thanks ",
                        "time": "03:31:57.507744"
                    }
                ],
                "2024-08-09": [
                    {
                        "from_student": false,
                        "message": "Yes, 10 am on Sunday. ",
                        "time": "12:34:52.277344"
                    },
                    {
                        "from_student": true,
                        "message": "Ok, Sunday at 10?",
                        "time": "12:33:45.262431"
                    },
                    {
                        "from_student": false,
                        "message": "Sure, no worries. Let's connect on Sunday morning. ",
                        "time": "12:08:22.867951"
                    },
                    {
                        "from_student": true,
                        "message": "Ah I unfortunately have work all day tomorrow...I could do Sunday ",
                        "time": "11:23:27.784865"
                    },
                    {
                        "from_student": false,
                        "message": "Hi Isaac,\nCan we connect tomorrow morning at 10?",
                        "time": "11:22:53.966919"
                    },
                    {
                        "from_student": true,
                        "message": "Hi Shuchi, these rules aren't really generating alerts when I SSH into the Ubuntu from the host network...I'm also getting weird \"Port scan detected\" alerts for an 8.8.8.8 DNS (Google DNS?). Could you please provide some guidance. Thanks !",
                        "time": "11:17:45.376635"
                    },
                    {
                        "from_student": false,
                        "message": "Hi Isaac,\nSorry, I missed replying to your message. It means logging into a file. ",
                        "time": "06:14:10.756565"
                    }
                ],
                "2024-08-08": [
                    {
                        "from_student": true,
                        "message": "Hi Shuchi, for step 2: configuring snort, it says all activities detected by the IDS must be logged. Does this mean logging to the console or logging to a file? ",
                        "time": "04:12:08.638045"
                    }
                ],
                "2024-07-31": [
                    {
                        "from_student": true,
                        "message": "Yes can do now ",
                        "time": "05:56:05.477476"
                    },
                    {
                        "from_student": false,
                        "message": "No worries! Can we connect now?",
                        "time": "05:35:13.612956"
                    },
                    {
                        "from_student": true,
                        "message": "Okay no problems. Sorry I was just getting home ",
                        "time": "04:18:18.338348"
                    },
                    {
                        "from_student": false,
                        "message": "Hi, I will be driving now, so let's connect at 1 PM. Hope that will be fine. ",
                        "time": "04:07:52.228259"
                    },
                    {
                        "from_student": false,
                        "message": "Hi Isaac,\nLet me know once you are available to take the call. ",
                        "time": "04:01:44.204279"
                    },
                    {
                        "from_student": false,
                        "message": "Sure, I can do so. ",
                        "time": "02:31:03.582312"
                    },
                    {
                        "from_student": true,
                        "message": "Hi Shuchi, I'm actually out at the moment and can't take a call. Any chance of doing so at 12pm instead?",
                        "time": "02:16:07.205496"
                    }
                ],
                "2024-07-24": [
                    {
                        "from_student": false,
                        "message": "sure",
                        "time": "02:02:42.022521"
                    },
                    {
                        "from_student": true,
                        "message": "Hi Shuchi, could we call at 10:30? ",
                        "time": "01:52:47.783093"
                    }
                ],
                "2024-07-20": [
                    {
                        "from_student": false,
                        "message": "Thanks! Speak to you then. ",
                        "time": "08:09:37.239129"
                    },
                    {
                        "from_student": true,
                        "message": "Sure ",
                        "time": "07:31:01.102871"
                    },
                    {
                        "from_student": false,
                        "message": "Sure, Isaac. Would you be available at 4:30 PM?",
                        "time": "07:09:17.492046"
                    },
                    {
                        "from_student": true,
                        "message": "Hi Shuchi, could we call today to discuss your feedback on my draft? ",
                        "time": "02:08:37.703844"
                    }
                ],
                "2024-07-18": [
                    {
                        "from_student": true,
                        "message": "Thanks ",
                        "time": "10:26:01.562680"
                    },
                    {
                        "from_student": false,
                        "message": "Thank you, Isaac. Give me some time, I will check your work and share my feedback. ",
                        "time": "07:35:07.915762"
                    },
                    {
                        "from_student": true,
                        "message": "Hi Shuchi, I have sent you a copy of my assignment via email. I'd appreciate any feedback you have on it so far. Thanks!",
                        "time": "02:05:38.047247"
                    }
                ],
                "2024-07-15": [
                    {
                        "from_student": false,
                        "message": "Thats great! Thank you for confirming. ",
                        "time": "02:34:45.330357"
                    },
                    {
                        "from_student": true,
                        "message": "All good, just found it",
                        "time": "00:25:14.393944"
                    },
                    {
                        "from_student": true,
                        "message": "Hi Shuchi, I'm trying to complete exercise 3.7 related to cowrie. However, the instructions say we needed to complete the \"installation and configuration workshop\" before we can do this one but there is no such workshop. ",
                        "time": "00:23:22.364807"
                    }
                ],
                "2024-07-10": [
                    {
                        "from_student": false,
                        "message": "Thank you!",
                        "time": "08:27:29.967451"
                    },
                    {
                        "from_student": true,
                        "message": "Sure, 10 works ",
                        "time": "08:26:17.256308"
                    },
                    {
                        "from_student": false,
                        "message": "Hi Isaac, Can we speak tomorrow morning?",
                        "time": "06:44:45.572474"
                    },
                    {
                        "from_student": false,
                        "message": "Sorry, I missed that. Can we connect tomorrow morning at 10?",
                        "time": "05:37:40.364770"
                    },
                    {
                        "from_student": true,
                        "message": "Hi Shuchi, I thought we organised 10am for Wednesday's ",
                        "time": "05:33:38.992415"
                    },
                    {
                        "from_student": false,
                        "message": "Hi,\nHope you are doing well with your studies. Please share your availability so that I can connect with you for a discussion on the unit.\n",
                        "time": "05:30:35.468938"
                    }
                ],
                "2024-07-01": [
                    {
                        "from_student": false,
                        "message": "Hi Isaac - This is Shuchi, your ECU Online Facilitator for the CYB6003 unit. You can connect with me via email at s.dhir@ecu.edu.au or text me on this number. Please check your ECU email for more information.",
                        "time": "06:57:26.247768"
                    }
                ]
            },
            "mail": [
                {
                    "sent": false,
                    "subject": "Welcome to Week 6!",
                    "body": "Hi,\r\n\r\nWelcome to Week 6!\r\n\r\nQuick Reminder:  Assessment 3  is due for submission at the end of this week by the 19th of August 2024, till 02:00 PM (AWST).\r\n\r\nThis week focuses on the concepts of the deployment of Wireless LAN and its security requirement",
                    "date": "2024-08-13T05:04:27.297846Z"
                },
                {
                    "sent": false,
                    "subject": "Re: Assignment 3: Network Security ",
                    "body": "Yes, Isaac. The iptables logs are stored in /var/log/syslog, use tail to view the logs. Further, you can use the grep command to look for specific log entries.\r\nAlso, you can view /var/log/messages\r\n\r\nRegards,\r\nDr Shuchi DHIR\r\nOnline Facilitator – Edith C",
                    "date": "2024-08-12T05:21:37.569870Z"
                },
                {
                    "sent": true,
                    "subject": "Re: Assignment 3: Network Security ",
                    "body": "Are iptables logs stored in /car/log/syslog? I’m using the command: ‘tail syslog’ to try and see them but all I can see is lots of blocked traffic notifications and no ssh traffic\r\n\r\nThanks,\r\n\r\nIsaac.\r\n\r\nGet Outlook for iOS\r\n______________________________",
                    "date": "2024-08-12T03:42:31.478699Z"
                },
                {
                    "sent": false,
                    "subject": "Re: Assignment 3: Network Security ",
                    "body": "Please change the following to:\r\n\r\nalert tcp any any -> 192.168.0.103 2233 (msg:”SSH Connection detected”; sid:1000001: rev1;)\r\n\r\nspecifying towards the ssh server.\r\n\r\n\r\nRegards,\r\nDr Shuchi DHIR\r\nOnline Facilitator – Edith Cowan University\r\nT: +6148003434",
                    "date": "2024-08-12T03:31:10.127217Z"
                },
                {
                    "sent": false,
                    "subject": "Re: Assignment 3: Network Security ",
                    "body": "Hi\r\n\r\nThe following logging rule is not restricted to a specific IP. I would suggest that you change the following rule:\r\n\r\n-A INPUT -p tcp —dport 2233 -j LOG —log-prefix “SSH TRAFFIC > “\r\n\r\n\r\nFor example, like this:\r\n\r\nsudo iptables -A INPUT -p tcp --dpo",
                    "date": "2024-08-12T03:29:52.054970Z"
                },
                {
                    "sent": true,
                    "subject": "Re: Assignment 3: Network Security ",
                    "body": "Also, I have changed the snort rule that detects SSH connections to the following as I get better results:\r\n\r\nalert tcp any any -> any 2233 (msg:”SSH Connection detected”; sid:1000001: rev1;)\r\n\r\nThe previous one wasn’t logging the SSH connections at all b",
                    "date": "2024-08-12T03:28:48.049263Z"
                },
                {
                    "sent": true,
                    "subject": "Re: Assignment 3: Network Security ",
                    "body": "Sure,\r\n\r\nAllow incoming SSH traffic only:\r\n-A INPUT -p tcp —dport 2233 -j ACCEPT\r\n\r\nRestrict traffic to whitelisted IP\r\n-A INPUT -p tcp —dport 2233 -s 192.168.0.1 -j ACCEPT\r\n\r\n-A INPUT -p tcp —dport 2233 -j LOG —log-prefix “SSH TRAFFIC > “\r\n\r\nBlock all ot",
                    "date": "2024-08-12T03:16:15.212372Z"
                },
                {
                    "sent": false,
                    "subject": "Re: Assignment 3: Network Security ",
                    "body": "Can you share the rules with me here, rather than the screenshot?\r\n\r\n\r\nRegards,\r\nDr Shuchi DHIR\r\nOnline Facilitator – Edith Cowan University\r\nT: +61480034342\r\nE: s.dhir@ecu.edu.au\r\n\r\nFrom: Isaac PANG <IPANG@our.ecu.edu.au>\r\nDate: Monday, 12 August 2024 at",
                    "date": "2024-08-12T03:11:04.934043Z"
                },
                {
                    "sent": true,
                    "subject": "Re: Assignment 3: Network Security ",
                    "body": "Hi Shuchi,\r\n\r\nOk, I will make those changes. I think I’m having some trouble with my iptables rules. The SSH connections don’t seem to be getting logged and there are a lot of blocked traffic notifications. I’m not sure how to remedy this.\r\n\r\nThanks for y",
                    "date": "2024-08-12T03:09:46.870604Z"
                },
                {
                    "sent": false,
                    "subject": "Re: For todays call ",
                    "body": "/var/log/snort/\r\n\r\nRegards,\r\nDr Shuchi DHIR\r\nOnline Facilitator – Edith Cowan University\r\nT: +61480034342\r\nE: s.dhir@ecu.edu.au\r\n\r\nFrom: Isaac PANG <IPANG@our.ecu.edu.au>\r\nDate: Sunday, 11 August 2024 at 7:34 AM\r\nTo: Shuchi DHIR <s.dhir@ecu.edu.au>\r\nSubje",
                    "date": "2024-08-11T02:11:38.289003Z"
                },
                {
                    "sent": true,
                    "subject": "Accepted: Phone Call: Isaac PANG & Shuchi Dhir",
                    "body": "",
                    "date": "2024-08-09T12:52:48.826619Z"
                },
                {
                    "sent": false,
                    "subject": "Phone Call: Isaac PANG & Shuchi Dhir",
                    "body": "Shuchi Dhir will call Isaac PANG on their phone. Kindly accept this calendar invitation.",
                    "date": "2024-08-09T12:35:15.805921Z"
                },
                {
                    "sent": true,
                    "subject": "Declined: Phone Call: Isaac PANG & Shuchi Dhir",
                    "body": "",
                    "date": "2024-08-09T12:33:38.508849Z"
                },
                {
                    "sent": true,
                    "subject": "Accepted: Phone Call: Isaac PANG & Shuchi Dhir",
                    "body": "",
                    "date": "2024-08-09T12:33:16.771708Z"
                },
                {
                    "sent": false,
                    "subject": "Phone Call: Isaac PANG & Shuchi Dhir",
                    "body": "Shuchi Dhir will call Isaac PANG on their phone. Kindly accept this calendar invitation.",
                    "date": "2024-08-09T12:10:20.174821Z"
                },
                {
                    "sent": false,
                    "subject": "Phone Call: Isaac PANG & Shuchi Dhir",
                    "body": "Shuchi Dhir will call Isaac PANG on their phone. Kindly accept this calendar invitation.",
                    "date": "2024-08-09T12:10:07.893172Z"
                },
                {
                    "sent": false,
                    "subject": "Phone Call: Isaac PANG & Shuchi Dhir",
                    "body": "Shuchi Dhir will call Isaac PANG on their phone. Kindly accept this calendar invitation.",
                    "date": "2024-08-07T02:40:44.328854Z"
                },
                {
                    "sent": true,
                    "subject": "Accepted: Phone Call: Isaac PANG & Shuchi Dhir",
                    "body": "",
                    "date": "2024-08-07T02:09:14.839354Z"
                },
                {
                    "sent": false,
                    "subject": "Welcome to Week 5!",
                    "body": "Hi,\r\n\r\n Welcome to Week 5!\r\n\r\nCongratulations on completing two assessments of the unit. I appreciate the efforts and the time you have invested in completing it. I suggest you start reviewing and organising yourself for assessment 3 which is due by the e",
                    "date": "2024-08-05T07:15:32.671641Z"
                },
                {
                    "sent": false,
                    "subject": "Phone Call: Isaac PANG & Shuchi Dhir",
                    "body": "Shuchi Dhir will call Isaac PANG on their phone. Kindly accept this calendar invitation.",
                    "date": "2024-07-31T06:05:24.263890Z"
                },
                {
                    "sent": false,
                    "subject": "Phone Call: Isaac PANG & Shuchi Dhir",
                    "body": "Shuchi Dhir will call Isaac PANG on their phone. Kindly accept this calendar invitation.",
                    "date": "2024-07-31T02:31:28.526974Z"
                },
                {
                    "sent": false,
                    "subject": "Welcome to Week 4!",
                    "body": "Hello,\r\n\r\nWelcome to Week 4!\r\n\r\nQuick Reminder: Quiz 2 is due for submission today.  Also, you have to work on assessment 2  and complete this task before 2 P.M (WST) of  5th of August 2024.\r\n\r\nThis week you will explore the network security assessment fr",
                    "date": "2024-07-29T03:19:57.176708Z"
                },
                {
                    "sent": false,
                    "subject": "Phone Call: Isaac PANG & Shuchi Dhir",
                    "body": "Shuchi Dhir will call Isaac PANG on their phone. Kindly accept this calendar invitation.",
                    "date": "2024-07-24T02:41:03.977961Z"
                },
                {
                    "sent": true,
                    "subject": "Accepted: Phone Call: Isaac PANG & Shuchi Dhir",
                    "body": "",
                    "date": "2024-07-24T02:32:40.111251Z"
                },
                {
                    "sent": false,
                    "subject": "Phone Call: Isaac PANG & Shuchi Dhir",
                    "body": "Shuchi Dhir will call Isaac PANG on their phone. Kindly accept this calendar invitation.",
                    "date": "2024-07-24T02:03:11.782178Z"
                },
                {
                    "sent": false,
                    "subject": "Re: Notes for call tomorrow",
                    "body": "No worries! Will discuss this on Wednesday.\r\n\r\nRegards,\r\nDr Shuchi DHIR\r\nOnline Facilitator – Edith Cowan University\r\nT: +61480034342\r\nE: s.dhir@ecu.edu.au\r\n\r\nFrom: Isaac PANG <IPANG@our.ecu.edu.au>\r\nDate: Monday, 22 July 2024 at 9:05 PM\r\nTo: Shuchi DHIR ",
                    "date": "2024-07-22T15:40:00.349833Z"
                },
                {
                    "sent": true,
                    "subject": "Re: Notes for call tomorrow",
                    "body": "Sorry, lost track of the days. I meant for Wednesday\r\n\r\nGet Outlook for iOS\r\n________________________________\r\nFrom: Isaac PANG\r\nSent: Monday, July 22, 2024 10:27:08 PM\r\nTo: Shuchi DHIR <s.dhir@ecu.edu.au>\r\nSubject: Notes for call tomorrow\r\n\r\nHi Shuchi,",
                    "date": "2024-07-22T15:35:08.118374Z"
                },
                {
                    "sent": false,
                    "subject": "FW: Welcome to Week 3!",
                    "body": "Apologies!\r\n\r\nI made a mistake while sharing the information about the quiz in my previous email.\r\n\r\nThe second quiz Is opening today and is due on the 29th.\r\n\r\nThe second quiz will test your knowledge of the areas of Firewalls, DMZ, IDS, SIEM, VPNs, and ",
                    "date": "2024-07-22T03:31:56.175378Z"
                },
                {
                    "sent": false,
                    "subject": "Welcome to Week 3!",
                    "body": "Hello,\r\n\r\nWelcome to Week 3!\r\n\r\nQuick reminder, Quiz 2 is due for submission today at 02:00 PM (AWST). Please complete it if you have not done so.\r\n\r\nI hope you have now started engaging with the Week 3 content and have completed the lab exercises of Week",
                    "date": "2024-07-22T02:18:19.930786Z"
                },
                {
                    "sent": false,
                    "subject": "Phone Call: Isaac PANG & Shuchi Dhir",
                    "body": "Shuchi Dhir will call Isaac PANG on their phone. Kindly accept this calendar invitation.",
                    "date": "2024-07-20T08:58:18.454124Z"
                },
                {
                    "sent": false,
                    "subject": "Phone Call: Isaac PANG & Shuchi Dhir",
                    "body": "Shuchi Dhir will call Isaac PANG on their phone. Kindly accept this calendar invitation.",
                    "date": "2024-07-20T08:09:36.745458Z"
                },
                {
                    "sent": false,
                    "subject": "Re: Assessment 2 Draft",
                    "body": "Hi Isaac,\r\n\r\nI have performed a cursory review of your work. Please find my feedback:\r\n\r\n\r\n  1.  While you have listed a few threats, try to list all threats that the network is exposed to.\r\n  2.  The justification of the ranking of the risks can be great",
                    "date": "2024-07-19T08:29:20.195881Z"
                },
                {
                    "sent": true,
                    "subject": "Assessment 2 Draft",
                    "body": "Hi Shuchi,\r\n\r\nAs discussed, please find attached a copy of my first draft for assessment 2. I would appreciate any feedback you could provide on where to improve etc.\r\n\r\nThanks for your help,\r\n\r\nIsaac.\r\n\r\nAssessment 2.docx",
                    "date": "2024-07-18T02:00:07.179647Z"
                },
                {
                    "sent": false,
                    "subject": "Welcome to Week 2!",
                    "body": "Hi,\r\n\r\nWelcome to Week 2!\r\n\r\nCongratulations on completing the Quiz 1 of the first assessment of the unit, I appreciate the efforts you have invested in completing it.\r\n\r\nThis week you will investigate two important concepts of implementing networking sec",
                    "date": "2024-07-15T07:08:49.094440Z"
                },
                {
                    "sent": false,
                    "subject": "Phone Call: Isaac PANG & Shuchi Dhir",
                    "body": "Shuchi Dhir will call Isaac PANG on their phone. Kindly accept this calendar invitation.",
                    "date": "2024-07-11T02:45:56.743286Z"
                },
                {
                    "sent": false,
                    "subject": "Phone Call: Isaac PANG & Shuchi Dhir",
                    "body": "Shuchi Dhir will call Isaac PANG on their phone. Kindly accept this calendar invitation.",
                    "date": "2024-07-10T08:51:17.656409Z"
                },
                {
                    "sent": false,
                    "subject": "Welcome to Week 1!",
                    "body": "Hi,\r\n\r\nWelcome to Week 1 of the ‘Network Security’ Unit!\r\n\r\nI hope you have started engaging with the content, and have completed the Week 0 activities. Do let me know if you need any help or have any questions.\r\n\r\nThis week, you will delve into the TCP/I",
                    "date": "2024-07-08T01:30:42.000045Z"
                },
                {
                    "sent": true,
                    "subject": "Accepted: Phone Call: Isaac PANG & Shuchi Dhir",
                    "body": "",
                    "date": "2024-07-02T09:02:16.398727Z"
                },
                {
                    "sent": false,
                    "subject": "Re: Your Online Facilitator for Network Security (CYB6003)",
                    "body": "That would be great!\r\n\r\nI have shared the invite with you.\r\n\r\nRegards,\r\nDr Shuchi DHIR\r\nOnline Facilitator – Edith Cowan University\r\nT: +61480034342\r\nE: s.dhir@ecu.edu.au\r\n\r\nFrom: Isaac PANG <IPANG@our.ecu.edu.au>\r\nDate: Tuesday, 2 July 2024 at 12:33 PM",
                    "date": "2024-07-02T07:36:20.236507Z"
                },
                {
                    "sent": false,
                    "subject": "Phone Call: Isaac PANG & Shuchi Dhir",
                    "body": "Shuchi Dhir will call Isaac PANG on their phone. Kindly accept this calendar invitation.",
                    "date": "2024-07-02T07:36:02.772869Z"
                },
                {
                    "sent": true,
                    "subject": "Re: Your Online Facilitator for Network Security (CYB6003)",
                    "body": "Hi Shuchi ,\r\n\r\nHow is tomorrow 10am?\r\n\r\nThanks,\r\n\r\nIsaac\r\n\r\nGet Outlook for iOS\r\n________________________________\r\nFrom: Shuchi DHIR <s.dhir@ecu.edu.au>\r\nSent: Monday, July 1, 2024 2:57:26 PM\r\nTo: Isaac PANG <IPANG@our.ecu.edu.au>\r\nSubject: Your Online Fa",
                    "date": "2024-07-02T07:03:08.666688Z"
                },
                {
                    "sent": false,
                    "subject": "Re:Your Online Facilitator for Network Security (CYB6003)",
                    "body": "Hi Isaac,\r\n\r\nI’d love to have a quick 10 min introductory call to help you get started with the unit. Do let me know when is a good time over the coming 1-2 days.\r\n\r\nPlease indicate your time preference using this link.\r\n\r\nThanks,\r\n\r\nShuchi Dhir\r\nOnline F",
                    "date": "2024-07-02T06:57:49.744922Z"
                },
                {
                    "sent": false,
                    "subject": "Re:Your Online Facilitator for Network Security (CYB6003)",
                    "body": "Hi Isaac,\r\n\r\nI’d love to have a quick 10 min introductory call to help you get started with the unit. Do let me know when is a good time over the coming 1-2 days.\r\n\r\nPlease indicate your time preference using this link.\r\n\r\nThanks,\r\n\r\nShuchi Dhir\r\nOnline F",
                    "date": "2024-07-02T06:57:49.719478Z"
                },
                {
                    "sent": false,
                    "subject": "Re:Your Online Facilitator for Network Security (CYB6003)",
                    "body": "Hi Isaac,\nI’d love to have a quick 10 min introductory call to help you get started with the unit. Do let me know when is a good time over the coming 1-2 days.\nPlease indicate your time preference using this link. \nThanks, \nShuchi DhirOnline Facilitator - Edith Cowan UniversityT: +61480034342 E: s.dhir@ecu.edu.auAll student communication will be recorded for security and quality purposes and collected on behalf of ECU. These communications may contain your personal information and will be maintained as per the privacy policy of ECU.",
                    "date": "2024-07-02T06:57:37.799573Z"
                },
                {
                    "sent": false,
                    "subject": "Your Online Facilitator for Network Security (CYB6003)",
                    "body": "Hi Isaac,\r\n\r\nI am Shuchi and I will be the online facilitator for your group on the Network Security unit with ECU. My role is to support you in successfully completing this unit.\r\n\r\nWhile you will see me active on the discussion boards, I am also availab",
                    "date": "2024-07-01T06:57:31.399473Z"
                },
                {
                    "sent": false,
                    "subject": "Your Online Facilitator for Network Security (CYB6003)",
                    "body": "Hi Isaac,\nI am Shuchi and I will be the online facilitator for your group on the Network Security unit with ECU. My role is to support you in successfully completing this unit.\nWhile you will see me active on the discussion boards, I am also available to you for 1-1 discussions over phone or chat. If you wish to have a direct conversation on academic content, assessments or even need study advice, feel free to send me an email or text and I will respond at the earliest. \nI am available 7 days a week and most active post 5 pm AEST. My contact details are in the signature below.  \nI would like to start with a 10-min introductory conversation with you. Please let me know when we can speak in the next few days? You could use this link to state your time preference. \nTalk to you soon,\nShuchi DhirOnline Facilitator - Edith Cowan UniversityT: +61480034342 E: s.dhir@ecu.edu.auAll student communication will be recorded for security and quality purposes and collected on behalf of ECU. These communications may contain your personal information and will be maintained as per the privacy policy of ECU.",
                    "date": "2024-07-01T06:57:26.208639Z"
                },
                {
                    "sent": false,
                    "subject": "Your Online Facilitator for the AC3 Unit at ECU Online",
                    "body": "Hi Isaac,\nI am Shuchi, and I will be the online facilitator for your group on the unit with ECU. My role is to support you in successfully completing this unit.\nWhile you will see me active on the discussion boards, I am also available to you for 1-1 discussions over phone or chat. If you wish to have a direct conversation on academic content, assessments or even need study advice, feel free to send me an email or text, and I will respond at the earliest. \nI am available 7 days a week and most active post 5 pm AEST. My contact details are in the signature below.  \nI would like to start with a 10-min introductory conversation with you. Please let me know when we can speak in the next few days. You could use this link to state your time preference. \nTalk to you soon,\nShuchi DhirOnline Facilitator - Edith Cowan UniversityT: +61480034342 E: s.dhir@ecu.edu.auAll student communication will be recorded for security and quality purposes and collected on behalf of ECU. These communications may contain your personal information and will be maintained as per the privacy policy of ECU.",
                    "date": "2023-05-03T09:18:40.659211Z"
                },
                {
                    "sent": false,
                    "subject": "Your Online Facilitator for Scripting Languages (CYB6004)",
                    "body": "Hi Isaac,\nI am Shuchi and I will be the online facilitator for your group on the Scripting Languages unit with ECU. My role is to support you in successfully completing this unit.\nWhile you will see me active on the discussion boards, I am also available to you for 1-1 discussions over phone or chat. If you wish to have a direct conversation on academic content, assessments or even need study advice, feel free to send me an email or text and I will respond at the earliest. \nI am available 7 days a week and most active post 5 pm AEDT. My contact details are in the signature below.  \nI would like to start with a 10-min introductory conversation with you. Please let me know when we can speak in the next few days? You could use this link to state your time preference. \nTalk to you soon,\nShuchi DhirOnline Facilitator - Edith Cowan UniversityT: +61480034342 E: s.dhir@ecu.edu.auAll student communication will be recorded for security and quality purposes and collected on behalf of ECU. These communications may contain your personal information and will be maintained as per the privacy policy of ECU.",
                    "date": "2023-01-10T09:34:03.024428Z"
                }
            ]
        }
    }
}




export {staticData}